/* Cart drawer. This used to sit inline in snippets/cv3-cart-drawer.liquid (about 196 KB inside every page).
   As a file, browsers download it once and reuse it. The snippet loads it at the same point as before.
   Edit the drawer's behaviour here from now on. */
  (function () {
    var root = document.querySelector('[data-cv3-cd]');
    if (!root) return;

    // CRO2610 (2026-10-12): the "G: Volume Discounts" app (window.mpb) rewrites every /cart/change.js it sees. Left
    // to itself it swaps the request's "properties" for the line's old ones plus its own tag, which undid every
    // update the cart makes to a line: the plant + pot set id and role, the paired pot's name, repotting / tray
    // yes or no. A pot added in the cart was then not tied to its plant, and no service could be added to the set.
    // The app takes a shop's own handler for those requests (mpb.custom_cart_change). This one sends what was
    // asked for, and only makes sure the app's own tags stay on the line. Without the app it does nothing.
    try {
      var mpbApp = window.mpb = window.mpb || {};
      if (!mpbApp.custom_cart_change) {
        mpbApp.custom_cart_change = function (payload) {
          try {
            var props = payload && payload.properties;
            if (props && typeof props === 'object') {
              var lines = (mpbApp.current_cart && mpbApp.current_cart.items) || [];
              var line = lines.filter(function (i) { return i.key === payload.id; })[0] || (payload.line ? lines[payload.line - 1] : null);
              var had = (line && line.properties) || {};
              ['__mpb_offer_id', '__mpb_order_offer_ignore'].forEach(function (k) {
                if (props[k] == null && had[k] != null && had[k] !== '') props[k] = had[k];
              });
            }
          } catch (e) { /* send the request as it was asked for */ }
          return payload;
        };
      }
    } catch (e) { /* the cart works without this */ }

    var els = {
      sheet:        root.querySelector('.cv3-cd__sheet'),
      count:        root.querySelector('[data-cv3-cd-count]'),
      body:         root.querySelector('[data-cv3-cd-body]'),
      loading:      root.querySelector('[data-cv3-cd-loading]'),
      items:        root.querySelector('[data-cv3-cd-items]'),
      empty:        root.querySelector('[data-cv3-cd-empty]'),
      preorderBanner: root.querySelector('[data-cv3-cd-preorder-banner]'),
      foot:         root.querySelector('[data-cv3-cd-foot]'),
      subtotal:     root.querySelector('[data-cv3-cd-subtotal]'),
      discRow:      root.querySelector('[data-cv3-cd-discount-row]'),
      discName:     root.querySelector('[data-cv3-cd-discount-name]'),
      discAmt:      root.querySelector('[data-cv3-cd-discount-amt]'),
      shipRow:      root.querySelector('[data-cv3-cd-ship-row]'),
      shipAmt:      root.querySelector('[data-cv3-cd-ship-amt]'),
      freeship:     root.querySelector('[data-cv3-cd-freeship]'),
      freeshipText: root.querySelector('[data-cv3-cd-freeship-text]'),
      freeshipFill: root.querySelector('[data-cv3-cd-freeship-fill]'),
      upsell:        root.querySelector('[data-cv3-cd-upsell]'),
      upsellAnchor:  root.querySelector('[data-cv3-cd-upsell-anchor]'),
      upsellCount:   root.querySelector('[data-cv3-cd-upsell-count]'),
      upsellStrip:   root.querySelector('[data-cv3-cd-upsell-strip]'),
      // Overlays are now body-level (moved out of the drawer) so we use
      // document.querySelector instead of root.querySelector.
      picker:       document.querySelector('[data-cv3-cd-picker]'),
      pickerTitle:  document.querySelector('[data-cv3-cd-picker-title]'),
      pickerBody:   document.querySelector('[data-cv3-cd-picker-body]'),
      pickerLoad:   document.querySelector('[data-cv3-cd-picker-loading]'),
      pickerGrid:   document.querySelector('[data-cv3-cd-picker-grid]'),
      pickerEmpty:  document.querySelector('[data-cv3-cd-picker-empty]'),
      pickerInfo:   document.querySelector('[data-cv3-cd-picker-foot-info]'),
      pickerApply:  document.querySelector('[data-cv3-cd-picker-apply]'),
      detail:       document.querySelector('[data-cv3-cd-detail]'),
      detailBody:   document.querySelector('[data-cv3-cd-detail-body]'),
      photo:        document.querySelector('[data-cv3-cd-photo]'),
      photoInput:   document.querySelector('[data-cv3-cd-photo-input]'),
      photoPreview: document.querySelector('[data-cv3-cd-photo-preview]'),
      photoEmpty:   document.querySelector('[data-cv3-cd-photo-empty]'),
      photoApply:        document.querySelector('[data-cv3-cd-photo-apply]'),
      photoPrice:        document.querySelector('[data-cv3-cd-photo-price]'),
      photoSizeLabel:    document.querySelector('[data-cv3-cd-photo-size-label]'),
      photoStatus:       document.querySelector('[data-cv3-cd-photo-status]'),
      photoDisposal:     document.querySelector('[data-cv3-cd-photo-disposal]'),
      photoDisposalChk:  document.querySelector('[data-cv3-cd-photo-disposal-check]'),
      photoDisposalHint: document.querySelector('[data-cv3-cd-photo-disposal-hint]')
    };
    var freeshipThreshold = els.freeship
      ? parseInt(els.freeship.dataset.threshold, 10) || 0
      : 0;

    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        try { return Shopify.formatMoney(cents); } catch (e) {}
      }
      try { return new Intl.NumberFormat('en-SG', { style: 'currency', currency: 'SGD' }).format(cents / 100); }
      catch (e) { return '$' + (cents / 100).toFixed(2); }
    }
    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }

    // `force: true` overrides the /cart suppression — used by the picker /
    // detail / photo overlays when triggered from inside the cart page, so
    // the overlay has a visible parent to render into. Sheet content stays
    // hidden via `is-overlay-only` so the customer only sees the overlay.
    // D1 — keep --cv3-cd-vh synced with the visual viewport so the drawer
    // shrinks when the soft keyboard rises on iOS Safari. visualViewport
    // is supported on iOS 13+ / all modern Android Chrome. Without this,
    // the drawer stays 92vh and the bottom buttons hide behind the keyboard.
    function syncVisualViewport() {
      if (!window.visualViewport) return;
      var h = window.visualViewport.height;
      // CRO2610: a height that cannot be a screen (0 while a tab is being set up, for one) would squeeze the cart
      // to nothing: without the variable the cart falls back to the full viewport height
      if (!(h >= 240)) {
        document.documentElement.style.removeProperty('--cv3-cd-vh-full');
        document.documentElement.style.removeProperty('--cv3-cd-vh');
        return;
      }
      // Full-height drawer — set the FULL viewport variable so dvh fallback
      // shrinks with the iOS keyboard. The old 92% variant was kept for
      // legacy non-full layouts; full now wins on mobile.
      document.documentElement.style.setProperty(
        '--cv3-cd-vh-full',
        Math.round(h) + 'px'
      );
      // Legacy 92% var still emitted for any code that may read it.
      document.documentElement.style.setProperty(
        '--cv3-cd-vh',
        Math.round(h * 0.92) + 'px'
      );
    }
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncVisualViewport);
      window.visualViewport.addEventListener('scroll', syncVisualViewport);
      syncVisualViewport();
    }

    function open(opts) {
      opts = opts || {};
      // Suppress on /cart — opening the drawer over the cart page makes
      // no sense (the cart contents are already on the page). All call
      // sites (clicking cart icon, AMP_API.OPEN_CART, programmatic) become
      // no-ops here unless explicitly forced.
      try {
        if (!opts.force && window.location && window.location.pathname &&
            /^\/cart(\/|$|\?)/.test(window.location.pathname)) {
          return;
        }
      } catch (e) { /* fall through to normal open on detection failure */ }
      // Refresh the viewport-height var on open so a portrait/landscape
      // rotation between drawer closes doesn't leave us with stale value.
      syncVisualViewport();
      // D2 — iOS scroll lock that ACTUALLY preserves position. Plain
      // `overflow: hidden` on body is unreliable on iOS Safari (the page
      // jumps to top or to a random offset when the drawer closes). The
      // position:fixed + negative-top trick locks the body in place AND
      // remembers the scroll Y for restore. Set BEFORE adding cv3-cd-open
      // so the body class's overflow:hidden takes effect on a stable body.
      // CRO2610: a page change still fading would sit on top of the cart; end it first (snippets/cro2610-instant.liquid)
      try { if (window.cro2610EndFade) window.cro2610EndFade(); } catch (e) {}
      lockBodyScroll();
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cv3-cd-open');
      watchOpen();
      // If we've already painted from the seed (or a prior refresh), skip the
      // synchronous /cart.js wait — show what we have, then refresh in the
      // background. First-open feels instant.
      if (lastCart) {
        setLoading(false);
        refresh().then(warmCaches);
      } else {
        refresh().then(warmCaches);
      }
      setTimeout(function () { try { els.sheet && els.sheet.focus({ preventScroll: true }); } catch (e) { els.sheet && els.sheet.focus(); } }, 50);
    }

    // Prefetch the pot collections + recommendations the customer is likely
    // to hit (Change pot, upsell strip). Tiny window.requestIdleCallback if
    // available so we don't compete with the open animation; otherwise a
    // 250 ms setTimeout. Each fetch already feeds the same cache the user-
    // initiated path uses, so the click is instant on warmed entries.
    var cachesWarmed = false;
    function warmCaches() {
      if (cachesWarmed || !lastCart) return;
      cachesWarmed = true;
      var run = function () {
        // 1. Unique pot collections across the cart's potted-plant lines.
        var handles = {};
        (lastCart.items || []).forEach(function (it) {
          var h = it.properties && it.properties._io_pot_collection;
          if (h && !potCollectionCache[h]) handles[h] = true;
        });
        Object.keys(handles).forEach(function (h) {
          fetch('/collections/' + encodeURIComponent(h) + '/products.json?limit=50', {
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' }
          })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var products = (data && data.products) || [];
              function toCents(p) {
                if (typeof p === 'number') return p > 1000 ? p : Math.round(p * 100);
                if (typeof p === 'string' && p) return Math.round(parseFloat(p) * 100);
                return 0;
              }
              var pots = products.map(function (p) {
                var availVariants = (p.variants || []).filter(function (v) { return v.available !== false; });
                if (!availVariants.length) return null;
                return {
                  product_id: p.id, product_handle: p.handle, title: p.title,
                  image: (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '',
                  variants: availVariants.map(function (v) {
                    return {
                      variant_id: v.id, title: v.title,
                      option1: v.option1, option2: v.option2, option3: v.option3,
                      price: toCents(v.price),
                      image: (v.featured_image && v.featured_image.src) || ''
                    };
                  })
                };
              }).filter(Boolean);
              potCollectionCache[h] = pots;
            })
            .catch(function () {});
        });
      };
      if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 1500 });
      else setTimeout(run, 250);
    }
    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cv3-cd-open');
      // D2 — restore body position AFTER removing cv3-cd-open so the
      // overflow:hidden has lifted before we snap scrollY back.
      unlockBodyScroll();
      // Snap overlays shut so the next open starts clean.
      if (els.picker) { els.picker.classList.remove('is-open'); els.picker.hidden = true; }
      if (els.detail) { els.detail.classList.remove('is-open'); els.detail.hidden = true; }
    }

       // Safety net — if anything other than close() strips `is-open` (a
    // third-party overlay, an app that closes "all drawers", a stray DOM
    // write), the body stays position:fixed and the page is unscrollable
    // until a reload. Watch the root class and run the real teardown.
    (function () {
      if (!root || !window.MutationObserver) return;
      new MutationObserver(function () {
        if (!root.classList.contains('is-open') &&
            document.body.classList.contains('cv3-cd-open')) {
          close();
        }
      }).observe(root, { attributes: true, attributeFilter: ['class'] });
    })();

    // CRO2610 — a cart that was asked to open must be on screen. Reported from an iPhone: the page locked as though
    // the cart were open, with no cart in view. So shortly after opening, the cart's box is measured; if it is not
    // in the screen (hidden, no size, or off to one side) it is repaired on the spot: first the page is held without
    // pinning the body, then the cart is placed in the page itself. Only if it is still out of view is the page let
    // go and the shopper sent to the cart page. Other layers lying on top of the cart (the "Added to cart" sheet,
    // an app's popup) do not count: only the cart's own box is looked at.
    var openChecks = 0;
    function cartSeen() {
      try {
        var cs = window.getComputedStyle(root);
        var r = els.sheet ? els.sheet.getBoundingClientRect() : null;
        var vw = window.innerWidth || document.documentElement.clientWidth || 0;
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        if (cs.display === 'none' || cs.visibility === 'hidden') return { ok: false, why: 'hidden by a style' };
        if (!r) return { ok: false, why: 'no cart panel' };
        if (vw && vh) {
          var w = Math.min(r.right, vw) - Math.max(r.left, 0), h = Math.min(r.bottom, vh) - Math.max(r.top, 0);
          if (w < 120 || h < 160) return { ok: false, why: 'panel at ' + Math.round(r.left) + ',' + Math.round(r.top) + ' size ' + Math.round(r.width) + 'x' + Math.round(r.height) + ' in a ' + vw + 'x' + vh + ' screen, page at ' + Math.round(window.scrollY || 0) };
        }
      } catch (e) {}
      return { ok: true, why: '' };
    }
    function cartNote(msg) {
      try { if (window.__twLog) window.__twLog(msg); } catch (e) {}
      try { window.localStorage.setItem('cv3CartIssue', new Date().toISOString().slice(0, 16) + ' ' + msg); } catch (e) {}
      try { console.warn('[cv3-cart-drawer] ' + msg); } catch (e) {}
    }
    // step 2 of the repair puts the cart in the page itself; undone when the cart closes
    var PLACED = ['position', 'top', 'left', 'right', 'bottom', 'height'];
    function unplaceCart() {
      if (!root.__cv3Placed) return;
      root.__cv3Placed = false;
      PLACED.forEach(function (k) { root.style.removeProperty(k); });
      if (els.sheet) ['height', 'max-height', 'transform'].forEach(function (k) { els.sheet.style.removeProperty(k); });
    }
    function watchOpen() {
      var mine = ++openChecks;
      function still() { return mine === openChecks && root.classList.contains('is-open'); }
      function giveUp(why) {
        cartNote('CART NOT ON SCREEN (' + why + '): page released, going to the cart page');
        close();
        try { window.location.assign(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart'); } catch (e) {}
      }
      function placeInPage(why) {
        // 2. put the cart in the page at the spot being looked at, with the screen's own size
        try {
          root.style.setProperty('position', 'absolute', 'important');
          root.style.setProperty('top', (window.scrollY || window.pageYOffset || 0) + 'px', 'important');
          root.style.setProperty('left', '0', 'important');
          root.style.setProperty('right', '0', 'important');
          root.style.setProperty('bottom', 'auto', 'important');
          root.style.setProperty('height', (window.innerHeight || 640) + 'px', 'important');
          els.sheet.style.setProperty('height', '100%', 'important');
          els.sheet.style.setProperty('max-height', 'none', 'important');
          els.sheet.style.setProperty('transform', 'none', 'important');
          root.__cv3Placed = true;
        } catch (e) {}
        cartNote('cart still not on screen (' + why + '): placed in the page instead');
        setTimeout(function () {
          if (!still()) return;
          var s3 = cartSeen();
          if (!s3.ok) giveUp(s3.why);
        }, 350);
      }
      setTimeout(function () {
        if (!still()) return;
        var s = cartSeen();
        if (s.ok) return;
        // 1. a pinned body is the usual reason: hold the page the other way, remember it for this browser, look again
        var b = document.body;
        if (b.style.position === 'fixed') {
          var y = bodyScrollLockY || 0;
          b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
          window.scrollTo(0, y);
          lockMode = 'overflow';
          try { window.localStorage.setItem('cv3Lock', 'overflow'); } catch (e) {}
          cartNote('cart not on screen after opening (' + s.why + '): page now held without pinning');
          setTimeout(function () {
            if (!still()) return;
            var s2 = cartSeen();
            if (!s2.ok) placeInPage(s2.why);
          }, 350);
          return;
        }
        placeInPage(s.why);
      }, 800);
    }
    // The page must never stay locked without a cart in view: checked again when a page comes back from the
    // browser's memory (Back / Forward) and when the tab is returned to.
    function releaseIfOrphaned() {
      if (!root.classList.contains('is-open') && (bodyScrollLockY !== null || document.body.classList.contains('cv3-cd-open'))) close();
    }
    window.addEventListener('pageshow', releaseIfOrphaned);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) releaseIfOrphaned(); });

    // D2 — iOS-safe body scroll lock. lockBodyScroll() captures scrollY
    // and pins the body in place with position:fixed; unlockBodyScroll()
    // releases and scrolls back. No-ops if already locked / already unlocked
    // (so a stray double-close can't accidentally jump the page).
    // CRO2610 — how the page is held still while the cart is open:
    //   'fixed'     the body is pinned (position: fixed, negative top), the original way;
    //   'overflow'  the page is held by body.cv3-cd-open { overflow: hidden } alone, which is how the "Added to cart"
    //               sheet holds it. iPhones and iPads use this. Reported from an iPhone (Safari with the floating
    //               toolbar): with the body pinned, the cart was outside the screen whenever it was opened further
    //               down a page, while the sheet opened at the same spot showed fine.
    // Any other browser where the pinned body leaves the cart off screen is switched over by watchOpen().
    var cv3Ua = navigator.userAgent || '';
    var lockMode = (/iP(hone|ad|od)/.test(cv3Ua) || (/Macintosh/.test(cv3Ua) && navigator.maxTouchPoints > 1)) ? 'overflow' : 'fixed';
    try { if (window.localStorage.getItem('cv3Lock') === 'overflow') lockMode = 'overflow'; } catch (e) {}
    var bodyScrollLockY = null;
    function lockBodyScroll() {
      if (bodyScrollLockY !== null) return;
      bodyScrollLockY = window.scrollY || window.pageYOffset || 0;
      if (lockMode !== 'fixed') return;
      var b = document.body;
      b.style.position = 'fixed';
      b.style.top = (-bodyScrollLockY) + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
    }
    function unlockBodyScroll() {
      if (bodyScrollLockY === null) return;
      var y = bodyScrollLockY;
      bodyScrollLockY = null;
      unplaceCart();
      var b = document.body;
      if (b.style.position === 'fixed') {
        b.style.position = '';
        b.style.top = '';
        b.style.left = '';
        b.style.right = '';
        b.style.width = '';
        // Use instant scroll (not smooth) so the user doesn't see the page
        // animate back to where they were — perceptually they never left.
        window.scrollTo(0, y);
      } else if (Math.abs((window.scrollY || window.pageYOffset || 0) - y) > 2) {
        window.scrollTo(0, y);          // the page behind moved (a field in the cart got the keyboard): put it back
      }
    }

    function setLoading(v) {
      if (els.loading) els.loading.classList.toggle('is-hidden', !v);
    }

    // ─── Inline upsell inference (potted plants) ──────────────────────
    // PDP determines repotting + tray variants from the pot-collection
    // handle (see pot-picker-widget.liquid ~L2104). We mirror that map here
    // so the drawer can offer those upsells on ANY potted-plant line that
    // carries _io_pot_collection — even ones that were added before the
    // service-variant stamping shipped. If the line carries explicit
    // _io_repot_variant_id / _io_tray_variant_id, those win (they're more
    // accurate because they may have been picked from a multi-option select).
    // CRO2610: the map printed from Theme settings (snippets/cv3-bundle-variants.liquid) wins; the names typed
    // here are the fallback when that table is missing.
    var POT_COLL_SIZE = (typeof window !== 'undefined' && window.CV3_BUNDLE_VARIANTS && window.CV3_BUNDLE_VARIANTS.pot_collections) || {
      'mini-planters':       'xs_s',
      'small-planters':      'xs_s',
      'xs-small-planters':   'xs_s',
      'medium-planters':     'm',
      'large-planters':      'l',
      'big-indoor-plant-pots': 'xl',
      'xxl-large-planters':  'xxl'
    };
    // Prefer the single-source-of-truth blob from snippets/cv3-bundle-variants
    // (hydrated by layout/theme.liquid) if present. The inline literals below
    // remain as a one-release fallback in case a cached page is loaded before
    // the new snippet ships, or the layout render is somehow skipped. When
    // updating IDs, change cv3-bundle-variants.liquid — these literals are
    // historic and will be removed next release.
    var _cv3bv = (typeof window !== 'undefined' && window.CV3_BUNDLE_VARIANTS) || {};
    var REPOT_BY_SIZE = _cv3bv.repot || {
      xs_s: { id: 39896975736926, price: 1000 },
      m:    { id: 40292317069406, price: 2500 },
      l:    { id: 40453521571934, price: 3500 },
      xl:   { id: 39896975769694, price: 5500 },
      xxl:  { id: 40453521604702, price: 8500 }
    };
    var TRAY_BY_SIZE = _cv3bv.tray || {
      xs_s: { id: 41451120164958, price: 500  },
      m:    { id: 41451120230494, price: 1000 },
      l:    { id: 41451120263262, price: 1500 },
      xl:   { id: 41451120296030, price: 1800 },
      xxl:  { id: 42387232620638, price: 2500 }
    };
    // ── ONSITE repotting ────────────────────────────────────────────
    // Distinct from in-warehouse "repot" service: customer keeps their
    // existing pot at home, we visit and repot the plant into THAT pot
    // (or take the old grow pot away if "with Disposal" is chosen).
    // Source: "Onsite Repotting Service" product (handle:
    // onsite-repotting-service). Keyed by PLANT size (XS/S/M/L/XL/XXL),
    // not planter size, per merchant requirement. Both variants per size:
    //   no_disposal  → customer's pot already empty/ready
    //   with_disposal → we take the old plastic grow pot away
    // Prices in cents (verified against the live product JSON 2026-05).
    // Same source-of-truth pattern — prefer the global blob, fall back to
    // inline literals. See REPOT_BY_SIZE comment above for migration notes.
    var ONSITE_REPOT_BY_PLANT_SIZE = _cv3bv.onsite_repot || {
      'XS':  { no_disposal: { id: 40296337178718, price: 5000  },
               with_disposal:{ id: 40400158687326, price: 5000  } },
      'S':   { no_disposal: { id: 40296337178718, price: 5000  },
               with_disposal:{ id: 40400158687326, price: 5000  } },
      'M':   { no_disposal: { id: 40296337211486, price: 5000  },
               with_disposal:{ id: 40400158720094, price: 7000  } },
      'L':   { no_disposal: { id: 40296337244254, price: 10000 },
               with_disposal:{ id: 40400158752862, price: 12500 } },
      'XL':  { no_disposal: { id: 41876459651166, price: 12000 },
               with_disposal:{ id: 41876459683934, price: 17500 } },
      'XXL': { no_disposal: { id: 40296484077662, price: 16000 },
               with_disposal:{ id: 40400158785630, price: 25000 } }
    };

    // ── JS-side pot-collection resolver ────────────────────────────
    // Mirror of the Liquid 3-tier resolver. Used when the Liquid map
    // wasn't emitted (cart > 30 items) or the line lacks _io_pot_collection.
    //
    // Tier 1: plant_size on the cart line (cart-data shape carries product
    //         metafields when included; we also accept a synthetic
    //         `_io_plant_size` line property in case future stamping adds
    //         it). Maps the standard XS/S/M/L/XL/XXL values.
    // Tier 2: product_type === 'Potted plant' → fall back to 'planters'.
    // Tier 3: not a potted plant → empty (true dead end).
    var PLANT_SIZE_TO_POT_COLL = {
      'XS':  'mini-planters',
      'S':   'xs-small-planters',
      'M':   'medium-planters',
      'L':   'large-planters',
      'XL':  'big-indoor-plant-pots',
      'XXL': 'xxl-large-planters'
    };
    function resolvePotCollFromAnchor(anchor) {
      if (!anchor) return '';
      var sz = resolvePlantSizeFromAnchor(anchor);
      if (sz && PLANT_SIZE_TO_POT_COLL[sz]) return PLANT_SIZE_TO_POT_COLL[sz];
      // Tier 2: any potted plant → catch-all 'planters'. The picker will
      // show the broader catalog; customer can filter by size inside.
      if (anchor.product_type === 'Potted plant') return 'planters';
      return '';
    }

    // ── JS-side plant-size resolver ────────────────────────────────
    // Returns one of 'XS' / 'S' / 'M' / 'L' / 'XL' / 'XXL' (or '').
    // Sources, in priority order:
    //   1. _io_plant_size stamped on the cart line (future-proof).
    //   2. Liquid-emitted lineKeyPlantSize map (covers the common case
    //      where /cart.js doesn't carry metafields).
    //   3. product-shaped metafield on the anchor (if some app injected it).
    function resolvePlantSizeFromAnchor(anchor) {
      if (!anchor) return '';
      var props = anchor.properties || {};
      var sz = (props._io_plant_size || '').toString().toUpperCase();
      if (sz) return sz;
      if (anchor.key && lineKeyPlantSize[anchor.key]) {
        return String(lineKeyPlantSize[anchor.key]).toUpperCase();
      }
      var mf = anchor.product && anchor.product.metafields && anchor.product.metafields.custom;
      if (mf && mf.plant_size && mf.plant_size.value) {
        return String(mf.plant_size.value).toUpperCase();
      }
      return '';
    }

    // Resolve onsite-repot variant + price for a given anchor + disposal
    // choice. Returns null if the anchor isn't a potted plant or has no
    // recognised plant size (in which case we don't offer onsite repot).
    function resolveOnsiteRepotForAnchor(anchor, withDisposal) {
      var sz = resolvePlantSizeFromAnchor(anchor);
      var row = sz && ONSITE_REPOT_BY_PLANT_SIZE[sz];
      if (!row) return null;
      var pick = withDisposal ? row.with_disposal : row.no_disposal;
      return { id: String(pick.id), price: pick.price, plantSize: sz, withDisposal: !!withDisposal };
    }

    // Resolve repot service for a cart line. Priority: stamped > inferred.
    // Falls back to the Liquid-emitted lineKeyPotCollection map when
    // _io_pot_collection isn't stamped (legacy / direct ATC), then to the
    // JS resolver (which guarantees 'planters' catch-all for potted plants).
    function resolvePotCollectionForLine(item) {
      var props = item.properties || {};
      if (props._io_pot_collection) return props._io_pot_collection;
      if (item.key && lineKeyPotCollection[item.key]) return lineKeyPotCollection[item.key];
      return resolvePotCollFromAnchor(item) || '';
    }
    function resolveRepotForLine(item) {
      var props = item.properties || {};
      if (props._io_repot_variant_id) {
        return {
          id:    String(props._io_repot_variant_id),
          price: parseInt(props._io_repot_price || '0', 10) || 0
        };
      }
      var sz = POT_COLL_SIZE[resolvePotCollectionForLine(item)];
      var rec = sz && REPOT_BY_SIZE[sz];
      return rec && rec.id && String(rec.id) !== '0' ? { id: String(rec.id), price: rec.price } : null;   // id 0 = not offered (unset or sold out)
    }
    function resolveTrayForLine(item) {
      var props = item.properties || {};
      if (props._io_tray_variant_id) {
        return {
          id:    String(props._io_tray_variant_id),
          price: parseInt(props._io_tray_price || '0', 10) || 0
        };
      }
      var sz = POT_COLL_SIZE[resolvePotCollectionForLine(item)];
      var rec = sz && TRAY_BY_SIZE[sz];
      return rec && rec.id && String(rec.id) !== '0' ? { id: String(rec.id), price: rec.price } : null;
    }

    // Cart-line pot-collection inference map (emitted from Liquid above).
    // Used as a fallback for any potted plant in cart that didn't get
    // `_io_pot_collection` stamped at ATC time — so the "Add pot?" CTA +
    // services shelf can still appear for legacy / direct-ATC items.
    var lineKeyPotCollection = {};
    try {
      var lkpcEl = document.querySelector('[data-cv3-cd-plant-pot-collections]');
      if (lkpcEl) lineKeyPotCollection = JSON.parse(lkpcEl.textContent || '{}') || {};
    } catch (e) {
      console.warn('[cv3-cart-drawer] plant-pot-collections parse failed', e);
    }

    // Cart-line plant-size map (XS / S / M / L / XL / XXL). Drives the
    // onsite-repot variant resolver — variant IDs vary by plant size, not
    // planter size, per merchant config. Emitted by Liquid above.
    var lineKeyPlantSize = {};
    try {
      var lkpsEl = document.querySelector('[data-cv3-cd-plant-sizes]');
      if (lkpsEl) lineKeyPlantSize = JSON.parse(lkpsEl.textContent || '{}') || {};
    } catch (e) {
      console.warn('[cv3-cart-drawer] plant-sizes parse failed', e);
    }

    // Pot variant → metadata map (material, drainage, tray, dimensions,
    // visualiser cutout). Server-side Liquid emission via cv3-pot-meta.liquid,
    // covering pot collections referenced by current cart + the default upsell
    // collection. Read by pickPot() to stamp _io_pot_* properties on swap-
    // added pots so View pairing → Details + the composite visualiser get
    // the same data PDP/PLP-added pots carry. Missing-variant case (a swap
    // into a collection not pre-emitted) falls back to image-only stamping.
    var potVariantMeta = {};
    try {
      var pvmEl = document.querySelector('[data-cv3-cd-pot-meta]');
      if (pvmEl) potVariantMeta = JSON.parse(pvmEl.textContent || '{}') || {};
    } catch (e) {
      console.warn('[cv3-cart-drawer] pot-meta parse failed', e);
    }
    // CRO2610: pot details are no longer printed into every page. One planter collection's details are fetched the
    // first time the pot chooser shows that collection, and merged into the map above. pickPot() waits for this
    // (a moment at most) before it stamps a newly added pot.
    var potMetaLoads = {};
    function loadPotMeta(handle) {
      if (!handle) return Promise.resolve();
      if (!potMetaLoads[handle]) {
        potMetaLoads[handle] = fetch('/collections/' + encodeURIComponent(handle) + '?section_id=cv3-pot-meta-json', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var m = /<script[^>]*data-cv3-cd-pot-meta[^>]*>([\s\S]*?)<\/script>/.exec(html);
            if (!m) return;
            var more = JSON.parse(m[1] || '{}') || {};
            Object.keys(more).forEach(function (k) { potVariantMeta[k] = more[k]; });
          })
          .catch(function () { potMetaLoads[handle] = null; });
      }
      return potMetaLoads[handle];
    }

    // Per-line metadata side channel (cv3-line-meta.liquid). /cart.js does
    // NOT return `product.tags`, so without this map we couldn't render the
    // preorder badge or the 6-month-protection pill in the drawer — the
    // gates need product context that JSON doesn't carry. Shape:
    //   { preorder_pids: [<product_id>, ...], guarantee_pid: <product_id> }
    // preorder_pids is scoped to products currently in cart at page-load
    // time (keeps payload tiny; new SPA-added preorder products won't
    // get the badge until next reload — acceptable gap, see snippet header).
    var cv3LineMeta = { preorder_pids: [], guarantee_pid: null };
    try {
      var lmEl = document.querySelector('[data-cv3-cd-line-meta]');
      if (lmEl) {
        var parsed = JSON.parse(lmEl.textContent || '{}') || {};
        cv3LineMeta.preorder_pids = Array.isArray(parsed.preorder_pids) ? parsed.preorder_pids.map(Number) : [];
        cv3LineMeta.guarantee_pid = parsed.guarantee_pid ? Number(parsed.guarantee_pid) : null;
      }
    } catch (e) {
      console.warn('[cv3-cart-drawer] line-meta parse failed', e);
    }
    // Updated by render(cart) before any row builds — buildPrimaryRowHtml
    // reads it to gate the 6-month-protection pill. Computed once per
    // render instead of per row so the cart-wide `some()` only runs once.
    var cartHasGuarantee = false;
    // Same — set by render(cart) so the preorder banner above the items
    // list knows whether to fire. Also drives the disabling of the
    // delivery-date module (consumer reads .cv3-cd[data-cv3-cd-has-preorder]).
    var cartHasPreorder = false;

    // Cached most-recent cart so we can paint instantly on next open.
    var lastCart = null;
    // Cache pot-collection fetches so re-opening the picker for the same
    // collection is instant. Keyed by handle → array of pot rows.
    var potCollectionCache = {};
    // Upsell recommendations: cache by anchor product_id so we don't re-fetch
    // every time the user adjusts quantity.
    var upsellRecsCache = {};
    var upsellLastSeed = null;

    function cartProductIds(cart) {
      var ids = {};
      (cart.items || []).forEach(function (i) { if (i.product_id) ids[i.product_id] = true; });
      return Object.keys(ids).map(function (s) { return parseInt(s, 10); });
    }

    // Toggle BOTH the strip container AND the anchor pill in one place so
    // they never disagree. IntersectionObserver further hides the anchor
    // when the strip is already in the viewport (no point pointing at
    // something the user can see).
    function setUpsellVisible(visible) {
      if (els.upsell) els.upsell.hidden = !visible;
      if (els.upsellAnchor) els.upsellAnchor.hidden = !visible;
    }

    function maybeRenderUpsells(cart) {
      if (!els.upsell || !els.upsellStrip) return;
      var manual = els.upsell.hasAttribute('data-cv3-cd-upsell-manual');
      var cartProds = cartProductIds(cart);

      if (manual) {
        // Filter out any upsell card whose product is already in cart.
        var anyVisible = false;
        var visibleCount = 0;
        Array.prototype.forEach.call(els.upsellStrip.querySelectorAll('[data-cv3-cd-upsell-add]'), function (card) {
          var h = card.getAttribute('data-cv3-cd-upsell-handle');
          var match = (cart.items || []).some(function (i) { return i.handle === h; });
          card.hidden = match;
          if (!match) { anyVisible = true; visibleCount++; }
        });
        setUpsellVisible(!(!anyVisible || cart.item_count === 0));
        setUpsellCount(visibleCount);
        return;
      }

      // Recs API path — fetch by first cart product. Skip when cart is empty.
      if (!cart.items || !cart.items.length) {
        setUpsellVisible(false);
        return;
      }
      var seedId = cart.items[0].product_id;
      if (!seedId) {
        setUpsellVisible(false);
        return;
      }
      // Avoid re-rendering the same seed every render() call.
      if (upsellLastSeed === seedId && els.upsellStrip.children.length) {
        setUpsellVisible(true);
        return;
      }
      upsellLastSeed = seedId;

      if (upsellRecsCache[seedId]) {
        renderUpsellCards(upsellRecsCache[seedId], cartProds);
        return;
      }

      fetch('/recommendations/products.json?product_id=' + seedId + '&limit=6&intent=related', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.products) || [];
          upsellRecsCache[seedId] = products;
          renderUpsellCards(products, cartProds);
        })
        .catch(function (err) {
          console.warn('[cv3-cart-drawer] upsell recs fetch failed', err);
          setUpsellVisible(false);
        });
    }

    function renderUpsellCards(products, cartProds) {
      var filtered = products.filter(function (p) {
        if (!p || !p.available) return false;
        return cartProds.indexOf(p.id) === -1;
      }).slice(0, 4);
      if (!filtered.length) {
        setUpsellVisible(false);
        return;
      }
      var html = filtered.map(function (p) {
        var v = (p.variants && p.variants[0]) || {};
        var img = (p.featured_image || (p.images && p.images[0]) || '');
        var imgSrc = typeof img === 'string' ? img : (img && img.src) || '';
        return (
          '<button type="button" class="cv3-cd__upsell-card" data-cv3-cd-upsell-add="' + (v.id || '') + '" data-cv3-cd-upsell-handle="' + escapeHtml(p.handle || '') + '">' +
            '<span class="cv3-cd__upsell-img">' + (imgSrc ? '<img src="' + imgSrc + '" alt="" loading="lazy" width="80" height="80">' : '') + '</span>' +
            '<span class="cv3-cd__upsell-name">' + escapeHtml(p.title || '') + '</span>' +
            '<span class="cv3-cd__upsell-price">' + formatMoney(typeof p.price === 'number' ? p.price : (v.price || 0)) + '</span>' +
            '<span class="cv3-cd__upsell-plus" aria-hidden="true">+</span>' +
          '</button>'
        );
      }).join('');
      els.upsellStrip.innerHTML = html;
      setUpsellVisible(true);
      setUpsellCount(filtered.length);
    }

    // Tiny helper — show the count pill next to "Add to your order"
    // when collapsed, so the customer knows there's something to expand into.
    function setUpsellCount(n) {
      if (!els.upsellCount) return;
      els.upsellCount.textContent = n > 0 ? String(n) : '';
    }

    // Generate a fresh random bundle id (legacy fallback — prefer
    // deterministicBundleId() below for new code so identical compositions
    // share an ID and Shopify's line-item coalescing can merge cleanly).
    function makeBundleId() {
      return 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    }

    // Hash a bundle composition signature to a short, stable id. MUST be
    // byte-identical to the copy in snippets/pot-picker-widget.liquid —
    // cross-surface coalescing (a PDP-composed bundle and a drawer-swapped
    // bundle of the SAME composition) depends on both producing the same
    // hash. Double djb2 → ~12 base36 chars, ~64-bit space (collision would
    // wrongly merge two different bundles in the renderer, so we don't
    // skimp on the hash width).
    function cv3HashBundleSig(sig) {
      var h1 = 5381, h2 = 52711;
      for (var i = 0; i < sig.length; i++) {
        var c = sig.charCodeAt(i);
        h1 = ((h1 << 5) + h1 + c) >>> 0;
        h2 = ((h2 << 5) + h2 + c) >>> 0;
      }
      return h1.toString(36) + h2.toString(36);
    }

    // Parse a packed `_io_pot_spec` / `_io_visual` JSON line-item property
    // back into an object. Returns {} on absent or malformed input so
    // callers can read keys without guarding. Counterpart to the
    // JSON.stringify packing done by pot-picker-widget, cv3-plp + pickPot.
    function cv3UnpackSpec(str) {
      if (!str) return {};
      try { return JSON.parse(str) || {}; }
      catch (e) { return {}; }
    }

    // A2 — Mirrors the PDP pot-picker's deterministic composition hash
    // (snippets/pot-picker-widget.liquid). Identical plant+pot+addons
    // produce the same bundle ID across calls — eliminates random-ID
    // collisions that caused pot children to attach to the wrong plant
    // anchor at render time. The signature (m…_p…_r…_t…) is hashed rather
    // than used raw so the id stays short on the cart line + admin order.
    function deterministicBundleId(plantVariantId, potVariantId, opts) {
      opts = opts || {};
      // CRO2610: the shared helper every entry point uses (snippets/cv3-bundle-variants.liquid); same formula as below
      if (window.CV3_SET && window.CV3_SET.id) return window.CV3_SET.id(plantVariantId, potVariantId, opts.repotVariant, opts.trayVariant);
      var sig = [
        'm' + String(plantVariantId || ''),
        potVariantId      ? 'p' + String(potVariantId)      : '',
        opts.repotVariant ? 'r' + String(opts.repotVariant) : '',
        opts.trayVariant  ? 't' + String(opts.trayVariant)  : ''
      ].filter(Boolean).join('_');
      return 'b_' + cv3HashBundleSig(sig);
    }

    // Ensures the anchor cart line has a `_io_bundle_id` property. If it
    // doesn't (standalone plant added without the bundle stamping), we mint
    // one and write it onto the line via /cart/change.js so future inline
    // upsell adds can group with it. Resolves with the bundle id to use.
    //
    // A2/A4 — accepts an optional `opts` object:
    //   { preferredBid, potCollection, pairedLabel }
    // - preferredBid: caller-provided deterministic ID (preferred for parity
    //   with PDP). Falls back to makeBundleId() if not given.
    // - potCollection / pairedLabel: backfill the anchor with the same
    //   metadata a PDP-added bundle has, so downstream code (cart page,
    //   render grouping, upsell pills hide-on-paired) treats them identically.
    function ensureBundleId(anchorKey, opts) {
      opts = opts || {};
      var anchor = findItemByKey(anchorKey);
      if (!anchor) return Promise.reject(new Error('anchor not found'));
      var existing = anchor.properties && anchor.properties._io_bundle_id;
      // If the anchor already has a bundle id, just backfill any missing
      // metadata (caller may have new info like a freshly-resolved pot
      // collection) and resolve with the existing id.
      var existingProps = anchor.properties || {};
      var needsWrite = !existing;
      var merged = Object.assign({}, existingProps);
      if (!existing) {
        merged._io_bundle_id = opts.preferredBid || makeBundleId();
        merged._io_bundle_role = 'plant';
      } else if (!existingProps._io_bundle_role) {
        // Defensive backfill: the plant already has a bundle_id (from a
        // prior PLP/PDP add or a partial earlier write) but no role. The
        // cart-page outer loop's anchor-finder requires role === 'plant'
        // to recognise this line as the bundle anchor — without it, any
        // subsequent service add (onsite_repot, repot, tray) would render
        // as a standalone orphan even though the bundle_id matches.
        merged._io_bundle_role = 'plant';
        needsWrite = true;
      }
      // Backfill — only write keys the anchor doesn't already carry, so
      // we never clobber legitimate values.
      if (opts.potCollection && !existingProps._io_pot_collection) {
        merged._io_pot_collection = opts.potCollection;
        needsWrite = true;
      }
      if (opts.pairedLabel && !existingProps._io_paired) {
        merged._io_paired = opts.pairedLabel;
        needsWrite = true;
      }
      var bid = merged._io_bundle_id;
      if (!needsWrite) return Promise.resolve(bid);
      // CRO2610: written as the product page writes a set's plant line (paired label, repotting / tray as yes or no,
      // one key order). A plant with no pot says "No decorative pot".
      if (window.CV3_SET && window.CV3_SET.plant) {
        merged = window.CV3_SET.plant({ paired: merged._io_paired, repot: merged._io_repotting === 'yes', tray: merged._io_tray === 'yes', id: bid }, merged);
      }
      return fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: anchorKey, properties: merged })
      })
        // Check r.ok — a 422 (e.g. stale line item key) silently dropped
        // the property write without surfacing the error. Then the
        // subsequent pot ADD happened with a bid the plant doesn't have,
        // and bundle grouping at render time saw an orphan. Now we throw
        // so the pickPot .catch handles it cleanly + tells the user.
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) {
              var err = new Error((body && body.description) || ('change.js ' + r.status));
              err.body = body;
              err.status = r.status;
              throw err;
            }
            return body;
          });
        })
        .then(function () { return bid; });
    }

    // CRO2610 — line keys go stale. Shopify gives a line a new key whenever its properties OR its discount change,
    // and on this store the automatic sale discount is tiered: each time the cart total crosses a tier, every line
    // gets a new key. So a key read a moment ago (from the page, or from the cart before an add) may no longer
    // exist, and a write to it fails with "no valid id or line parameter". Find the line again in a fresh cart:
    // by its key if that still exists, else the line with the same variant and the same properties.
    function findLineAgain(cart, line) {
      if (!cart || !cart.items || !line) return null;
      var same = cart.items.filter(function (it) { return it.key === line.key; })[0];
      if (same) return same;
      var want = JSON.stringify(line.properties || {});
      return cart.items.filter(function (it) {
        return String(it.variant_id) === String(line.variant_id) && JSON.stringify(it.properties || {}) === want;
      })[0] || null;
    }

    // CRO2610 — one contract for sets (CV3_SET in snippets/cv3-bundle-variants.liquid).
    // The plant line of a set says which pot it is paired with and whether repotting and a tray belong to it
    // (_io_paired, _io_repotting, _io_tray), exactly as the product page stamps them. When the cart itself changes
    // a set (a service or the pot is added or removed here), this brings the plant line back in step. It reads the
    // cart once, writes once, and only when something actually differs. Resolves with the cart after the write
    // (carrying the re-rendered cart page section when on /cart), or null when nothing needed writing.
    function syncSetLine(bundleId) {
      if (!bundleId || !(window.CV3_SET && window.CV3_SET.plant)) return Promise.resolve(null);
      return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return null;
          var plant = null, pot = null, hasRepot = false, hasTray = false;
          cart.items.forEach(function (it) {
            var p = it.properties || {};
            if (p._io_bundle_id !== bundleId) return;      // only lines that really carry this id on the server
            var role = p._io_bundle_role;
            if (role === 'plant') { if (!plant) plant = it; }
            else if (role === 'pot') { if (!pot) pot = it; }
            else if (role === 'repot') hasRepot = true;
            else if (role === 'tray') hasTray = true;
          });
          if (!plant) return null;
          var have = plant.properties || {};
          var next = window.CV3_SET.plant({
            paired: pot ? window.CV3_SET.paired(pot.product_title, pot.variant_title) : 'No decorative pot',
            repot: hasRepot, tray: hasTray, id: bundleId
          }, have);
          if (JSON.stringify(next) === JSON.stringify(have)) return null;
          return fetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(Object.assign({ id: plant.key, properties: next }, cartSectionParams()))
          }).then(function (r) { return r.json().then(function (body) { if (!r.ok) throw new Error((body && body.description) || ('change.js ' + r.status)); return body; }); });
        })
        .catch(function (err) { console.warn('[cv3-cart-drawer] set line not updated', err); return null; });
    }
    // After a change to a set made here: update the plant line if needed, then show the result.
    function syncSetThenShow(bundleId) {
      return syncSetLine(bundleId).then(function (cart) {
        if (!cart) return false;
        try { render(cart); } catch (_) {}
        maybeReloadCartPage(sectionHtmlFromCartResponse(cart));
        return true;
      });
    }

    // Per-card feedback states for the upsell + service-add buttons.
    // Without this the customer sees no signal that a click registered,
    // because the new line lives inside the cart body and the global drawer
    // spinner is small. We swap the card to "Adding…" → "Added ✓" then let
    // refresh() re-render (which removes / converts the row).
    function markCardState(el, state) {
      if (!el) return;
      el.dataset.cv3CdAdding = state;
      if (state === 'adding') {
        el.setAttribute('disabled', '');
        el.setAttribute('aria-busy', 'true');
      } else if (state === 'added') {
        el.removeAttribute('disabled');
        el.removeAttribute('aria-busy');
      } else {
        delete el.dataset.cv3CdAdding;
        el.removeAttribute('disabled');
        el.removeAttribute('aria-busy');
      }
    }

    // Add a service line (repotting / tray) back into an existing bundle.
    // Stamps the bundle_id + role so the drawer re-renders it as a child of
    // the original plant — instant toggle-on UX without a PDP detour.
    //
    // Qty handling: services scale with the bundle anchor. If the anchor is
    // at qty=2, adding a repot creates the repot at qty=2 so the customer
    // gets 2 plants × 2 repotting visits (matches the qty-stepper scaling
    // behaviour). Onsite-repot is the exception — it includes 1 photo per
    // visit and the qty stepper is already capped at 1 for any bundle that
    // carries one, so adding it at qty=1 here is consistent with that cap.
    function addBundleService(role, variantId, bundleId, anchorKey, sourceEl) {
      if (!variantId || !role) return;
      markCardState(sourceEl, 'adding');
      setLoading(true);
      // Captured from the add.js response (`sections` param) — threaded
      // into maybeReloadCartPage so the cart page syncs with no extra GET.
      var addBundleServiceSectionHtml = null;
      // A1 — focus this anchor on the next render so the customer sees
      // the new service land next to its plant.
      if (anchorKey) setFocusedKey(anchorKey);
      // Resolve the anchor's qty so we add the service at the matching
      // amount. Onsite-repot is capped at qty=1 regardless (one photo
      // per visit — see qty-stepper cap in buildItemLi).
      var anchorItem = anchorKey ? findItemByKey(anchorKey) : null;
      var addQty = (role === 'onsite_repot')
        ? 1
        : (anchorItem && anchorItem.quantity > 0 ? anchorItem.quantity : 1);
      // If the anchor isn't bundled yet, mint a bundle id first so this new
      // service line groups under the plant.
      var bidPromise = bundleId ? Promise.resolve(bundleId) : ensureBundleId(anchorKey, (anchorItem && window.CV3_SET) ? {
        preferredBid: window.CV3_SET.id(anchorItem.variant_id, '', (role === 'repot' || role === 'onsite_repot') ? variantId : '', role === 'tray' ? variantId : '')
      } : null);
      var bidUsed = bundleId;
      bidPromise
        .then(function (bid) {
          bidUsed = bid;
          var properties = { _io_bundle_id: bid, _io_bundle_role: role };
          if (role === 'repot')         properties._io_service_type = 'repotting';
          if (role === 'onsite_repot')  properties._io_service_type = 'onsite_repotting';
          if (role === 'tray')          properties._io_service_type = 'tray';
          // The onsite-repotting flow needs a customer photo of their pot —
          // surface that as an obvious line-item note in the cart + checkout.
          if (role === 'onsite_repot') {
            properties['Note'] = 'Onsite repotting — please reply to the order confirmation email with a photo of your pot.';
          }
          return fetch('/cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(Object.assign(
              { items: [{ id: variantId, quantity: addQty, properties: properties }] },
              cartSectionParams()
            ))
          // C2 — Shopify returns 422 for sold-out / unavailable variants
          // with a JSON error body. Previously the .json() succeeded but
          // the next .then() ran the "Added ✓" UI on a failed add. Now we
          // throw the parsed error so .catch() handles it consistently.
          }).then(function (r) {
            return r.json().then(function (body) {
              if (!r.ok) {
                var err = new Error(body && body.description || ('add.js ' + r.status));
                err.body = body; err.status = r.status;
                throw err;
              }
              return body;
            });
          });
        })
        .then(function (addResp) {
          markCardState(sourceEl, 'added');
          // Stash the re-rendered section HTML (rides back inside the
          // add.js response thanks to the `sections` param) for the
          // cart-page sync below.
          addBundleServiceSectionHtml = sectionHtmlFromCartResponse(addResp);
          // Brief "Added ✓" state. The fetch interceptor's debounced
          // refresh fires ~80ms after the add.js POST and handles the
          // re-render + cart:updated dispatch. No explicit refresh here
          // (avoids the double-render scroll race that pickPot also had).
          return new Promise(function (res) { setTimeout(res, 350); });
        })
        .then(function () {
          // CRO2610: repotting / a tray now belong to this set: say so on the plant line (as the product page does)
          return syncSetThenShow(bidUsed);
        })
        .then(function (shown) {
          if (!shown) maybeReloadCartPage(addBundleServiceSectionHtml);
        })
        .catch(function (err) {
          console.error('[cv3-cart-drawer] addBundleService failed', err);
          markCardState(sourceEl, null);
          setLoading(false);
        });
    }

    // ─── Onsite-repotting photo modal ───────────────────────────────
    // Customer attaches a photo of their pot at home; uploaded as a line-
    // item property via multipart /cart/add.js. Shopify stores the file on
    // its CDN and surfaces the URL on the order in admin.
    var photoCtx = null;

    // Overlays (picker / detail / photo) are now body-level standalone
    // modals — they open over the page regardless of drawer state, with
    // their own backdrop + fixed positioning. No need to force the drawer
    // open just to show them.
    function ensureDrawerVisibleForOverlay() { /* no-op — kept as safety stub */ }
    function teardownOverlayDrawerIfNeeded() { /* no-op */ }

    // Re-sync the photo modal's price line + checkbox hint based on the
    // current disposal toggle state. Reads from photoCtx (set by
    // openPhotoModal) — both variants per size are stored there so we
    // don't need to re-resolve on every toggle.
    function syncPhotoModalPrice() {
      if (!photoCtx || !photoCtx.onsite) return;
      var withDisposal = !!(els.photoDisposalChk && els.photoDisposalChk.checked);
      var pick = withDisposal ? photoCtx.onsite.with_disposal : photoCtx.onsite.no_disposal;
      photoCtx.variantId = pick.id;
      photoCtx.withDisposal = withDisposal;
      if (els.photoPrice) els.photoPrice.textContent = '+' + formatMoney(pick.price);
      if (els.photoDisposalHint) {
        var diff = photoCtx.onsite.with_disposal.price - photoCtx.onsite.no_disposal.price;
        els.photoDisposalHint.textContent = withDisposal
          ? 'We take the old grow pot away.'
          : (diff > 0 ? 'Adds ' + formatMoney(diff) + ' for disposal.' : 'Toggle on to have us dispose of the old pot.');
      }
    }

    function openPhotoModal(role, variantId, bundleId, anchorKey, sourceEl) {
      if (!els.photo) {
        // Modal markup not present — fall back to legacy path.
        return addBundleService(role, variantId, bundleId, anchorKey, sourceEl);
      }
      // For onsite_repot we resolve the variant from the PLANT'S size
      // (not the planter size that was passed in). This gives us two
      // variants per size — w/o disposal + with disposal — so the
      // disposal toggle below can switch between them at apply-time.
      var anchor = findItemByKey(anchorKey);
      var onsiteRow = null;
      var plantSize = '';
      if (role === 'onsite_repot' && anchor) {
        plantSize = resolvePlantSizeFromAnchor(anchor);
        onsiteRow = plantSize && ONSITE_REPOT_BY_PLANT_SIZE[plantSize] ? ONSITE_REPOT_BY_PLANT_SIZE[plantSize] : null;
      }
      ensureDrawerVisibleForOverlay('photo');
      photoCtx = {
        role: role,
        variantId: variantId,   // initial; overwritten by syncPhotoModalPrice for onsite
        bundleId: bundleId,
        anchorKey: anchorKey,
        sourceEl: sourceEl,
        file: null,
        onsite: onsiteRow,
        plantSize: plantSize,
        withDisposal: false
      };
      // Show / hide the disposal toggle + size label depending on whether
      // we resolved a plant-size-aware onsite variant. If not (regular
      // repot or unknown plant size), the modal still works using the
      // variantId that was passed in — we just hide the toggle.
      var hasOnsiteToggle = !!onsiteRow;
      if (els.photoDisposal)    els.photoDisposal.hidden    = !hasOnsiteToggle;
      if (els.photoDisposalChk) els.photoDisposalChk.checked = false;
      if (els.photoSizeLabel) {
        els.photoSizeLabel.textContent = hasOnsiteToggle ? '(' + plantSize + ')' : '';
      }
      if (hasOnsiteToggle) {
        syncPhotoModalPrice();
      } else {
        // Legacy fallback: read price from the source button's adjacent
        // .cv3-cd__svc-price for a friendlier footer line.
        var priceEl = sourceEl ? sourceEl.querySelector('.cv3-cd__svc-price') : null;
        if (els.photoPrice) els.photoPrice.textContent = priceEl ? priceEl.textContent.replace(/^\+\s*/, '') : '—';
      }
      if (els.photoInput) els.photoInput.value = '';
      if (els.photoPreview) { els.photoPreview.hidden = true; els.photoPreview.src = ''; }
      if (els.photoEmpty)   els.photoEmpty.hidden = false;
      if (els.photoStatus)  els.photoStatus.dataset.cv3CdState = 'idle';
      els.photo.hidden = false;
      requestAnimationFrame(function () { els.photo.classList.add('is-open'); });
      els.photo.setAttribute('aria-hidden', 'false');
    }

    // Bind disposal toggle once at IIFE init (modal markup is server-rendered).
    if (els.photoDisposalChk) {
      els.photoDisposalChk.addEventListener('change', syncPhotoModalPrice);
    }
    // C6 — every URL.createObjectURL() needs a matching URL.revokeObjectURL()
    // or the blob stays in memory for the page lifetime. Each preview is
    // 2-5MB depending on iPhone photo size; 10-15 unrevoked previews on a
    // budget Android make the page noticeably sluggish.
    var lastPhotoBlobUrl = null;
    function revokePhotoBlob() {
      if (lastPhotoBlobUrl) {
        try { URL.revokeObjectURL(lastPhotoBlobUrl); } catch (_) {}
        lastPhotoBlobUrl = null;
      }
    }
    function closePhotoModal() {
      if (!els.photo) return;
      els.photo.classList.remove('is-open');
      els.photo.setAttribute('aria-hidden', 'true');
      setTimeout(function () { if (!els.photo.classList.contains('is-open')) els.photo.hidden = true; }, 280);
      photoCtx = null;
      revokePhotoBlob();
      teardownOverlayDrawerIfNeeded('photo');
    }
    // Preview the selected file in the dropzone.
    if (els.photoInput) {
      els.photoInput.addEventListener('change', function () {
        var f = els.photoInput.files && els.photoInput.files[0];
        if (!f) return;
        if (f.size > 20 * 1024 * 1024) {
          alert('Photo is over 20 MB — Shopify can\'t store it. Try a smaller file.');
          els.photoInput.value = '';
          return;
        }
        // HEIC hint — accepted but won't preview in our admin. We let it
        // through (the operations team can still open it locally) and
        // visually mark the dropzone so the user can swap if they want.
        // Detect by both MIME (Safari sets this) and filename extension
        // (some Android browsers leave MIME blank on iOS-originated files).
        var isHeic = /image\/hei[cf]/i.test(f.type || '') ||
                     /\.hei[cf]$/i.test(f.name || '');
        if (els.photoEmpty) {
          var existingHint = els.photoEmpty.querySelector('[data-cv3-heic-hint]');
          if (isHeic && !existingHint) {
            var hint = document.createElement('div');
            hint.setAttribute('data-cv3-heic-hint', '');
            hint.style.cssText = 'margin-top:8px;font-size:11px;color:#9a6c00;line-height:1.4';
            hint.textContent = 'Heads up: HEIC files don\'t preview well in our system. ' +
                               'Upload still works — or pick a JPEG/PNG version if you\'d prefer.';
            els.photoEmpty.appendChild(hint);
          } else if (!isHeic && existingHint) {
            existingHint.remove();
          }
        }
        if (photoCtx) photoCtx.file = f;
        if (els.photoEmpty) els.photoEmpty.hidden = true;
        if (els.photoPreview) {
          // Revoke the previous blob URL before allocating a new one — handles
          // the "user picks photo, picks another photo, doesn't upload" path.
          revokePhotoBlob();
          lastPhotoBlobUrl = URL.createObjectURL(f);
          els.photoPreview.src = lastPhotoBlobUrl;
          els.photoPreview.hidden = false;
        }
      });
    }
    // Apply: upload photo + add to cart. Uses FormData (multipart) so the
    // file lands as a line property URL. Without a file, falls back to
    // the JSON path so the legacy cart-note behaviour is preserved.
    function applyPhotoUpload() {
      if (!photoCtx) return closePhotoModal();
      var ctx = photoCtx;
      // No file selected → behave exactly like the legacy "Skip" path.
      if (!ctx.file) {
        addBundleService(ctx.role, ctx.variantId, ctx.bundleId, ctx.anchorKey, ctx.sourceEl);
        closePhotoModal();
        return;
      }
      // Disable the Apply button while uploading.
      if (els.photoApply) {
        els.photoApply.disabled = true;
        els.photoApply.textContent = 'Uploading…';
      }
      markCardState(ctx.sourceEl, 'adding');

      // Captured from the add.js response (`sections` param) — threaded
      // into maybeReloadCartPage so the cart page syncs with no extra GET.
      var photoUploadSectionHtml = null;
      // Mint a bundle id if the plant doesn't have one yet, same as the
      // addBundleService path.
      var photoAnchor = ctx.anchorKey ? findItemByKey(ctx.anchorKey) : null;
      var bidPromise = ctx.bundleId ? Promise.resolve(ctx.bundleId) : ensureBundleId(ctx.anchorKey, (photoAnchor && window.CV3_SET) ? {
        preferredBid: window.CV3_SET.id(photoAnchor.variant_id, '', ctx.variantId, '')
      } : null);
      bidPromise
        .then(function (bid) {
          var fd = new FormData();
          fd.append('id', String(ctx.variantId));
          fd.append('quantity', '1');
          fd.append('properties[_io_bundle_id]', bid);
          fd.append('properties[_io_bundle_role]', ctx.role);
          fd.append('properties[_io_service_type]', 'onsite_repotting');
          // The file. Shopify accepts properties[<name>] as a file input on
          // /cart/add.js when posted as multipart/form-data. The line item
          // ends up with a public CDN URL for the file in its properties.
          fd.append('properties[Photo of your pot]', ctx.file);
          // Re-render the main-cart section in the same POST (cart page sync).
          var sp = cartSectionParams();
          if (sp.sections) {
            fd.append('sections', sp.sections);
            fd.append('sections_url', sp.sections_url);
          }
          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            // NOTE: don't set Content-Type — browser sets the multipart
            // boundary automatically when body is FormData.
            body: fd
          }).then(function (r) {
            if (!r.ok) return r.json().then(function (j) { throw j; });
            return r.json();
          });
        })
        .then(function (addResp) {
          markCardState(ctx.sourceEl, 'added');
          photoUploadSectionHtml = sectionHtmlFromCartResponse(addResp);
          return new Promise(function (res) { setTimeout(res, 350); });
        })
        .then(function () { return refresh(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cv3-cart-drawer:photo-upload' } }));
          closePhotoModal();
          if (els.photoApply) { els.photoApply.disabled = false; els.photoApply.textContent = 'Add to cart'; }
          maybeReloadCartPage(photoUploadSectionHtml);
        })
        .catch(function (err) {
          console.error('[cv3-cart-drawer] photo upload failed', err);
          alert((err && (err.description || err.message)) || 'Could not upload the photo. Please try again or use the Skip option.');
          markCardState(ctx.sourceEl, null);
          if (els.photoApply) { els.photoApply.disabled = false; els.photoApply.textContent = 'Add to cart'; }
        });
    }

    // Quick-add an upsell variant. Standalone (no bundle stamping), since
    // these are add-ons to the existing order, not part of a styled set.
    function addUpsell(variantId, sourceEl) {
      if (!variantId) return;
      markCardState(sourceEl, 'adding');
      setLoading(true);
      var upsellSectionHtml = null;
      // A card may carry line properties (data-cv3-cd-upsell-props, JSON). A suggested plant uses this to say
      // which planters fit it, so its line gets the same "+ Add a pot" prompt as a plant added with the pot picker.
      var upsellItem = { id: variantId, quantity: 1 };
      var upsellProps = sourceEl && sourceEl.getAttribute && sourceEl.getAttribute('data-cv3-cd-upsell-props');
      if (upsellProps) {
        try { var parsedProps = JSON.parse(upsellProps); if (parsedProps && typeof parsedProps === 'object') upsellItem.properties = parsedProps; } catch (e) {}
      }
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(Object.assign(
          { items: [upsellItem] },
          cartSectionParams()
        ))
      })
        .then(function (r) { return r.json(); })
        .then(function (addResp) {
          markCardState(sourceEl, 'added');
          upsellSectionHtml = sectionHtmlFromCartResponse(addResp);
          return new Promise(function (res) { setTimeout(res, 450); });
        })
        .then(function () {
          return refresh();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cv3-cart-drawer:upsell' } }));
          maybeReloadCartPage(upsellSectionHtml);
        })
        .catch(function (err) {
          console.error('[cv3-cart-drawer] upsell add failed', err);
          markCardState(sourceEl, null);
          setLoading(false);
        });
    }
    // Active picker context — which anchor's pot are we changing?
    var pickerCtx = null;
    // Promise for the cart refresh kicked off when the picker opens.
    // pickPot() awaits it so its mutations run against CURRENT line keys
    // without adding latency — the fetch overlaps with the customer
    // choosing a pot.
    var pickerCartReady = null;
    // Hint passed from the click handler into openInlinePotPicker via a
    // module-scoped var (avoids changing the openInlinePotPicker
    // signature, which is also called from other paths). Consumed once.
    var pendingPotCollHint = null;

    // Find the anchor cart item by key.
    function findItemByKey(key) {
      if (!lastCart || !lastCart.items) return null;
      for (var i = 0; i < lastCart.items.length; i++) {
        if (lastCart.items[i].key === key) return lastCart.items[i];
      }
      return null;
    }

    // Find the existing pot child of a given anchor (by bundle_id).
    function findPotChild(anchor) {
      if (!anchor || !lastCart) return null;
      var bid = anchor.properties && anchor.properties._io_bundle_id;
      if (!bid) return null;
      var items = lastCart.items || [];
      for (var i = 0; i < items.length; i++) {
        var p = items[i].properties || {};
        if (p._io_bundle_id === bid && p._io_bundle_role === 'pot') return items[i];
      }
      return null;
    }

    function openInlinePotPicker(anchorKey) {
      // Open the picker shell IMMEDIATELY (even before cart data lands) so
      // the user gets instant feedback. We paint the overlay with its
      // loading spinner up front; data backfills below. This eliminates
      // the ~1–3 s "click but nothing happens" feeling on /cart, where
      // lastCart starts as null and we have to /cart.js fetch first.
      ensureDrawerVisibleForOverlay('picker');
      els.pickerTitle.textContent = 'Loading…';
      els.picker.hidden = false;
      requestAnimationFrame(function () { els.picker.classList.add('is-open'); });
      els.picker.setAttribute('aria-hidden', 'false');
      showPickerLoading(true);
      resetPickerFoot();

      // Cart-freshness vs picker-open speed.
      //
      // pickPot() (fired on Apply) resolves the anchor + old-pot line KEYS
      // from lastCart, and those keys must be current — Shopify rotates a
      // line's key whenever its properties change, and a swap fired at a
      // stale key fails with "no valid id or line parameter".
      //
      // BUT opening the picker doesn't need that — and blocking the open on
      // a GET /cart.js (slow on a big cart) just to THEN start the slow
      // products.json fetch made "Change pot" feel like a 10s hang. So:
      //   • No cart cached yet  → we must wait once (can't resolve anchor).
      //   • Cart already cached → open IMMEDIATELY off the cached cart and
      //     refresh in the BACKGROUND. The customer spends a few seconds
      //     choosing a pot; the refresh lands well within that window, so
      //     pickPot() still sees fresh keys at Apply time — without the
      //     /cart.js round-trip sitting in the picker-open critical path.
      if (!lastCart) {
        pickerCartReady = refreshCartData();
        return pickerCartReady.then(function () { openInlinePotPickerWithData(anchorKey); });
      }
      // Background refresh — pickPot() awaits this promise so its mutations
      // resolve fresh line keys without the /cart.js round-trip blocking
      // the picker open.
      pickerCartReady = refreshCartData();
      openInlinePotPickerWithData(anchorKey);
    }

    function openInlinePotPickerWithData(anchorKey) {
      var anchor = findItemByKey(anchorKey);
      if (!anchor) { closeInlinePotPicker(); return; }
      // 4-tier resolver:
      //   0. Click-time hint from the button's data-cv3-cd-pot-coll
      //      attribute (set by cv3-cart-page-item.liquid using Liquid's
      //      full 3-tier resolver). Wins because it had the merchant's
      //      product object at render time — most authoritative source.
      //   1. _io_pot_collection stamped on the cart line at ATC (set by
      //      quick-add using the plant_size metafield).
      //   2. lineKeyPotCollection map (Liquid pre-resolves for ≤30-item
      //      carts: plant_size metafield → collections → 'planters').
      //   3. JS-side fallback: synthetic plant_size hint on the line,
      //      else 'planters' catch-all. Guarantees the picker ALWAYS
      //      opens for a potted-plant line.
      var hintHandle = '';
      if (pendingPotCollHint && pendingPotCollHint.key === anchorKey) {
        hintHandle = pendingPotCollHint.handle || '';
        pendingPotCollHint = null;
      }
      var handle = hintHandle
                 || (anchor.properties && anchor.properties._io_pot_collection)
                 || lineKeyPotCollection[anchorKey]
                 || resolvePotCollFromAnchor(anchor);
      if (!handle) {
        // True dead end (not a potted plant at all). Show a polite
        // empty-state with a link to the product page.
        pickerCtx = { anchorKey: anchorKey, handle: null, currentPotChild: null };
        els.pickerTitle.textContent = 'Add a pot';
        showPickerLoading(false);
        if (els.pickerGrid) els.pickerGrid.hidden = true;
        if (els.pickerEmpty) {
          els.pickerEmpty.hidden = false;
          els.pickerEmpty.innerHTML =
            '<p style="margin:0 0 10px;">We don’t have a curated pot range for this plant inside the cart yet.</p>' +
            (anchor.url
              ? '<a class="cv3-cd__edit-btn" href="' + anchor.url + '">Choose a pot on the product page</a>'
              : '');
        }
        resetPickerFoot();
        return;
      }
      pickerCtx = { anchorKey: anchorKey, handle: handle, currentPotChild: findPotChild(anchor) };
      loadPotMeta(handle);

      els.pickerTitle.textContent = pickerCtx.currentPotChild ? 'Change pot' : 'Add a pot';

      if (potCollectionCache[handle]) {
        // pickerCtx.pots is what pickPot() reads to look up the picked
        // pot's title + image at apply time. Without this, pickPot's
        // `(pickerCtx.pots || []).find(...)` always returned undefined,
        // pairedLabel silently fell back to 'Decorative pot', and the
        // visualiser had no source for _io_visual_photo. Fixed here AND
        // in the fetch branch below.
        pickerCtx.pots = potCollectionCache[handle];
        renderPickerGrid(potCollectionCache[handle]);
      } else {
        showPickerLoading(true);
        fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=50', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data && data.products) || [];
            // Preserve ALL available variants per product — the picker
            // shows variant swatches under each card so a customer can
            // pick size / colour without leaving the drawer.
            //
            // NOTE on prices: /collections/<h>/products.json returns prices
            // as dollar STRINGS ("25.00"), not cent integers. formatMoney
            // and the rest of the drawer work in cents, so we normalise
            // once here. (/cart.js, by contrast, returns cents — that's
            // why the cart-line code didn't hit this bug.)
            function toCents(p) {
              if (typeof p === 'number') return p > 1000 ? p : Math.round(p * 100);
              if (typeof p === 'string' && p) return Math.round(parseFloat(p) * 100);
              return 0;
            }
            var pots = products.map(function (p) {
              var availableVariants = (p.variants || []).filter(function (v) {
                return v.available !== false;
              });
              if (!availableVariants.length) return null;
              var firstImg = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
              return {
                product_id: p.id,
                product_handle: p.handle,
                title: p.title,
                image: firstImg,
                variants: availableVariants.map(function (v) {
                  var vImg = '';
                  if (v.featured_image && v.featured_image.src) vImg = v.featured_image.src;
                  return {
                    variant_id: v.id,
                    title: v.title,
                    option1: v.option1,
                    option2: v.option2,
                    option3: v.option3,
                    price: toCents(v.price),
                    image: vImg
                  };
                })
              };
            }).filter(Boolean);
            potCollectionCache[handle] = pots;
            // Same stash as the cache-hit branch above — keep pickerCtx.pots
            // populated so pickPot() can resolve the picked pot's title +
            // image for _io_paired + _io_visual_photo stamping.
            if (pickerCtx && pickerCtx.handle === handle) pickerCtx.pots = pots;
            renderPickerGrid(pots);
          })
          .catch(function (err) {
            console.error('[cv3-cart-drawer] pot collection fetch failed', err);
            renderPickerGrid([]);
          });
      }
    }

    // ─── Pairing-detail overlay (View pairing button) ────────────────
    // Renders the PDP-grade composite visualiser (plant cutout above pot
    // cutout, scaled by their respective heights in cm) plus a tabbed
    // Details panel with the line items + per-line metadata.
    function openDetailOverlay(anchorKey) {
      // Same as openInlinePotPicker — on cart page lastCart may not be
      // populated yet; fetch + retry.
      if (!lastCart) {
        return refresh().then(function () { openDetailOverlay(anchorKey); });
      }
      var anchor = findItemByKey(anchorKey);
      if (!anchor) return;
      // Force the drawer visible if we're on /cart, so the detail overlay
      // has a parent. Cleared by closeOverlayContext() in closeDetailOverlay.
      ensureDrawerVisibleForOverlay('detail');
      var bid = anchor.properties && anchor.properties._io_bundle_id;
      var children = [];
      if (bid) {
        (lastCart.items || []).forEach(function (it) {
          var p = it.properties || {};
          if (p._io_bundle_id !== bid) return;
          if (it.key === anchor.key) return;
          children.push(it);
        });
        var roleOrder = { pot: 1, repot: 2, onsite_repot: 2, tray: 3 };
        children.sort(function (a, b) {
          var ra = roleOrder[(a.properties || {})._io_bundle_role] || 9;
          var rb = roleOrder[(b.properties || {})._io_bundle_role] || 9;
          return ra - rb;
        });
      }
      var potChild = children.filter(function (c) {
        return (c.properties || {})._io_bundle_role === 'pot';
      })[0];

      // ─── Visualiser composite (PDP parity) ────────────────────────
      // If we have cutout images + heights, render them at correct relative
      // scale. Otherwise fall back to plain images stacked.
      // Cutout photo + height are packed: the plant carries `_io_visual`
      // ({ph,vh}); the pot carries them inside `_io_pot_spec` ({ph,vh,…}).
      var aProps = anchor.properties || {};
      var pProps = (potChild && potChild.properties) || {};
      var aVisual = cv3UnpackSpec(aProps._io_visual);
      var pSpec   = cv3UnpackSpec(pProps._io_pot_spec);
      var plantPhoto  = aVisual.ph || anchor.image || '';
      var plantHeight = parseFloat(aVisual.vh) || 0;
      var potPhoto    = pSpec.ph || (potChild && potChild.image) || '';
      var potHeight   = parseFloat(pSpec.vh) || 0;

      var visHtml = '';
      if (plantPhoto || potPhoto) {
        visHtml = '<div class="cv3-cd__vis cv3-cd__vis--scaled">';
        // When both heights are known, scale by ratio (max height of stack
        // = container 280 px; plant + pot share that height proportionally).
        var useCutouts = (window.cv3CdConfig || {}).visualiserCutouts !== false;
        if (useCutouts && plantHeight && potHeight) {
          var total = plantHeight + potHeight;
          var plantPct = Math.round((plantHeight / total) * 100);
          var potPct   = Math.round((potHeight   / total) * 100);
          if (potPhoto) {
            visHtml += '<img class="cv3-cd__vis-pot cv3-cd__vis-pot--scaled" ' +
                       'style="height:' + potPct + '%;" src="' + potPhoto + '" alt="" loading="lazy">';
          }
          if (plantPhoto) {
            visHtml += '<img class="cv3-cd__vis-plant cv3-cd__vis-plant--scaled" ' +
                       'style="height:' + plantPct + '%; bottom:' + potPct + '%;" ' +
                       'src="' + plantPhoto + '" alt="" loading="lazy">';
          }
        } else {
          // Approximate composite using whatever we have.
          if (potPhoto)   visHtml += '<img class="cv3-cd__vis-pot" src="' + potPhoto + '" alt="" loading="lazy">';
          if (plantPhoto) visHtml += '<img class="cv3-cd__vis-plant" src="' + plantPhoto + '" alt="" loading="lazy">';
        }
        visHtml += '</div>';
      } else {
        visHtml = '<div class="cv3-cd__vis"><div class="cv3-cd__vis-empty">No imagery available for this pairing.</div></div>';
      }

      // ─── Tabs: Pairing | Details ────────────────────────────────────
      var tabsHtml =
        '<div class="cv3-cd__detail-tabs" role="tablist">' +
          '<button type="button" class="cv3-cd__detail-tab is-active" role="tab" aria-selected="true" data-cv3-cd-detail-tab="pair">Pairing</button>' +
          '<button type="button" class="cv3-cd__detail-tab" role="tab" aria-selected="false" data-cv3-cd-detail-tab="details">Details</button>' +
        '</div>';

      // ─── Pairing panel: line items + bundle total ──────────────────
      function lineRow(it, roleLabel) {
        var img = it.image
          ? '<img src="' + it.image + '" alt="" loading="lazy">'
          : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="3" y="8" width="18" height="13" rx="1"/></svg>';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? ' · ' + it.variant_title : '';
        return (
          '<div class="cv3-cd__detail-line">' +
            '<div class="cv3-cd__detail-thumb">' + img + '</div>' +
            '<div class="cv3-cd__detail-info">' +
              '<div class="cv3-cd__detail-role">' + escapeHtml(roleLabel) + '</div>' +
              '<div class="cv3-cd__detail-name">' + escapeHtml((it.product_title || '') + variant) + '</div>' +
            '</div>' +
            '<div class="cv3-cd__detail-price">' + formatMoney(it.final_line_price || 0) + '</div>' +
          '</div>'
        );
      }
      var pairRows = lineRow(anchor, 'Plant');
      children.forEach(function (c) {
        var r = (c.properties || {})._io_bundle_role || 'addon';
        var label = (r === 'pot') ? 'Pot' : (r === 'repot') ? 'Repotting service' : (r === 'onsite_repot') ? 'Onsite repotting' : (r === 'tray') ? 'Matching tray' : 'Add-on';
        pairRows += lineRow(c, label);
      });
      var total = bundleTotal(anchor, children);
      var totalHtml =
        '<div class="cv3-cd__detail-total">' +
          '<span class="cv3-cd__detail-total-label">Bundle total</span>' +
          '<span class="cv3-cd__detail-total-amt">' + formatMoney(total) + '</span>' +
        '</div>';
      var pairPanel =
        '<div class="cv3-cd__detail-panel is-active" data-cv3-cd-detail-panel="pair">' +
          pairRows + totalHtml +
        '</div>';

      // ─── Details panel: plant block + pot block (deeper metadata) ───
      function detailBlock(it, roleLabel) {
        if (!it) return '';
        var bits = [];
        var props = it.properties || {};
        var role = props._io_bundle_role || '';

        // ── Pot ── show the same spec strip the PDP picker shows:
        //    Color · Material · Drainage · Tray · Dimensions
        // Read from the packed `_io_pot_spec` JSON ({mat,drn,tray,w,h,inner,…}).
        // Plain Variant/Type/Brand/SKU are skipped — not useful here.
        if (role === 'pot') {
          if (it.variant_title && it.variant_title !== 'Default Title') {
            bits.push({ label: 'Color', value: it.variant_title });
          }
          var ps = cv3UnpackSpec(props._io_pot_spec);
          if (ps.mat)  bits.push({ label: 'Material', value: ps.mat });
          if (ps.drn)  bits.push({ label: 'Drainage', value: ps.drn });
          if (ps.tray) bits.push({ label: 'Tray',     value: ps.tray });
          var dim = '';
          if (ps.w && ps.h) {
            dim = 'Ø ' + ps.w + ' × H ' + ps.h + 'cm';
          } else if (ps.w) {
            dim = 'Ø ' + ps.w + 'cm';
          }
          if (dim) bits.push({ label: 'Dimensions', value: dim });
          if (ps.inner) {
            bits.push({ label: 'Inner Ø', value: ps.inner + 'cm' });
          }
        }
        // ── Plant — keep it lean: size variant + plant height (when known) ──
        else if (role === 'plant' || role === '') {
          if (it.variant_title && it.variant_title !== 'Default Title') {
            bits.push({ label: 'Size', value: it.variant_title });
          }
          var pv = cv3UnpackSpec(props._io_visual);
          if (pv.vh) {
            bits.push({ label: 'Plant height', value: pv.vh + ' cm' });
          }
        }
        // ── Services (repot / onsite_repot / tray) — variant + service type ──
        else {
          if (it.variant_title && it.variant_title !== 'Default Title') {
            bits.push({ label: 'Variant', value: it.variant_title });
          }
          if (props._io_service_type) {
            bits.push({ label: 'Service', value: String(props._io_service_type).replace(/_/g, ' ') });
          }
          // Onsite repotting carries a customer-uploaded photo URL.
          if (props['Photo of your pot']) {
            bits.push({
              label: 'Your photo',
              value: '<a href="' + escapeHtml(props['Photo of your pot']) + '" target="_blank" rel="noopener">View photo</a>',
              html: true
            });
          }
        }

        // Price last, on every block.
        bits.push({ label: 'Price', value: formatMoney(it.final_line_price || it.price || 0) });

        var rows = bits.map(function (b) {
          // `html: true` lets a bit emit pre-escaped HTML (e.g. a link
          // to the customer-uploaded photo). Default is text-only + escaped.
          var val = b.html ? b.value : escapeHtml(String(b.value));
          return '<div class="cv3-cd__detail-kv">' +
                   '<dt>' + escapeHtml(b.label) + '</dt>' +
                   '<dd>' + val + '</dd>' +
                 '</div>';
        }).join('');
        var thumb = it.image
          ? '<img src="' + it.image + '" alt="" loading="lazy">'
          : '';
        // For pot blocks, attach a placeholder div that hydratePotDescSections()
        // fills with the same Size/Dimensions sections the PDP picker shows,
        // by lazy-fetching /products/<handle>.js and parsing the description.
        var potDescSlot = (role === 'pot' && it.handle)
          ? '<div class="cv3-cd__detail-extras" data-cv3-cd-pot-desc data-cv3-cd-pot-handle="' + escapeHtml(it.handle) + '"></div>'
          : '';
        return (
          '<div class="cv3-cd__detail-block">' +
            '<div class="cv3-cd__detail-block-head">' +
              '<div class="cv3-cd__detail-block-thumb">' + thumb + '</div>' +
              '<div>' +
                '<div class="cv3-cd__detail-block-role">' + escapeHtml(roleLabel) + '</div>' +
                '<a class="cv3-cd__detail-block-name" href="' + escapeHtml(it.url || '#') + '">' + escapeHtml(it.product_title || '') + '</a>' +
              '</div>' +
            '</div>' +
            '<dl class="cv3-cd__detail-kvlist">' + rows + '</dl>' +
            potDescSlot +
          '</div>'
        );
      }
      var detailsPanel =
        '<div class="cv3-cd__detail-panel" data-cv3-cd-detail-panel="details" hidden>' +
          detailBlock(anchor, 'Plant') +
          (potChild ? detailBlock(potChild, 'Pot') : '') +
          children.filter(function (c) {
            return (c.properties || {})._io_bundle_role !== 'pot';
          }).map(function (c) {
            var r = (c.properties || {})._io_bundle_role;
            var label = (r === 'repot') ? 'Repotting service' : (r === 'onsite_repot') ? 'Onsite repotting' : (r === 'tray') ? 'Matching tray' : 'Add-on';
            return detailBlock(c, label);
          }).join('') +
        '</div>';

      els.detailBody.innerHTML = visHtml + tabsHtml + pairPanel + detailsPanel;
      els.detail.hidden = false;
      requestAnimationFrame(function () { els.detail.classList.add('is-open'); });
      els.detail.setAttribute('aria-hidden', 'false');

      // Hydrate any pot blocks with their description's Size/Dimensions
      // sections — same data the PDP pot picker shows. Runs in idle so
      // it doesn't block the overlay open animation.
      var run = function () { hydratePotDescSections(); };
      if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 800 });
      else setTimeout(run, 60);
    }

    // ─── Lazy hydrate Pot description spec sections ──────────────────
    // Reads each pot's product description via /products/<handle>.js, parses
    // the HTML, extracts h4 headings matching "size" / "dimension", and
    // injects them under the pot's Details block. Mirrors the PDP picker's
    // approach (pot-picker-widget.liquid ~L1922). Cached per-handle so a
    // re-open of View pairing is instant.
    var potDescCache = {};
    function hydratePotDescSections() {
      var slots = els.detailBody && els.detailBody.querySelectorAll('[data-cv3-cd-pot-desc]');
      if (!slots || !slots.length) return;
      slots.forEach(function (slot) {
        if (slot.dataset.cv3CdPotDescDone === '1') return;
        var handle = slot.dataset.cv3CdPotHandle;
        if (!handle) return;
        if (potDescCache[handle] != null) {
          renderPotDescSlot(slot, potDescCache[handle]);
          return;
        }
        // Fetch the pot product as JSON (Shopify includes its rendered
        // description as `body_html`).
        fetch('/products/' + encodeURIComponent(handle) + '.js', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var bodyHtml = (data && (data.description || data.body_html)) || '';
            var extracted = extractPotSizeSections(bodyHtml);
            potDescCache[handle] = extracted;
            renderPotDescSlot(slot, extracted);
          })
          .catch(function (err) {
            console.warn('[cv3-cart-drawer] pot description fetch failed', err);
            slot.dataset.cv3CdPotDescDone = '1'; // don't retry on this open
          });
      });
    }
    function extractPotSizeSections(html) {
      if (!html) return '';
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var pieces = '';
        var headings = doc.querySelectorAll('h4, h3');
        for (var i = 0; i < headings.length; i++) {
          var h = headings[i];
          var key = (h.textContent || '').trim().toLowerCase();
          if (!key.includes('size') && !key.includes('dimension')) continue;
          // Collect siblings up to the next heading at same level.
          var stop = h.tagName;
          var sib = h.nextSibling;
          var inner = '';
          while (sib && !(sib.nodeType === 1 && sib.tagName === stop)) {
            if (sib.nodeType === 1) {
              if (/^(img|table|iframe|video|style|script|noscript)$/i.test(sib.tagName)) {
                sib = sib.nextSibling; continue;
              }
              // Strip inline styles to avoid clashing.
              sib.removeAttribute && sib.removeAttribute('style');
              inner += sib.outerHTML;
            } else if (sib.nodeType === 3 && sib.textContent.trim()) {
              inner += sib.textContent;
            }
            sib = sib.nextSibling;
          }
          if (inner.trim()) {
            pieces +=
              '<div class="cv3-cd__detail-desc-section">' +
                '<h5 class="cv3-cd__detail-desc-title">' + (h.textContent || '').trim() + '</h5>' +
                '<div class="cv3-cd__detail-desc-body">' + inner + '</div>' +
              '</div>';
          }
        }
        return pieces;
      } catch (e) { return ''; }
    }
    function renderPotDescSlot(slot, html) {
      slot.dataset.cv3CdPotDescDone = '1';
      if (!html) { slot.remove(); return; }
      slot.innerHTML = html;
    }

    function closeDetailOverlay() {
      if (!els.detail) return;
      els.detail.classList.remove('is-open');
      els.detail.setAttribute('aria-hidden', 'true');
      setTimeout(function () { if (!els.detail.classList.contains('is-open')) els.detail.hidden = true; }, 280);
      teardownOverlayDrawerIfNeeded('detail');
    }

    function closeInlinePotPicker() {
      els.picker.classList.remove('is-open');
      els.picker.setAttribute('aria-hidden', 'true');
      // Hide after the transition so it doesn't trap focus or pointer events.
      setTimeout(function () { if (!els.picker.classList.contains('is-open')) els.picker.hidden = true; }, 280);
      pickerCtx = null;
      teardownOverlayDrawerIfNeeded('picker');
    }

    function showPickerLoading(v) {
      if (!els.pickerLoad) return;
      els.pickerLoad.classList.toggle('is-hidden', !v);
      if (v) {
        els.pickerGrid.hidden = true;
        els.pickerEmpty.hidden = true;
      }
    }

    // Concise variant label — strips the redundant product title from
    // Shopify's variant.title pattern ("Beige / Medium").
    function variantChipLabel(v) {
      var parts = [v.option1, v.option2, v.option3].filter(function (x) {
        return x && x !== 'Default Title';
      });
      return parts.length ? parts.join(' · ') : (v.title || '');
    }

    function renderPickerGrid(pots) {
      showPickerLoading(false);
      if (!pots.length) {
        els.pickerGrid.hidden = true;
        els.pickerEmpty.hidden = false;
        resetPickerFoot();
        return;
      }
      els.pickerEmpty.hidden = true;
      var currentVariantId = pickerCtx && pickerCtx.currentPotChild ? pickerCtx.currentPotChild.variant_id : null;
      // Cards are <div role="radio">, not <button>, because their inner
      // multi-line title + variant chip strip don't fit the button content
      // model cleanly. The picker is a single-select group; clicking a
      // chip selects that specific variant within the card.
      var html = pots.map(function (pot) {
        // Default "active" variant for this card = whatever's currently in
        // cart (if any of THIS product's variants is in cart), otherwise the
        // first available variant.
        var defaultVariant = pot.variants[0];
        var hasCurrent = false;
        pot.variants.forEach(function (v) {
          if (v.variant_id === currentVariantId) { defaultVariant = v; hasCurrent = true; }
        });
        var priceStr = formatMoney(defaultVariant.price || 0);
        var imgSrc = defaultVariant.image || pot.image;
        var classes = 'cv3-cd__pp-card' + (hasCurrent ? ' is-current' : '');

        // Variant chips — only render when there's more than one available variant.
        var chipsHtml = '';
        if (pot.variants.length > 1) {
          chipsHtml = '<div class="cv3-cd__pp-chips" role="radiogroup" aria-label="Variant">';
          pot.variants.forEach(function (v) {
            var label = variantChipLabel(v);
            var isDefault = (v.variant_id === defaultVariant.variant_id);
            chipsHtml +=
              '<button type="button" class="cv3-cd__pp-chip' + (isDefault ? ' is-active' : '') + '" ' +
                'data-cv3-cd-pp-chip="' + v.variant_id + '" ' +
                'data-cv3-cd-pp-chip-price="' + (v.price || 0) + '" ' +
                'data-cv3-cd-pp-chip-img="' + escapeHtml(v.image || '') + '" ' +
                'aria-pressed="' + (isDefault ? 'true' : 'false') + '">' +
                escapeHtml(label) +
              '</button>';
          });
          chipsHtml += '</div>';
        }

        return (
          '<div class="' + classes + '" role="radio" tabindex="0" aria-checked="false" ' +
                'data-cv3-cd-pp-pick="' + defaultVariant.variant_id + '" ' +
                'data-cv3-cd-pp-title="' + escapeHtml(pot.title || '') + '" ' +
                'data-cv3-cd-pp-price="' + (defaultVariant.price || 0) + '">' +
            '<div class="cv3-cd__pp-img" data-cv3-cd-pp-img>' + (imgSrc ? '<img src="' + imgSrc + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div class="cv3-cd__pp-meta">' +
              '<div class="cv3-cd__pp-name">' + escapeHtml(pot.title || '') + '</div>' +
              '<div class="cv3-cd__pp-price" data-cv3-cd-pp-card-price>' + escapeHtml(priceStr) + '</div>' +
              chipsHtml +
              (hasCurrent ? '<span class="cv3-cd__pp-current-tag">Currently in cart</span>' : '') +
            '</div>' +
          '</div>'
        );
      }).join('');
      els.pickerGrid.innerHTML = html;
      els.pickerGrid.hidden = false;
      resetPickerFoot();
    }

    function resetPickerFoot() {
      if (!els.pickerInfo || !els.pickerApply) return;
      els.pickerApply.disabled = true;
      els.pickerInfo.innerHTML = pickerCtx && pickerCtx.currentPotChild
        ? 'Select a different pot to swap in.'
        : 'Select a pot to add to your order.';
      if (pickerCtx) pickerCtx.selectedVariantId = null;
    }

    function selectPickerCard(cardEl) {
      if (!cardEl || !pickerCtx) return;
      var vid = parseInt(cardEl.getAttribute('data-cv3-cd-pp-pick'), 10);
      if (!vid) return;
      // No-op if user re-clicks the existing pot.
      if (pickerCtx.currentPotChild && vid === pickerCtx.currentPotChild.variant_id) {
        return;
      }
      // Clear previous selection
      Array.prototype.forEach.call(els.pickerGrid.querySelectorAll('.cv3-cd__pp-card'), function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-checked', 'false');
      });
      cardEl.classList.add('is-selected');
      cardEl.setAttribute('aria-checked', 'true');
      pickerCtx.selectedVariantId = vid;
      var title = cardEl.getAttribute('data-cv3-cd-pp-title') || '';
      var price = parseInt(cardEl.getAttribute('data-cv3-cd-pp-price'), 10) || 0;
      els.pickerInfo.innerHTML = 'Selected: <strong>' + escapeHtml(title) + '</strong> · ' + formatMoney(price);
      els.pickerApply.disabled = false;
    }

    // Commit a pot pick. UX order matters here:
    //   1. Close the picker IMMEDIATELY (Apply feels instant).
    //   2. Show the drawer's loading spinner so the user knows work is in flight.
    //   3. Remove old pot + add new pot (sequential — /cart/update.js can't
    //      do "swap by variant", it can only set quantity by line key).
    //   4. refresh() repaints the drawer with the new pot in the bundle.
    function pickPot(newVariantId) {
      if (!pickerCtx) return;
      var anchorKey = pickerCtx.anchorKey;

      // Picked-pot metadata — comes from the picker SELECTION, not cart
      // state, so it's safe to read synchronously before the picker closes.
      var pickedPotProduct = null;
      var pickedPotVariant = null;
      (pickerCtx.pots || []).some(function (p) {
        var match = (p.variants || []).filter(function (v) {
          return String(v.variant_id) === String(newVariantId);
        })[0];
        if (match) { pickedPotProduct = p; pickedPotVariant = match; return true; }
        return false;
      });
      var pairedLabel = pickedPotProduct && pickedPotProduct.title
        ? pickedPotProduct.title
        : 'Decorative pot';
      // CRO2610: what goes on the plant line: pot name, then its option, as the product page writes it
      var pairedFull = (window.CV3_SET && pickedPotProduct && pickedPotProduct.title)
        ? window.CV3_SET.paired(pickedPotProduct.title, pickedPotVariant ? pickedPotVariant.title : '')
        : pairedLabel;
      var pickedPotImage =
        (pickedPotVariant && pickedPotVariant.image) ||
        (pickedPotProduct && pickedPotProduct.image) || '';

      // Await the cart refresh started when the picker opened (almost
      // certainly already finished — the customer spent seconds choosing a
      // pot). pickPot's mutations MUST run against current line keys:
      // Shopify rotates a line's key on ANY property change, so the
      // anchor / old-pot keys captured at picker-open can be stale. We
      // re-resolve EVERYTHING cart-dependent inside the .then() below, off
      // the fresh cart — this is what makes the swap reliable.
      var cartReady = pickerCartReady || refreshCartData();
      // CRO2610: also wait (2.5s at most) for this collection's pot details, so the new pot is stamped in full
      var potMetaReady = Promise.race([loadPotMeta(pickerCtx.handle) || Promise.resolve(), new Promise(function (done) { setTimeout(done, 2500); })]);
      cartReady = Promise.all([cartReady, potMetaReady]);

      // Instant UX — close the picker, show the working toast.
      closeInlinePotPicker();
      showCartToast('Adding ' + pairedLabel + ' to your bundle…', { busy: true });
      setLoading(true);
      setFocusedKey(anchorKey);

      cartReady.then(function () {
        // Re-resolve anchor + old pot + collection from the FRESH cart.
        var anchor = findItemByKey(anchorKey);
        if (!anchor) {
          showCartToast('Couldn’t find that plant in your cart — please refresh and try again.', { duration: 3500, isError: true });
          setLoading(false);
          return;
        }
        var anchorProps     = anchor.properties || {};
        var anchorVariantId = anchor.variant_id;
        var resolvedPotColl = resolvePotCollectionForLine(anchor);

        // Bundle id — reuse the anchor's id when it has one, else mint a
        // deterministic one. EITHER WAY the anchor is relabelled below so
        // its REAL cart line carries this exact id. That's the fix for the
        // "new pot orphaned / old pot still shows" bug: normalizeWidgetPairings
        // synthesises _io_bundle_id in memory for legacy pairings, but that
        // id is NOT on the real line — so a new pot stamped with it didn't
        // match the plant on the server-rendered cart page. Relabelling
        // writes the id for real, guaranteeing plant + new pot group.
        var bundleId = anchorProps._io_bundle_id
          || deterministicBundleId(anchorVariantId, newVariantId);
        // CRO2610: a new set never takes the id of a different set already in the cart (see CV3_SET.free)
        if (!anchorProps._io_bundle_id && window.CV3_SET && window.CV3_SET.free) {
          bundleId = window.CV3_SET.free(bundleId, window.CV3_SET.plant({ paired: pairedFull, repot: false, tray: false, id: bundleId, potCollection: resolvedPotColl }, anchorProps), anchor.key);
        }

        function relabelLine(line, propertyOverrides) {
          if (!line || !line.key) {
            console.warn('[cv3-cart-drawer] relabelLine skipped — line has no cart key', line);
            return Promise.resolve(null);
          }
          var newProps = Object.assign({}, line.properties || {}, propertyOverrides);
          function write(key) {
            return fetch('/cart/change.js', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: key, properties: newProps })
            }).then(function (r) {
              return r.json().then(function (body) {
                if (!r.ok) {
                  var err = new Error((body && body.description) || ('change.js ' + r.status));
                  err.body = body; err.status = r.status;
                  throw err;
                }
                return body;
              });
            });
          }
          // CRO2610: if the key went stale in the meantime (see findLineAgain), look the line up once more and retry
          return write(line.key).catch(function (err) {
            if (!(err && (err.status === 400 || err.status === 404 || err.status === 422))) throw err;
            return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var again = findLineAgain(cart, { key: line.key, variant_id: line.variant_id, properties: line.was || line.properties || {} });
                if (!again || again.key === line.key) throw err;
                return write(again.key);
              });
          });
        }

        // Anchor relabel — ALWAYS. Stamps bundle id / role / paired label
        // onto the plant's REAL line so plant + new pot agree on a real
        // (not in-memory-synthesised) bundle id.
        var anchorOverrides = {
          _io_bundle_id:   bundleId,
          _io_bundle_role: 'plant',
          _io_paired:      pairedFull
        };
        // CRO2610: whether this set has repotting / a tray, read from the cart just before the plant line is written
        var setHasRepot = false, setHasTray = false;
        // the cart as last seen during this change (after the new pot went in): the plant line is looked up in it
        // again before it is written, because adding the pot can give the plant a new key (see findLineAgain)
        var latestCart = null;
        if (resolvedPotColl && !anchorProps._io_pot_collection) {
          anchorOverrides._io_pot_collection = resolvedPotColl;
        }

        // New pot properties — PDP/PLP-shape metadata packed into ONE
        // `_io_pot_spec` JSON property (full spec via the Liquid-emitted
        // potVariantMeta map, picker-image fallback). Mirrors the pack
        // shape used by pot-picker-widget + cv3-plp.
        var newPotProps = { _io_bundle_id: bundleId, _io_bundle_role: 'pot' };
        var pvm = potVariantMeta[String(newVariantId)];
        var potSpec = {};
        if (pvm && window.CV3_SET && window.CV3_SET.potSpec) {
          // CRO2610: the same text the product page writes for this pot: its own fields only, plain values, one key
          // order. (This used to add the chooser's photo when the pot has no cut-out picture and wrote Drainage as a
          // list, so the same pot added here and on the product page made two different lines.)
          var potSpecText = window.CV3_SET.potSpec({ photo: pvm.visual_photo, visualHeight: pvm.visual_height, material: pvm.material, drainage: pvm.drainage, tray: pvm.tray, width: pvm.width_cm, height: pvm.height_cm, inner: pvm.inner_diam });
          if (potSpecText) newPotProps._io_pot_spec = potSpecText;
        } else if (pvm) {
          if (pvm.visual_photo)  potSpec.ph = pvm.visual_photo;
          else if (pickedPotImage) potSpec.ph = pickedPotImage;
          if (pvm.visual_height) potSpec.vh    = String(pvm.visual_height);
          if (pvm.material)      potSpec.mat   = pvm.material;
          if (pvm.drainage)      potSpec.drn   = pvm.drainage;
          if (pvm.tray)          potSpec.tray  = pvm.tray;
          if (pvm.width_cm)      potSpec.w     = String(pvm.width_cm);
          if (pvm.height_cm)     potSpec.h     = String(pvm.height_cm);
          if (pvm.inner_diam)    potSpec.inner = String(pvm.inner_diam);
        } else {
          if (pickedPotImage) potSpec.ph = pickedPotImage;
          console.warn('[cv3-cart-drawer] pickPot: no pot meta for variant ' + newVariantId + ' — Details/visualiser will be sparse.');
        }
        if (!newPotProps._io_pot_spec && Object.keys(potSpec).length) newPotProps._io_pot_spec = JSON.stringify(potSpec);

        function doAddNewPot() {
          return fetch('/cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: newVariantId,
                quantity: anchor.quantity || 1,  // match anchor qty so qty=2 bundles get 2 pots
                properties: newPotProps
              }]
            })
          }).then(function (r) {
            return r.json().then(function (body) {
              if (!r.ok) throw new Error((body && body.description) || ('add.js ' + r.status));
              return body;
            });
          });
        }

        // Remove EVERY pot child of this bundle except the one we just
        // added. This is the fix for the "5 pots on one plant" bug:
        //
        //   Old behaviour — doRemoveOldPot removed exactly ONE pot, the
        //   `oldPotChild` resolved from a cart snapshot taken at picker-
        //   open time. If that key was stale (cart mutated since), the
        //   /cart/change.js silently no-op'd or threw, the old pot
        //   survived, and EVERY swap just stacked another pot onto the
        //   bundle. The customer ended up paying for 5 pots.
        //
        //   New behaviour — re-fetch a guaranteed-fresh /cart.js (so every
        //   line key is current), collect EVERY `role:pot` line sharing
        //   this bundle id, drop the just-added pot's key from that set,
        //   and zero out all the rest in ONE atomic /cart/update.js. This
        //   removes the pot being swapped away AND self-heals a bundle
        //   that already accumulated junk pots — one swap cleans it to
        //   exactly: plant + the new pot.
        function removeStalePots(newPotKey) {
          if (!newPotKey) {
            // Without the new pot's key we can't safely tell it apart from
            // the stale ones — skip removal rather than risk deleting the
            // pot the customer just chose. (add.js always returns a key,
            // so this is a defensive guard, not an expected path.)
            console.warn('[cv3-cart-drawer] removeStalePots — no newPotKey, skipping cleanup');
            return Promise.resolve();
          }
          return fetch('/cart.js', {
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' }
          })
            .then(function (r) {
              if (!r.ok) throw new Error('cart.js ' + r.status);
              return r.json();
            })
            .then(function (freshCart) {
              latestCart = freshCart;
              var updates = {};
              (freshCart.items || []).forEach(function (it) {
                var p = it.properties || {};
                if (p._io_bundle_id === bundleId &&
                    p._io_bundle_role === 'pot' &&
                    it.key !== newPotKey) {
                  updates[it.key] = 0;
                }
                if (p._io_bundle_id === bundleId && p._io_bundle_role === 'repot') setHasRepot = true;
                if (p._io_bundle_id === bundleId && p._io_bundle_role === 'tray') setHasTray = true;
              });
              if (!Object.keys(updates).length) return null; // nothing stale
              return fetch('/cart/update.js', {
                method: 'POST', credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ updates: updates })
              }).then(function (r) {
                return r.json().then(function (body) {
                  if (!r.ok) throw new Error((body && body.description) || ('update.js ' + r.status));
                  if (body && body.items) latestCart = body;
                  return body;
                });
              });
            });
        }

        // FLOW — add the new pot FIRST (a failed add leaves the bundle
        // untouched, never potless), THEN remove every other pot in the
        // bundle, THEN relabel the anchor LAST. The cart page re-syncs via
        // the normal fast soft-reload — the old "stale cart" symptom was
        // really the bundle accumulating un-removed pots (now fixed by
        // removeStalePots), not a caching problem, so no hard reload needed.
        var potAdded = false;
        doAddNewPot()
          .then(function (addResp) {
            potAdded = true;
            var newPotKey = addResp && addResp.items && addResp.items[0] && addResp.items[0].key;
            return removeStalePots(newPotKey);
          })
          .then(function () {
            // CRO2610: the plant line as the product page writes it (label, repotting / tray as yes or no, one key
            // order). relabelLine merges overrides into the line, so the full line is passed as the override.
            var plantNow = findLineAgain(latestCart, anchor) || anchor;
            if (window.CV3_SET && window.CV3_SET.plant) {
              var full = window.CV3_SET.plant({ paired: pairedFull, repot: setHasRepot, tray: setHasTray, id: bundleId, potCollection: anchorOverrides._io_pot_collection }, anchor.properties || {});
              return relabelLine({ key: plantNow.key, variant_id: anchor.variant_id, properties: {}, was: anchor.properties || {} }, full);
            }
            return relabelLine({ key: plantNow.key, variant_id: anchor.variant_id, properties: anchor.properties || {}, was: anchor.properties || {} }, anchorOverrides);
          })
          .then(function () {
            // On /cart the drawer DOM is invisible — skip its re-render,
            // just keep lastCart current for the next action.
            if (cartPageEl) {
              setLoading(false);
              refreshCartData();
              return;
            }
            return refresh();
          })
          .then(function () {
            showCartToast('Added ' + pairedLabel + ' ✓', { duration: 1800 });
            maybeReloadCartPage();
          })
          .catch(function (err) {
            console.error('[cv3-cart-drawer] pickPot failed', err);
            if (potAdded) {
              showCartToast('Pot added — refresh if the old one still shows.', { duration: 3000 });
              if (cartPageEl) { maybeReloadCartPage(); } else { refresh(); }
            } else {
              showCartToast(
                'Couldn’t add the pot — ' + ((err && err.message) || 'please try again') + '.',
                { duration: 3500, isError: true }
              );
              setLoading(false);
            }
          });
      });
    }


    // ─── Cross-widget pairing normalization ────────────────────────────
    // The pot-pairing-widget beta uses a different but related contract:
    //   plant line: `_io_paired` (pot token, non-empty)
    //   child line: `_io_parent_pairing: <plant.key>` (+ _io_service_type)
    // We rewrite those in-memory into the cv3 bundle contract so the same
    // render path groups them naturally:
    //   plant gets `_io_bundle_id = plant.key` + `_io_bundle_role = 'plant'`
    //   child gets `_io_bundle_id = _io_parent_pairing` + role inferred
    // The original cart untouched on the server — we only mutate the local
    // shape used for rendering. Idempotent: items that already carry a
    // bundle_id are left as-is, so cv3-quick-add bundles + widget pairings
    // coexist in the same cart.
    function normalizeWidgetPairings(cart) {
      if (!cart || !cart.items) return cart;
      cart.items.forEach(function (item) {
        var p = item.properties = item.properties || {};
        if (p._io_bundle_id) return; // already cv3-shaped

        // Plant line — has _io_paired with a non-empty pot token AND is
        // NOT a service line. Treat the line's own key as the bundle id.
        var paired = p._io_paired;
        var serviceType = p._io_service_type;
        var parentKey = p._io_parent_pairing;
        if (parentKey) {
          // Child: stamp parent's key as the bundle id, infer role.
          p._io_bundle_id = parentKey;
          if (serviceType === 'repotting')        p._io_bundle_role = 'repot';
          else if (serviceType === 'onsite_repotting') p._io_bundle_role = 'onsite_repot';
          else if (serviceType === 'tray')        p._io_bundle_role = 'tray';
          else                                    p._io_bundle_role = 'pot'; // best-effort
        } else if (paired && String(paired).trim() && !/no decorative pot|nursery|^no$/i.test(String(paired))) {
          // Plant: use the line's own key as the implicit bundle id.
          p._io_bundle_id = item.key;
          p._io_bundle_role = 'plant';
        }
      });
      return cart;
    }

    // A1 — Module-level key the user just interacted with (set by handlers
    // like pickPot, addBundleService, changeQty, applyPhotoUpload right
    // before they call refresh()). On the next render(), we either scroll
    // this key's row back into view (preferred) or fall back to the saved
    // scrollTop. Cleared after each render so the next neutral refresh
    // just preserves position without jumping.
    var lastFocusedKey = null;

    // A1 — Restore scroll position (or scroll the focused item into view)
    // after a re-render. rAF defers until the new DOM is painted so
    // measurements are accurate.
    //
    // Multi-render race: a mutation like pickPot fires multiple fetches in
    // sequence (change.js + add.js + the interceptor dispatch), each of
    // which queues a refresh → render. The FIRST render runs before the
    // new pot child has been added; the LAST render is the one that has
    // the final cart. lastFocusedKey must survive intermediate renders
    // (don't clear when the key isn't found yet — the next render with
    // the final DOM will find it). A 4s safety timeout clears the key
    // so unrelated future renders don't keep force-scrolling.
    var lastFocusedKeyExpiry = 0;
    function setFocusedKey(key) {
      lastFocusedKey = key;
      lastFocusedKeyExpiry = Date.now() + 4000;
    }
    function restoreScrollPositionAfterRender(savedScrollTop) {
      requestAnimationFrame(function () {
        try {
          // Expire stale keys.
          if (lastFocusedKey && Date.now() > lastFocusedKeyExpiry) {
            lastFocusedKey = null;
          }
          // Prefer scrolling the line the user just touched into view.
          // We compute the offset manually (rather than scrollIntoView)
          // because scrollIntoView can scroll the WRONG ancestor on iOS
          // (sometimes scrolls the window, sometimes the drawer body).
          // Direct scrollTop assignment on els.body is deterministic.
          if (lastFocusedKey && els.items && els.body) {
            var sel = '[data-cv3-cd-key="' + (typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(lastFocusedKey) : lastFocusedKey.replace(/"/g, '\\"')) + '"]';
            var el = els.items.querySelector(sel);
            if (el) {
              var bodyRect = els.body.getBoundingClientRect();
              var elRect = el.getBoundingClientRect();
              // Delta from the body's top to the element's top, applied
              // on top of the current scrollTop. 12px breathing room.
              var target = els.body.scrollTop + (elRect.top - bodyRect.top) - 12;
              els.body.scrollTop = Math.max(0, target);
              lastFocusedKey = null;   // success — release the latch
              return;
            }
            // NOT found yet — don't clear lastFocusedKey. The next render
            // (likely the one with the final cart) may find it.
          }
          // Fallback: restore the previous scrollTop verbatim. Skip if 0
          // (the cart was at top anyway) so we don't fight a real scroll
          // restore on a later render.
          if (savedScrollTop && savedScrollTop > 0 && els.body) {
            els.body.scrollTop = savedScrollTop;
          }
        } catch (_) { /* best-effort — never break render() */ }
      });
    }

    function render(cart) {
      // A1 — Capture scroll position BEFORE we destroy the items list so
      // we can restore it after the new DOM is appended. Without this,
      // every cart mutation (pickPot, addBundleService, qty change, etc.)
      // dumps the user back at the top of a long cart.
      var savedScrollTop = (els.body && typeof els.body.scrollTop === 'number')
        ? els.body.scrollTop : null;

      cart = normalizeWidgetPairings(cart);
      lastCart = cart;
      dropLoneGiftLines(cart);
      var count = cart.item_count || 0;
      els.count.textContent = count;

      // Compute cart-wide parity gates ONCE per render — buildPrimaryRowHtml
      // reads these closures to decide whether to stamp the 6-month-
      // protection pill on each potted-plant row, and the banner inject
      // below uses cartHasPreorder. Both are O(n) over items, cheap at
      // typical cart sizes but worth not running per-row.
      var gpid = cv3LineMeta.guarantee_pid;
      cartHasGuarantee = !!(gpid && (cart.items || []).some(function (it) {
        return Number(it.product_id) === Number(gpid);
      }));
      var ppids = cv3LineMeta.preorder_pids || [];
      cartHasPreorder = !!(ppids.length && (cart.items || []).some(function (it) {
        return ppids.indexOf(Number(it.product_id)) !== -1;
      }));
      // Surface on the root so other modules (delivery-date picker, etc.)
      // can react via CSS / JS selectors. Mirrors the cart-page
      // [data-cv3-cp-has-preorder] hook in cv3-cart-page.liquid.
      if (root) {
        if (cartHasPreorder) root.setAttribute('data-cv3-cd-has-preorder', '');
        else root.removeAttribute('data-cv3-cd-has-preorder');
      }
      // Drawer-side preorder banner — show/hide based on the gate. Banner
      // markup is in the static drawer template (see below); we just
      // toggle its hidden attribute here.
      if (els.preorderBanner) {
        if (cartHasPreorder) els.preorderBanner.removeAttribute('hidden');
        else els.preorderBanner.setAttribute('hidden', '');
      }

      // Freeship strip
      if (els.freeship && freeshipThreshold > 0) {
        var rem = Math.max(0, freeshipThreshold - cart.total_price);
        var pct = Math.min(100, Math.round((cart.total_price / freeshipThreshold) * 100));
        els.freeshipFill.style.width = pct + '%';
        if (rem === 0) {
          els.freeship.classList.add('is-unlocked');
          els.freeshipText.innerHTML = "🎉 You've unlocked free delivery!";
        } else {
          els.freeship.classList.remove('is-unlocked');
          els.freeshipText.innerHTML = "You're <strong>" + formatMoney(rem) + "</strong> away from free delivery.";
        }
      }

      if (count === 0) {
        els.items.setAttribute('hidden', '');
        els.empty.removeAttribute('hidden');
        els.foot.setAttribute('hidden', '');
        return;
      }
      els.empty.setAttribute('hidden', '');
      els.foot.removeAttribute('hidden');
      els.items.removeAttribute('hidden');

      // ─── Bundle grouping ───────────────────────────────────────────
      // The PLP / PDP quick-add stamps `_io_bundle_id` on every line
      // item in a styled-set (plant + pot + repot + tray). Walk the
      // cart, build groups, then render each group as ONE visual card
      // with the plant as the anchor and pot/repot/tray as nested rows.
      //
      // Items WITHOUT _io_bundle_id render standalone (the cart's
      // pre-CRO behaviour — no grouping, one row each).
      var bundles = {};        // bundle_id → { anchor, children: [...] }
      var standalone = [];     // items with no bundle id
      var bundleOrder = [];    // preserve first-appearance order
      (cart.items || []).forEach(function (item) {
        var props = item.properties || {};
        var bid = props._io_bundle_id;
        // CRO2610: a planter box set (plant sets page) is not a plant + pot set. Its lines carry _io_box_id and
        // stay together under it: the box is the card's first row, the plants and the repotting are listed in it
        // (buildBoxLi). Without its box line the others fall out as lines on their own, by the guard below.
        if (props._io_box_id) {
          var boxKey = 'box:' + props._io_box_id;
          if (!bundles[boxKey]) {
            bundles[boxKey] = { anchor: null, children: [] };
            bundleOrder.push(boxKey);
          }
          if (props._io_box_role === 'box' && !bundles[boxKey].anchor) bundles[boxKey].anchor = item;
          else bundles[boxKey].children.push(item);
          return;
        }
        if (!bid) {
          standalone.push(item);
          return;
        }
        if (!bundles[bid]) {
          bundles[bid] = { anchor: null, children: [] };
          bundleOrder.push(bid);
        }
        // The "plant" role (explicit) — or any item with _io_paired —
        // becomes the anchor. Everything else stacks below.
        var role = props._io_bundle_role;
        if (role === 'plant' || (!bundles[bid].anchor && props._io_paired)) {
          bundles[bid].anchor = item;
        } else {
          bundles[bid].children.push(item);
        }
      });
      // A3 — Defensive guard: if a bundle has no plant anchor (e.g. data
      // corruption, an orphaned pot/repot line whose plant was removed in
      // another tab, or any future ID-mismatch bug), don't render an empty
      // bundle card OR mistakenly promote a non-plant child to anchor (a
      // pot rendered as the bundle's main row would look completely wrong
      // and hide the upsell pills on real eligible plants elsewhere in
      // the cart). Push the orphan children to the standalone list and
      // drop the empty bundle. The deterministic bundle ID from A2 makes
      // this nearly impossible to hit, but the guard is cheap insurance.
      var orphanBundleIds = [];
      bundleOrder.forEach(function (bid) {
        var b = bundles[bid];
        if (b.anchor) return;
        // No anchor — promote ONLY if the candidate looks like a plant
        // (has _io_paired or no _io_bundle_role at all). Otherwise treat
        // each child as standalone.
        var promoteIdx = -1;
        for (var ci = 0; ci < b.children.length; ci++) {
          var cp = b.children[ci].properties || {};
          var cr = cp._io_bundle_role;
          if (cr === 'plant' || (!cr && cp._io_paired)) { promoteIdx = ci; break; }
        }
        if (promoteIdx >= 0) {
          b.anchor = b.children.splice(promoteIdx, 1)[0];
        } else {
          // Genuine orphan bundle — children get promoted to standalone.
          b.children.forEach(function (c) { standalone.push(c); });
          b.children = [];
          orphanBundleIds.push(bid);
        }
      });
      if (orphanBundleIds.length) {
        bundleOrder = bundleOrder.filter(function (bid) {
          return orphanBundleIds.indexOf(bid) === -1;
        });
      }

      // ─── Render ────────────────────────────────────────────────────
      // Build a flat work list ordered NEWEST-FIRST. Each card (bundle or
      // standalone) is positioned by its most-recently-added line: Shopify
      // orders cart.items oldest→newest, so a higher index = added later.
      // A bundle's recency is the max index among its lines (anchor +
      // children) — so adding a pot to an existing bundle floats that
      // whole bundle back to the top. Bundles and singles are intermixed
      // purely by recency; we no longer cluster "all bundles, then all
      // singles".
      //
      // For small carts (≤ 50 rows) we render synchronously into a
      // fragment in one shot. For larger carts we render incrementally —
      // first paint the initial 20 rows, then yield to the main thread via
      // rAF and append the rest in batches of 20.
      var itemIndex = {};
      (cart.items || []).forEach(function (it, idx) { itemIndex[it.key] = idx; });

      var workList = [];
      bundleOrder.forEach(function (bid) {
        var b = bundles[bid];
        if (!b.anchor) return;
        var recency = itemIndex[b.anchor.key] || 0;
        b.children.forEach(function (c) {
          var ci = itemIndex[c.key] || 0;
          if (ci > recency) recency = ci;
        });
        workList.push({ anchor: b.anchor, children: b.children, recency: recency });
      });
      standalone.forEach(function (item) {
        workList.push({ anchor: item, children: [], recency: itemIndex[item.key] || 0 });
      });
      // Newest-added card first.
      workList.sort(function (a, b) { return b.recency - a.recency; });

      els.items.innerHTML = '';
      var SYNC_LIMIT = 50;
      var INITIAL_BATCH = 20;
      var BATCH_SIZE = 20;

      if (workList.length <= SYNC_LIMIT) {
        // Small cart — render the whole list in one shot via DocumentFragment.
        var frag = document.createDocumentFragment();
        workList.forEach(function (w) { frag.appendChild(buildItemLi(w.anchor, w.children)); });
        els.items.appendChild(frag);
        restoreScrollPositionAfterRender(savedScrollTop);
      } else {
        // Big cart — render the first INITIAL_BATCH rows immediately so the
        // top of the cart is interactive ASAP, then append the rest in rAF
        // batches. Each batch ends with one append to minimise reflows.
        var firstFrag = document.createDocumentFragment();
        var i = 0;
        for (; i < Math.min(INITIAL_BATCH, workList.length); i++) {
          firstFrag.appendChild(buildItemLi(workList[i].anchor, workList[i].children));
        }
        els.items.appendChild(firstFrag);
        // A1 — restore scroll position once the INITIAL batch is in, so the
        // user sees the right area immediately. The remaining rAF batches
        // append below the fold without disturbing the visible area.
        restoreScrollPositionAfterRender(savedScrollTop);
        function renderBatch() {
          if (i >= workList.length) return;
          var f = document.createDocumentFragment();
          var stop = Math.min(i + BATCH_SIZE, workList.length);
          for (; i < stop; i++) {
            f.appendChild(buildItemLi(workList[i].anchor, workList[i].children));
          }
          els.items.appendChild(f);
          if (i < workList.length) requestAnimationFrame(renderBatch);
        }
        requestAnimationFrame(renderBatch);
      }

      // Subtotal uses items_subtotal_price (cart total BEFORE discount) so
      // the discount line below is meaningful. Falls back to total_price.
      var sub = (cart.items_subtotal_price != null) ? cart.items_subtotal_price : (cart.total_price || 0);
      els.subtotal.textContent = formatMoney(sub);

      // Discount line — CART-LEVEL ONLY. Mirror of cv3-cart-page.liquid's
      // summary fix (see the comment above the per-app loop in that file
      // for the full gotcha explanation). `cart.total_discount` is the
      // COMBINED line+cart total, and subtracting it from the subtotal
      // double-counts line allocations that are already baked into
      // `items_subtotal_price`. We want only the cart-level portion here so
      // Subtotal − discount = Total. Sum `total_allocated_amount` across
      // cart_level_discount_applications; the row's name uses the first
      // application's title. The single-row drawer footer can't show every
      // app individually — multi-app support would need a markup change.
      var cartLevelDisc = 0;
      var apps = cart.cart_level_discount_applications || [];
      for (var ai = 0; ai < apps.length; ai++) {
        cartLevelDisc += (apps[ai].total_allocated_amount || 0);
      }
      if (cartLevelDisc > 0 && els.discRow) {
        var name = (apps[0] && apps[0].title) || '';
        els.discName.textContent = name ? '· ' + name : '';
        els.discAmt.textContent = '−' + formatMoney(cartLevelDisc);
        els.discRow.removeAttribute('hidden');
      } else if (els.discRow) {
        els.discRow.setAttribute('hidden', '');
      }

      // Upsells — manual override stays in DOM as-is; otherwise lazy-fetch
      // recommendations based on the first product in the cart.
      maybeRenderUpsells(cart);

      // Shipping row: only show if a shipping_rate is already known
      // (Shopify usually returns it for /cart only after checkout step 2).
      // We keep this hook so when shipping IS known, it appears; otherwise
      // the row stays hidden and the "calculated at checkout" note shows.
      if (els.shipRow && cart.shipping_address && cart.requires_shipping) {
        // No reliable shipping cost on /cart.js — leave hidden by default.
        els.shipRow.setAttribute('hidden', '');
      }
    }

    // Build one line-item <li> — optionally with nested bundle children
    // (pot, repotting, tray) under the main info column.
    // Build a "primary row" — same shape used for plant anchor and for the
    // pot child when it's promoted to a same-size sibling row. Image left,
    // info middle, price right.
    function buildPrimaryRowHtml(item, opts) {
      opts = opts || {};
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
        : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cv3-cd__item-variant">' + escapeHtml(item.variant_title) + '</div>'
        : '';
      var roleTag = opts.roleLabel
        ? '<div class="cv3-cd__item-role">' + escapeHtml(opts.roleLabel) + '</div>'
        : '';

      // ─── Legacy parity badges + metadata (mirror of cv3-cart-page-row) ──
      // Same four blocks the Liquid row renders, gated on the same fields.
      // Preorder + guarantee require server-side context (product.tags /
      // cart-wide check) that /cart.js doesn't carry → fed from the
      // cv3LineMeta side channel (cv3-line-meta.liquid) + the cartHas*
      // closures set in render(). Selling plan + visible properties are
      // straight off the cart line.
      var preorderHtml = '';
      if (cv3LineMeta.preorder_pids.indexOf(Number(item.product_id)) !== -1) {
        preorderHtml = '<div class="cv3-cd__badge cv3-cd__badge--preorder">Preorder</div>';
      }
      var planHtml = '';
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.name) {
        planHtml = '<div class="cv3-cd__plan">' + escapeHtml(item.selling_plan_allocation.selling_plan.name) + '</div>';
      }
      var guaranteeHtml = '';
      if (cartHasGuarantee && item.product_type === 'Potted plant') {
        guaranteeHtml = '<a class="cv3-cd__badge cv3-cd__badge--guarantee" href="/pages/6-month-protection">6-month protection</a>';
      }
      // Customer-facing line item properties (gift notes, engraving, etc.).
      // Skip internal keys (anything starting with `_` — the _io_* bundle
      // namespace + _is* widget keys). File-upload values (URLs containing
      // /uploads/) render as a download link. Mirror of the Liquid block
      // in cv3-cart-page-row.liquid.
      var propsHtml = '';
      var ip = item.properties || {};
      var ipKeys = (typeof ip === 'object') ? Object.keys(ip) : [];
      var visibleProps = ipKeys.filter(function (k) {
        if (!k || k.charAt(0) === '_') return false;
        var v = ip[k];
        return v != null && String(v).length > 0;
      });
      if (visibleProps.length) {
        propsHtml = '<ul class="cv3-cd__props">';
        visibleProps.forEach(function (k) {
          var v = String(ip[k]);
          var valHtml;
          if (v.indexOf('/uploads/') !== -1) {
            var fname = v.split('/').pop();
            valHtml = '<a href="' + escapeHtml(v) + '" target="_blank" rel="noopener">' + escapeHtml(fname) + '</a>';
          } else {
            valHtml = escapeHtml(v);
          }
          propsHtml +=
            '<li><strong>' + escapeHtml(k) + ':</strong> ' + valHtml + '</li>';
        });
        propsHtml += '</ul>';
      }
      var parityBlocksHtml = preorderHtml + planHtml + guaranteeHtml + propsHtml;
      var nameTag = opts.linkUrl
        ? '<a class="cv3-cd__item-name" href="' + escapeHtml(opts.linkUrl) + '">' + escapeHtml(item.product_title || '') + '</a>'
        : '<div class="cv3-cd__item-name">' + escapeHtml(item.product_title || '') + '</div>';
      var rightX = opts.childRemove
        ? '<button type="button" class="cv3-cd__row-x" data-cv3-cd-child-remove="' + item.key + '" aria-label="Remove this item from the bundle">' +
            '<span aria-hidden="true">×</span>' +
          '</button>'
        : '';
      // Optional raw HTML rendered INSIDE row-info, below the variant.
      var infoExtrasHtml = opts.infoExtras
        ? '<div class="cv3-cd__row-info-extras">' + opts.infoExtras + '</div>'
        : '';

      // ─── Price stack: original (strike) + final + per-discount labels.
      // Shopify's cart item carries:
      //   - original_line_price : cents, BEFORE any discount allocations
      //   - final_line_price    : cents, AFTER discount allocations
      //   - line_level_discount_allocations : array of { amount, discount_application: { title, type } }
      // We show the strike + sale colour only when there's an actual delta,
      // and list each named discount below so customers see where each
      // discount came from.
      var origLine  = (item.original_line_price != null) ? item.original_line_price : (item.final_line_price || 0);
      var finalLine = item.final_line_price || 0;
      var hasDiscount = origLine > finalLine;
      var discountLines = '';
      var allocs = item.line_level_discount_allocations || item.discount_allocations || [];
      if (allocs.length) {
        discountLines = '<div class="cv3-cd__price-discounts">';
        allocs.forEach(function (a) {
          var amt = a.amount || (a.discount_amount && a.discount_amount.cents) || 0;
          if (!amt) return;
          var name = (a.discount_application && a.discount_application.title)
            || a.title
            || 'Discount';
          discountLines +=
            '<span class="cv3-cd__price-discount-line" title="' + escapeHtml(name) + '">' +
              escapeHtml(name) + ' −' + formatMoney(amt) +
            '</span>';
        });
        discountLines += '</div>';
      }
      var priceHtml =
        '<div class="cv3-cd__price-stack">' +
          (hasDiscount
            ? '<span class="cv3-cd__price-strike">' + formatMoney(origLine) + '</span>'
            : '') +
          '<div class="cv3-cd__row-price cv3-cd__price-final' +
            (hasDiscount ? ' cv3-cd__price-final--discounted' : '') + '">' +
            formatMoney(finalLine) +
          '</div>' +
          discountLines +
        '</div>';

      return (
        '<div class="cv3-cd__row' + (opts.rowClass ? ' ' + opts.rowClass : '') + '">' +
          '<div class="cv3-cd__row-img">' + imgHtml + '</div>' +
          '<div class="cv3-cd__row-info">' +
            roleTag +
            nameTag +
            variant +
            parityBlocksHtml +
            infoExtrasHtml +
          '</div>' +
          '<div class="cv3-cd__row-right">' +
            priceHtml +
            rightX +
          '</div>' +
        '</div>'
      );
    }

    // CRO2610: a planter box set from the plant sets page. One box, each plant once with how many of it go into
    // the box, and the repotting: plain cart lines tied by _io_box_id (assets/cro2610-set.js, boxItems). The card
    // shows the box, lists what goes into it and removes it as one. No quantity button (one box per set: the same
    // plant can be in it several times and Shopify checks stock line by line when a quantity is changed) and no
    // pot or tray offers. Mirror on the cart page: snippets/cv3-cart-page-box.liquid.
    function buildBoxLi(box, lines) {
      var li = document.createElement('li');
      li.className = 'cv3-cd__item cv3-cd__item--bundle tw-boxset';
      li.dataset.cv3CdKey = box.key;
      var roleOf = function (c) { return (c.properties || {})._io_box_role || ''; };
      var plants = lines.filter(function (c) { return roleOf(c) === 'plant'; })
        .sort(function (a, b) { return (b.original_price || 0) - (a.original_price || 0); });
      var rest = lines.filter(function (c) { return roleOf(c) !== 'plant'; });
      var count = plants.reduce(function (n, c) { return n + (c.quantity || 0); }, 0);
      var preorder = (cv3LineMeta && cv3LineMeta.preorder_pids) || [];
      var headHtml = buildPrimaryRowHtml(box, {
        rowClass: 'cv3-cd__row--anchor',
        infoExtras: '<div class="cv3-cd__item-variant">Planter box set \u00b7 ' + (count === 1 ? '1 plant' : count + ' plants') + ', listed below</div>'
      });
      var listHtml = '<div class="cv3-cd__svcs" data-cv3-cd-svcs>';
      plants.concat(rest).forEach(function (c) {
        var r = roleOf(c), label;
        if (r === 'plant') {
          label = (c.quantity || 1) + ' \u00d7 ' + (c.product_title || '') + (preorder.indexOf(Number(c.product_id)) !== -1 ? ' (pre-order)' : '');
        } else {
          label = labelForChild(c, r === 'repot' ? 'repot' : '');
        }
        listHtml +=
          '<div class="cv3-cd__svc cv3-cd__svc--on" data-cv3-cd-child-key="' + c.key + '">' +
            renderChildThumb(c, r === 'repot' ? 'repot' : '') +
            '<span class="cv3-cd__svc-name">' + escapeHtml(label) + '</span>' +
            '<span class="cv3-cd__svc-price">+' + formatMoney(c.final_line_price) + '</span>' +
            '<button type="button" class="cv3-cd__svc-x" data-cv3-cd-child-remove="' + c.key + '" aria-label="Remove from this set">' +
              '<span aria-hidden="true">×</span>' +
            '</button>' +
          '</div>';
      });
      listHtml += '</div>';
      li.innerHTML =
        headHtml +
        listHtml +
        '<div class="cv3-cd__bundle-total">' +
          '<span class="cv3-cd__bundle-total-label">Set total</span>' +
          '<span class="cv3-cd__bundle-total-amt">' + formatMoney(bundleTotal(box, lines)) + '</span>' +
        '</div>' +
        '<button type="button" class="cv3-cd__remove-link" data-cv3-cd-remove data-cv3-cd-children="' +
          lines.map(function (c) { return c.key; }).join(',') + '">Remove set</button>';
      return li;
    }

    // CRO2610 gift note: the $0 line that follows the cart page's Gift message box (snippets/cv3-cart-page.liquid,
    // giftNoteSync). Drawn as a small row with the message: no quantity buttons, no ×. Same row as
    // snippets/cv3-cart-page-giftnote.liquid.
    function isGiftLine(item) { return !!(item && item.properties && item.properties._tw_gift_note); }
    function buildGiftLi(item) {
      var li = document.createElement('li');
      li.className = 'cv3-cd__item tw-giftline';
      li.dataset.cv3CdKey = item.key;
      var msg = (item.properties || {})['Gift message'] || '';
      var title = String(item.product_title || 'Gift note').replace(/^\+\s*/, '');
      var price = Number(item.final_line_price || 0);
      li.innerHTML =
        '<span class="tw-giftline__icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3.5 6.5 8.5 6.5 8.5-6.5"/></svg></span>' +
        '<span class="tw-giftline__body">' +
          '<span class="tw-giftline__title">' + escapeHtml(title) + '</span>' +
          (msg ? '<span class="tw-giftline__msg">\u201c' + escapeHtml(msg) + '\u201d</span>' : '') +
          '<span class="tw-giftline__hint">To change it, edit the gift message on the cart page.</span>' +
        '</span>' +
        '<span class="tw-giftline__price">' + (price > 0 ? escapeHtml(formatMoney(price)) : 'Free') + '</span>';
      return li;
    }
    // A gift note never stays in a cart on its own (the last other line was removed): take it out.
    var giftDropping = false;
    function dropLoneGiftLines(cart) {
      var items = (cart && cart.items) || [];
      if (giftDropping || !items.length || !items.every(isGiftLine)) return;
      giftDropping = true;
      items.reduce(function (p, it) { return p.then(function () { return changeLine({ id: it.key, quantity: 0 }); }); }, Promise.resolve())
        .catch(function () {})
        .then(function () { giftDropping = false; });
    }
    // One line's quantity or properties, from outside (the cart page's gift note): same refresh as the quantity
    // buttons (drawer redrawn, cart page lines and totals swapped in place from the same response).
    function changeLine(body) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(Object.assign({}, body, cartSectionParams()))
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, body: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'change failed');
          render(res.body);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cv3-cart-drawer:line' } }));
          if (cartPageEl) maybeReloadCartPage(sectionHtmlFromCartResponse(res.body));
          return res.body;
        });
    }

    function buildItemLi(item, children) {
      if (isGiftLine(item)) return buildGiftLi(item);
      // CRO2610: a planter box set has its own card (a box left with nothing in it is an ordinary line again)
      if (item.properties && item.properties._io_box_id && item.properties._io_box_role === 'box' && children && children.length) {
        return buildBoxLi(item, children);
      }
      var li = document.createElement('li');
      var isPottedPlant = (item.product_type === 'Potted plant');
      var props = item.properties || {};
      // "Bundle-eligible" = a potted plant that EITHER already has children
      // (proper bundle) OR was stamped with the inline-upsell metadata
      // (_io_pot_collection / _io_repot_variant_id / _io_tray_variant_id)
      // so we can surface the same Change-pot / Add-pot / Add-service UI on
      // a standalone plant line. Non-potted-plant items always render flat.
      // Fallback: if this potted-plant line has no `_io_pot_collection`
      // (e.g. added via legacy/direct ATC outside the cv3 quick-add),
      // look it up by line key from the Liquid-emitted map.
      if (isPottedPlant && !props._io_pot_collection && item.key && lineKeyPotCollection[item.key]) {
        props._io_pot_collection = lineKeyPotCollection[item.key];
      }
      var hasStampedUpsells = !!(props._io_pot_collection || props._io_repot_variant_id || props._io_tray_variant_id);
      var actAsBundle = isPottedPlant && ((children && children.length) || hasStampedUpsells);
      li.className = 'cv3-cd__item' + (actAsBundle ? ' cv3-cd__item--bundle' : '');
      li.dataset.cv3CdKey = item.key;

      // Separate the pot from the smaller add-on services. The pot gets a
      // full primary row beneath the plant (same size = same visual weight);
      // services render as a compact dot-list below.
      var potChild = (children || []).filter(function (c) {
        return c.properties && c.properties._io_bundle_role === 'pot';
      })[0];
      var services = (children || []).filter(function (c) {
        return !c.properties || c.properties._io_bundle_role !== 'pot';
      });

      // ─── Determine "compact" treatment EARLY so we can build the
      // info_extras (qty stepper + "Bundled" toggle) before the anchor
      // row, then pass them into buildPrimaryRowHtml so they render
      // INSIDE row-info (below the variant), not as a separate sibling
      // block under the image.
      var _svcCountEarly = (children || []).filter(function (c) {
        return !c.properties || c.properties._io_bundle_role !== 'pot';
      }).length;
      var _useCompactEarly = isPottedPlant && ((children && children.length) || hasStampedUpsells)
        && (potChild || _svcCountEarly > 0);
      // Bundle qty scaling — when the user bumps qty on a bundle anchor, ALL
      // child lines (pot, repot, tray) need to ratchet with it. Otherwise
      // qty=2 ships 2 plants crammed into 1 pot with 1 repotting service,
      // which is physically nonsensical. We stamp the child keys onto the
      // qty buttons themselves so the delegated click handler can read them
      // and route through batchUpdate() instead of single-line changeQty().
      //
      // Special case: if any child is an `onsite_repot` (1 photo upload per
      // visit), we CAP the bundle at qty=1 and disable the + button with a
      // tooltip — scaling onsite-repot via the stepper would invisibly fan
      // one photo across multiple visits, which fulfilment can't honour.
      // For multi-unit orders the customer adds the bundle again as a
      // second composition.
      var _bundleChildKeys = (children || [])
        .map(function (c) { return c.key; })
        .filter(Boolean);
      var _hasOnsiteRepot = (children || []).some(function (c) {
        return (c.properties || {})._io_bundle_role === 'onsite_repot';
      });
      var _bundleChildAttr = _bundleChildKeys.length
        ? ' data-cv3-cd-bundle-children="' + escapeHtml(_bundleChildKeys.join(',')) + '"'
        : '';
      var _qtyUpDisabled  = _hasOnsiteRepot;  // cap at 1 when onsite present
      var _qtyUpTitle     = _hasOnsiteRepot
        ? 'Onsite repotting includes one photo per visit. Add the bundle again to order another.'
        : '';
      var _qtyTipAttr     = _qtyUpTitle ? ' data-cv3-tip="' + escapeHtml(_qtyUpTitle) + '"' : '';
      // Qty stepper — always part of info_extras (mirrors cart-page layout).
      var _qtyInfoHtml =
        '<div class="cv3-cd__qty">' +
          '<button type="button" class="cv3-cd__qty-btn" data-cv3-cd-qty="' + (item.quantity - 1) + '"' + _bundleChildAttr + ' aria-label="Decrease quantity"' + (item.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
          '<span class="cv3-cd__qty-val">' + item.quantity + '</span>' +
          '<button type="button" class="cv3-cd__qty-btn" data-cv3-cd-qty="' + (item.quantity + 1) + '"' + _bundleChildAttr + _qtyTipAttr + ' aria-label="Increase quantity"' + (_qtyUpDisabled ? ' disabled title="' + escapeHtml(_qtyUpTitle) + '"' : '') + '>+</button>' +
        '</div>';
      // "Bundled ▾" toggle — only when there's something to collapse.
      var _bundledToggleHtml = '';
      if (_useCompactEarly) {
        var _meta =
          (potChild ? escapeHtml((potChild.product_title || '').slice(0, 24)) : '') +
          (potChild && _svcCountEarly > 0 ? ' · ' : '') +
          (_svcCountEarly > 0 ? _svcCountEarly + ' svc' + (_svcCountEarly > 1 ? 's' : '') : '');
        // <span role="button"> (not <button>) — escapes Tumbleweed's
        // global button styling that bled through and made this look
        // chunky/CTA-like. Keyboard support handled by the delegated
        // bundle-toggle click handler (which fires on `click` regardless
        // of source element) plus the keydown listener below.
        // CRO2610: a set stays folded (with every part listed the card got too long), but the fold now says what
        // is in it: the pot's own picture and the names, cut off by the width of the card, never by a letter count
        // ("Bundled Z…" before). It sits under the plant as a full-width row; a tap opens the rows with each part's
        // price and the controls to change or remove it.
        var _setParts = [];
        if (potChild) _setParts.push(potChild.product_title || '');
        var _setWord = { repot: 'Repotting', tray: 'Tray', onsite_repot: 'Onsite repotting' };
        (children || []).forEach(function (c) {
          if (c === potChild) return;
          _setParts.push(_setWord[(c.properties || {})._io_bundle_role] || c.product_title || '');
        });
        var _setPic = potChild && potChild.image ? String(potChild.image) : '';
        var _setThumb = _setPic
          ? '<img class="tw-settoggle__thumb" src="' + escapeHtml(_setPic + (_setPic.indexOf('?') > -1 ? '&' : '?') + 'width=96') + '" alt="" width="34" height="34" loading="lazy">'
          : '';
        _meta = '';
        _bundledToggleHtml =
          '<span class="cv3-cd__details-toggle tw-settoggle" data-cv3-cd-bundle-toggle role="button" tabindex="0" aria-expanded="false">' +
            _setThumb +
            '<span class="tw-settoggle__text"><span class="tw-settoggle__with">With</span> ' + escapeHtml(_setParts.join(' + ')) + '</span>' +
            (_meta ? '<span class="cv3-cd__details-toggle-meta">' + _meta + '</span>' : '') +
            '<svg class="cv3-cd__details-toggle-chev" viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>' +
          '</span>';
      }
      var _anchorInfoExtras = _qtyInfoHtml;          // the set's fold is its own row under the plant now

      // Plant anchor row (always shown). Plant's OWN price on the right —
      // no longer the bundle total, so the customer can read each line.
      var anchorHtml = buildPrimaryRowHtml(item, {
        linkUrl: item.url,
        rowClass: 'cv3-cd__row--anchor',
        infoExtras: _anchorInfoExtras
      });

      // Pot row (only when bundle has a pot child). Same primary-row shape.
      var potHtml = (actAsBundle && potChild)
        ? buildPrimaryRowHtml(potChild, {
            linkUrl: potChild.url,
            roleLabel: 'Paired pot',
            rowClass: 'cv3-cd__row--pot',
            childRemove: true
          })
        : '';

      // "Add a decorative pot" CTA — shows on any potted-plant line that
      // qualifies for the pot picker. The resolvePotCollectionForLine
      // helper guarantees a handle for every potted plant via the
      // 3-tier fallback (metafield → collections → 'planters'), so we
      // gate on isPottedPlant + actAsBundle instead of on the stamped
      // property alone. Stamping the resolved handle onto the button
      // lets the click handler skip the lookup entirely.
      // "Add a pot?" + "Onsite repotting" pills — clean two-pill layout
      // with tooltip helpers, mirroring snippets/cv3-cart-page-item.liquid.
      // The dashed prompt-box is gone; pills carry the info via the ?
      // popover instead so the row reads as tappable affordances, not a
      // CTA card-within-a-card.
      var gapHtml = '';
      var resolvedColl = isPottedPlant ? resolvePotCollectionForLine(item) : '';
      if (actAsBundle && !potChild && resolvedColl) {
        // Resolve onsite-repot variant for THIS plant (fallback to S if
        // plant_size isn't resolvable — same behavior as cart page).
        var onsiteDef = resolveOnsiteRepotForAnchor(item, false);
        var showOnsitePill = !!(onsiteDef && (window.cv3CdConfig || {}).showServicesUpsell !== false);
        // Also suppress if the bundle already has a repot child.
        if (showOnsitePill && (children || []).some(function (c) {
          var r = (c.properties || {})._io_bundle_role;
          return r === 'repot' || r === 'onsite_repot';
        })) {
          showOnsitePill = false;
        }
        var bidHere = props._io_bundle_id || '';
        gapHtml =
          '<div class="cv3-cd__gap' + (showOnsitePill ? ' cv3-cd__gap--multi' : '') + '">' +
            '<div class="cv3-cd__gap-actions">' +
              '<span class="cv3-cd__tip-wrap">' +
                '<button type="button" class="cv3-cd__gap-btn" ' +
                        'data-cv3-cd-change-pot="' + item.key + '" ' +
                        'data-cv3-cd-pot-coll="' + escapeHtml(resolvedColl) + '">+ Add a pot</button>' +
                '<button type="button" class="cv3-cd__tip-btn" aria-label="What is this?" ' +
                        'data-cv3-tip="Ships in a plastic grow pot. Add a decorative planter — we have ceramic, stoneware, and self-watering options sized to your plant.">?</button>' +
              '</span>' +
              (showOnsitePill
                ? '<span class="cv3-cd__tip-wrap">' +
                    '<button type="button" class="cv3-cd__gap-btn cv3-cd__gap-btn--ghost" ' +
                            'data-cv3-cd-svc-add="onsite_repot" ' +
                            'data-cv3-cd-bundle-id="' + escapeHtml(bidHere) + '" ' +
                            'data-cv3-cd-svc-variant="' + onsiteDef.id + '">' +
                      '+ Onsite repotting <span class="cv3-cd__gap-btn-price">+' + formatMoney(onsiteDef.price) + '</span>' +
                    '</button>' +
                    '<button type="button" class="cv3-cd__tip-btn" aria-label="What is this?" ' +
                            'data-cv3-tip="We come to you — repot your new plant into a pot you already have at home. After checkout you\'ll be asked to upload a photo of your pot so our team brings the right tools and soil.">?</button>' +
                  '</span>'
                : '') +
            '</div>' +
          '</div>';
      }

      // ─── Services shelf (potted-plant lines, with or without bundle) ─
      // Repotting copy is contextual:
      //   - Bundle has a pot → "Add repotting service" (standard repot into
      //     the pot we're shipping). Variant uses the size's repot id.
      //   - Bundle has NO pot → "Add onsite repotting" (we visit the
      //     customer's home and repot into their own pot — needs a photo).
      //     Same underlying variant ID; the role gets stamped as
      //     `onsite_repot` so cart admin / fulfilment can tell them apart.
      // Tray upsell still requires a pot — pointless otherwise.
      var svcHtml = '';
      var svcNudgeHtml = '';
      if (actAsBundle) {
        var bid = props._io_bundle_id;
        var hasRepot = services.some(function (c) {
          var r = (c.properties || {})._io_bundle_role;
          return r === 'repot' || r === 'onsite_repot';
        });
        var hasTray  = services.some(function (c) { return (c.properties || {})._io_bundle_role === 'tray'; });
        var repot = resolveRepotForLine(item);
        var tray  = resolveTrayForLine(item);
        var cfgUpsell = (window.cv3CdConfig || {}).showServicesUpsell !== false;
        var canUpsellRepot = cfgUpsell && !!(repot && !hasRepot);
        // When there's no pot child, the onsite-repot upsell is already
        // shown inline beside the + Add a pot pill (gapHtml above). Skip
        // the duplicate "Add onsite repotting" card in the services
        // shelf — mirrors the cart-page logic. Standard warehouse repot
        // (when pot_child exists) still renders in the shelf.
        if (canUpsellRepot && !potChild) canUpsellRepot = false;
        var canUpsellTray  = cfgUpsell && !!(potChild && tray && !hasTray);
        // CRO2610: what a pot allows follows the product page's rules (Theme settings → CV3 Pot picker & add-ons):
        // no repotting when its Drainage is the "no repotting" value, a tray only when its Tray field says it is
        // paired separately. Applied when the pot line carries those fields; a pot without them is offered as before.
        var potRuleSpec = potChild ? cv3UnpackSpec((potChild.properties || {})._io_pot_spec) : null;
        if (potRuleSpec && window.CV3_SET && window.CV3_SET.allows && (potRuleSpec.drn != null || potRuleSpec.tray != null)) {
          var potAllows = window.CV3_SET.allows(potRuleSpec.drn, potRuleSpec.tray);
          if (!potAllows.repot) canUpsellRepot = false;
          if (!potAllows.tray) canUpsellTray = false;
        }
        var hasAnyShelf = services.length > 0 || canUpsellRepot || canUpsellTray;
        // CRO2610: a set that has its pot but no repotting / tray says so on the closed card, as the same kind of
        // pill a plant without a pot gets ("+ Add a pot"). Before, these offers only showed after opening the set.
        if (potChild && (canUpsellRepot || canUpsellTray)) {
          svcNudgeHtml = '<div class="cv3-cd__gap cv3-cd__gap--multi" data-cro2610-svc-nudge><div class="cv3-cd__gap-actions">' +
            (canUpsellRepot
              ? '<button type="button" class="cv3-cd__gap-btn cv3-cd__gap-btn--ghost" data-cv3-cd-svc-add="repot" data-cv3-cd-bundle-id="' + escapeHtml(bid || '') + '" data-cv3-cd-svc-variant="' + repot.id + '">+ Repotting <span class="cv3-cd__gap-btn-price">+' + formatMoney(repot.price) + '</span></button>'
              : '') +
            (canUpsellTray
              ? '<button type="button" class="cv3-cd__gap-btn cv3-cd__gap-btn--ghost" data-cv3-cd-svc-add="tray" data-cv3-cd-bundle-id="' + escapeHtml(bid || '') + '" data-cv3-cd-svc-variant="' + tray.id + '">+ Matching tray <span class="cv3-cd__gap-btn-price">+' + formatMoney(tray.price) + '</span></button>'
              : '') +
          '</div></div>';
        }
        if (hasAnyShelf) {
          svcHtml = '<div class="cv3-cd__svcs" data-cv3-cd-svcs>';
          // Existing services (with × to remove)
          services.forEach(function (c) {
            var role = (c.properties && c.properties._io_bundle_role) || '';
            var label = labelForChild(c, role);
            svcHtml +=
              '<div class="cv3-cd__svc cv3-cd__svc--on" data-cv3-cd-child-key="' + c.key + '">' +
                renderChildThumb(c, role) +
                '<span class="cv3-cd__svc-name">' + escapeHtml(label) + '</span>' +
                '<span class="cv3-cd__svc-price">+' + formatMoney(c.final_line_price) + '</span>' +
                '<button type="button" class="cv3-cd__svc-x" data-cv3-cd-child-remove="' + c.key + '" aria-label="Remove this service">' +
                  '<span aria-hidden="true">×</span>' +
                '</button>' +
              '</div>';
          });
          if (canUpsellRepot) {
            var addKind  = potChild ? 'repot' : 'onsite_repot';
            var addLabel = potChild ? 'Add repotting service' : 'Add onsite repotting';
            var addHint  = potChild ? '' : '<span class="cv3-cd__svc-hint">Photo of your pot needed — we’ll email you</span>';
            // For onsite, the button advertises the NO-disposal variant +
            // its price (the modal lets the customer flip to with-disposal).
            // Standard repot keeps the planter-size-based REPOT_BY_SIZE
            // variant resolved in `repot` above.
            var btnVariantId = repot.id;
            var btnPrice = repot.price;
            if (addKind === 'onsite_repot') {
              var onsiteDefault = resolveOnsiteRepotForAnchor(item, false);
              if (onsiteDefault) {
                btnVariantId = onsiteDefault.id;
                btnPrice = onsiteDefault.price;
              }
            }
            // Multi-qty price hint — when the bundle anchor is at qty>1
            // and the service scales with anchor (everything except onsite-
            // repot, which is capped at 1), show "× N = $XX" so the customer
            // sees the total impact at a glance instead of doing the math.
            var anchorQty = item.quantity || 1;
            var scalesWithAnchor = (addKind !== 'onsite_repot');
            var priceLineHtml = '+' + formatMoney(btnPrice);
            if (scalesWithAnchor && anchorQty > 1) {
              priceLineHtml += ' <span class="cv3-cd__svc-price-mult">× ' + anchorQty + ' = ' + formatMoney(btnPrice * anchorQty) + '</span>';
            }
            svcHtml +=
              '<button type="button" class="cv3-cd__svc cv3-cd__svc--add" ' +
                'data-cv3-cd-svc-add="' + addKind + '" ' +
                'data-cv3-cd-bundle-id="' + escapeHtml(bid || '') + '" ' +
                'data-cv3-cd-svc-variant="' + btnVariantId + '">' +
                '<span class="cv3-cd__bundle-thumb" aria-hidden="true">' + ICON_REPOT + '</span>' +
                '<span class="cv3-cd__svc-namewrap">' +
                  '<span class="cv3-cd__svc-name">' + addLabel + '</span>' +
                  addHint +
                '</span>' +
                '<span class="cv3-cd__svc-price">' + priceLineHtml + '</span>' +
                '<span class="cv3-cd__svc-plus" aria-hidden="true">+</span>' +
              '</button>';
          }
          if (canUpsellTray) {
            // Same multi-qty hint pattern as the repot button above — tray
            // also scales per plant under the bundle-qty fix.
            var trayAnchorQty = item.quantity || 1;
            var trayPriceLine = '+' + formatMoney(tray.price);
            if (trayAnchorQty > 1) {
              trayPriceLine += ' <span class="cv3-cd__svc-price-mult">× ' + trayAnchorQty + ' = ' + formatMoney(tray.price * trayAnchorQty) + '</span>';
            }
            svcHtml +=
              '<button type="button" class="cv3-cd__svc cv3-cd__svc--add" ' +
                'data-cv3-cd-svc-add="tray" ' +
                'data-cv3-cd-bundle-id="' + escapeHtml(bid || '') + '" ' +
                'data-cv3-cd-svc-variant="' + tray.id + '">' +
                '<span class="cv3-cd__bundle-thumb" aria-hidden="true">' + ICON_TRAY + '</span>' +
                '<span class="cv3-cd__svc-name">Add matching tray</span>' +
                '<span class="cv3-cd__svc-price">' + trayPriceLine + '</span>' +
                '<span class="cv3-cd__svc-plus" aria-hidden="true">+</span>' +
              '</button>';
          }
          svcHtml += '</div>';
        }
      }

      // Edit row — UX-simplified (v2.10):
      //   no pot      → no row (the gap-CTA above is the only affordance needed)
      //   has pot     → "Change pot" + "View pairing"
      // "Open product" removed (PDP is reachable by clicking the plant name
      // anyway; the extra pill cluttered the row).
      var editHtml = '';
      if (actAsBundle && potChild) {
        var cfg = window.cv3CdConfig || {};
        var parts = [];
        if (cfg.showChangePot !== false) {
          parts.push('<button type="button" class="cv3-cd__edit-btn" ' +
                       'data-cv3-cd-change-pot="' + item.key + '" ' +
                       'data-cv3-cd-pot-coll="' + escapeHtml(resolvedColl || '') + '">Change pot</button>');
        }
        if (cfg.showViewPairing !== false) {
          parts.push('<button type="button" class="cv3-cd__edit-btn" data-cv3-cd-view="' + item.key + '">View pairing</button>');
        }
        if (parts.length) editHtml = '<div class="cv3-cd__edit-row">' + parts.join('') + '</div>';
      }

      // (qtyHtml previously declared here; superseded by _qtyInfoHtml above,
      // which is composed into the anchor row's row-info as info_extras.)

      var removeLink =
        '<button type="button" class="cv3-cd__remove-link" data-cv3-cd-remove' +
          (actAsBundle ? ' data-cv3-cd-children="' + children.map(function(c){return c.key;}).join(',') + '"' : '') + '>' +
          (actAsBundle ? 'Remove set' : 'Remove') +
        '</button>';

      // qty stepper now lives INSIDE the anchor row's row-info (passed
      // via _anchorInfoExtras above). Toggle pill too. So no separate
      // bottomRowHtml is needed — the only thing left to append is the
      // Remove link, which is absolutely positioned as the × at top-right
      // by .cv3-cd__remove-link CSS. DOM position doesn't matter visually.

      // ─── BUNDLE LAYOUT — qty + "Bundled" toggle already in the anchor
      // row's row-info. Body unfolds with pot row + services + edit pills.
      // Bundle total sits between body and remove. Compact treatment is
      // applied via .cv3-cd__item--compact when there's something to hide.
      var useCompact = _useCompactEarly;
      if (useCompact) {
        li.classList.add('cv3-cd__item--compact');
        // Bundle total — main price line below the body.
        //
        // Two enhancements over the plain "Bundle total $X" row:
        //   1. Multi-qty suffix "(×N)" when the bundle's anchor qty > 1.
        //      After the bundle-qty-scaling fix, bumping a bundle to qty=2
        //      ratchets all children too — so the "Bundle total" is now
        //      the aggregate for N bundles. Without the ×N hint, customers
        //      might misread the doubled number as a calculation error.
        //   2. "You saved $X.XX" reinforcement line below the total when
        //      any line in the bundle has discount allocations (line- or
        //      cart-level promos that touched this bundle). CRO standard;
        //      Shopify-computed so the math is always correct.
        // Per-bundle "You saved $X" line removed (drawer parity with the
        // cart page) — the cart footer + summary already aggregate
        // savings across the whole order. The bundleSavings() helper is
        // kept since it's cheap and may be useful for future per-bundle
        // signals, just not rendered in the card right now.
        var _btot   = bundleTotal(item, children);
        var _bqty   = item.quantity || 1;
        var bundleTotalHtml =
          '<div class="cv3-cd__bundle-total">' +
            '<span class="cv3-cd__bundle-total-label">' +
              'Set total' +
              (_bqty > 1 ? ' <span class="cv3-cd__bundle-total-qty">(×' + _bqty + ')</span>' : '') +
            '</span>' +
            '<span class="cv3-cd__bundle-total-amt">' + formatMoney(_btot) + '</span>' +
          '</div>';
        li.innerHTML =
          anchorHtml +
          _bundledToggleHtml +
          '<div class="cv3-cd__bc-body" data-cv3-cd-bundle-body hidden>' +
            potHtml +
            gapHtml +
            svcHtml +
            editHtml +
          '</div>' +
          svcNudgeHtml +
          bundleTotalHtml +
          removeLink;
      } else {
        // Flat layout for non-bundles AND for empty-bundle plants. Empty
        // bundles still want their `gapHtml` (the inline pot/onsite pills)
        // since that's the call-to-action.
        li.innerHTML =
          anchorHtml +
          potHtml +
          gapHtml +
          svcHtml +
          editHtml +
          removeLink;
      }
      return li;
    }

    // Tiny inline SVGs for service rows that don't have a product image.
    var ICON_REPOT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 11h12l-1.5 8a2 2 0 0 1-2 1.5h-5a2 2 0 0 1-2-1.5z"/><path d="M9 11V8a3 3 0 0 1 6 0v3"/><path d="M12 3v2"/></svg>';
    var ICON_TRAY  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><ellipse cx="12" cy="14" rx="8" ry="3"/><path d="M4 14v2c0 1.7 3.6 3 8 3s8-1.3 8-3v-2"/></svg>';
    var ICON_GIFT  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="13" rx="1"/><path d="M3 12h18"/><path d="M12 8v13"/><path d="M7 8a2 2 0 1 1 2-2 6 6 0 0 1 3 2 6 6 0 0 1 3-2 2 2 0 1 1 2 2"/></svg>';

    function renderChildThumb(item, role) {
      if (item.image) {
        return '<span class="cv3-cd__bundle-thumb">' +
                 '<img src="' + item.image + '" alt="" loading="lazy">' +
               '</span>';
      }
      var icon = ICON_GIFT;
      if (role === 'repot') icon = ICON_REPOT;
      else if (role === 'tray') icon = ICON_TRAY;
      return '<span class="cv3-cd__bundle-thumb" aria-hidden="true">' + icon + '</span>';
    }

    function bundleTotal(anchor, children) {
      var t = anchor.final_line_price || 0;
      (children || []).forEach(function (c) { t += (c.final_line_price || 0); });
      return t;
    }
    // How many cents the customer saved on this bundle vs the pre-discount
    // line totals. Sums (original − final) across anchor + every child.
    // Used to render a "You saved $X.XX" reinforcement line under the
    // bundle total — CRO win, fulfilment-safe (orig and final are both
    // Shopify-computed). Returns 0 when nothing was discounted, so the
    // caller can cheaply gate the row on `> 0`.
    function bundleSavings(anchor, children) {
      var origAnchor = (anchor.original_line_price != null) ? anchor.original_line_price : (anchor.final_line_price || 0);
      var saved = Math.max(0, origAnchor - (anchor.final_line_price || 0));
      (children || []).forEach(function (c) {
        var orig = (c.original_line_price != null) ? c.original_line_price : (c.final_line_price || 0);
        saved += Math.max(0, orig - (c.final_line_price || 0));
      });
      return saved;
    }

    // Friendly per-role label for bundle children (pot / repot / tray).
    function labelForChild(c, role) {
      var title = c.product_title || '';
      var variant = (c.variant_title && c.variant_title !== 'Default Title') ? c.variant_title : '';
      var combined = variant ? title + ' · ' + variant : title;
      if (role === 'repot')        return 'Repotting service' + (variant ? ' (' + variant + ')' : '');
      if (role === 'onsite_repot') return 'Onsite repotting' + (variant ? ' (' + variant + ')' : '');
      if (role === 'tray')         return 'Matching tray';
      if (role === 'pot')          return '+ ' + combined;
      // Fallback (no role — best-effort)
      return '+ ' + combined;
    }

    // refresh() is a read — it just re-fetches /cart.js and re-paints. It
    // does NOT trigger a page reload. Only the mutation paths (changeQty,
    // batchUpdate, pickPot, addBundleService, addUpsell, applyPhotoUpload)
    // call maybeReloadCartPage explicitly after their mutation completes.
    // Earlier this lived here, which caused the cart page to reload every
    // time we lazy-loaded the cart for the picker — wiping the picker.
    // Data-only cart refresh — pulls fresh /cart.js into `lastCart` WITHOUT
    // the full drawer re-render that refresh() does. Use this when a caller
    // needs current line keys / cart state but the drawer DOM doesn't need
    // rebuilding (e.g. opening the pot picker, where the visible surface is
    // the picker overlay, not the items list). On a large cart the skipped
    // render() is the difference between a snappy open and a multi-second
    // stall.
    function refreshCartData() {
      return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('cart-fetch ' + r.status);
          return r.json();
        })
        .then(function (cart) {
          lastCart = normalizeWidgetPairings(cart);
          return lastCart;
        })
        .catch(function (err) {
          console.error('[cv3-cart-drawer] refreshCartData /cart.js failed', err);
          return lastCart;
        });
    }

    function refresh() {
      setLoading(true);
      return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        // C2 — Shopify's CDN can return HTML on 5xx (maintenance page,
        // CloudFront error). Calling .json() on that throws SyntaxError
        // and the spinner used to stay up forever. Now we check r.ok and
        // re-throw a typed error so .catch() runs through to setLoading(false).
        .then(function (r) {
          if (!r.ok) throw new Error('cart-fetch ' + r.status);
          return r.json();
        })
        .then(function (cart) {
          render(cart);
          setLoading(false);
          return cart;
        })
        .catch(function (err) {
          console.error('[cv3-cart-drawer] /cart.js failed', err);
          setLoading(false);
        });
    }

    // If we're rendered on the standalone /cart page, the cv3-cart-page
    // snippet is server-rendered Liquid. Any drawer-initiated mutation
    // (remove, qty change, change pot, add service) needs that snippet
    // re-rendered — easiest path is a soft reload of the page. Only fires
    // on the cart page; everywhere else this is a no-op.
    var cartPageReloadPending = false;
    // C1 — recovery clock. If the page is backgrounded mid-reload, or the
    // network drops between veil-show and reload-fire, the user previously
    // saw a permanent overlay. We now: (a) auto-recover the flag + remove
    // the veil after a hard timeout, (b) clear on pageshow (bfcache return),
    // (c) reset on user gesture (click/keydown) as a last-resort escape.
    var cartPageReloadTimer = null;
    function abortReloadRecovery() {
      cartPageReloadPending = false;
      if (cartPageReloadTimer) { clearTimeout(cartPageReloadTimer); cartPageReloadTimer = null; }
      hideCartPageVeil();
      hideCartPageProgress();
    }

    // Thin non-blocking top progress bar — the soft-reload indicator.
    // Created lazily, lives on <body>. CSS in cv3-cart-drawer-css.liquid.
    var cartPageProgressEl = null;
    function showCartPageProgress() {
      if (!cartPageProgressEl) {
        cartPageProgressEl = document.createElement('div');
        cartPageProgressEl.className = 'cv3-cp-progress';
        cartPageProgressEl.setAttribute('aria-hidden', 'true');
        document.body.appendChild(cartPageProgressEl);
      }
      cartPageProgressEl.classList.add('is-active');
    }
    function hideCartPageProgress() {
      if (cartPageProgressEl) cartPageProgressEl.classList.remove('is-active');
    }
    // Soft-reload: fetch ONLY the main-cart section's HTML via Shopify's
    // Section Rendering API, surgically replace the items list, summary
    // rows, and preorder banner WITHOUT a full page reload. Avoids
    // re-initialising every IIFE on the page (DingDoong, Smile.io, our own
    // cart-page IIFE with its 30+ observers). On cart-page mutations this
    // turns a 2-5s full reload into a ~300-500ms patch.
    //
    // Using `?sections=main` (the section ID from templates/cart.json)
    // instead of `?sections=main-cart` (the section TYPE / file name).
    // Shopify returns `{"main": "<rendered section HTML>"}` — ~5-20KB
    // vs ~50-200KB for a full /cart HTML fetch. 10x smaller payload,
    // identical server-rendered correctness (same Liquid runs, same
    // includes, just no header/footer/scripts).
    //
    // Element targeting is deliberately narrow: we only swap children
    // INSIDE elements that don't carry direct event handlers. The
    // delegated handlers on the document still match the new children,
    // so qty steppers, bundle expand, × buttons all keep working without
    // any rebind. Elements with direct event handlers (flex toggle, note
    // textareas, checkout submit, view-toggle pills) are NEVER touched.
    // Fallback fetch — only used when a mutation didn't carry the
    // re-rendered section in its own response (the sections-in-POST
    // pattern is the primary path). Prefer the Section Rendering API
    // (`?sections=main`, ~5-20KB); fall back to full /cart HTML if the
    // section response is missing/empty. Caller's catch hard-reloads
    // only if BOTH fail.
    
    

// AFTER
    // The cart page's section ID is template-scoped (e.g.
    // "template--18335208702046__main"), NOT "main". Read it off the
    // rendered wrapper so it survives the template being re-created;
    // fall back to the section TYPE, which the API also accepts.
    function cartSectionId() {
      var wrap = cartPageEl && cartPageEl.closest('[id^="shopify-section-"]');
      return wrap ? wrap.id.replace(/^shopify-section-/, '') : 'main-cart';
    }
    function fetchCartSectionHtml() {
      var id = cartSectionId();
      // NO Accept: application/json — on /cart that header makes Shopify
      // serve the Cart AJAX API (the cart object) instead of the sections.
      return fetch('/cart?sections=' + encodeURIComponent(id), {
        credentials: 'same-origin'
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart-section ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var html = data && data[id];
          if (!html) throw new Error('no-main-section-in-response');
          return html;
        })


        .catch(function (err) {
          console.warn('[cv3-cart-drawer] Section Rendering fallback → full /cart fetch:', err && err.message);
          return fetch('/cart', {
            credentials: 'same-origin',
            headers: { 'Accept': 'text/html' }
          }).then(function (r) {
            if (!r.ok) throw new Error('cart-html ' + r.status);
            return r.text();
          });
        });
    }
    // Pure DOM-swap. Takes a section HTML string (the rendered main-cart
    // section), surgically patches the live cart page. Synchronous; throws
    // 'empty-cart-transition' if the cart just went empty (the caller must
    // hard-reload to re-init the empty-state UI + its CTA).
    function applyCartSectionHtml(sectionHtml) {
      var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');

      // 1. Items lists — swap innerHTML on BOTH renders. The cart page
      //    has two independent item lists: the bundled (grouped) list and
      //    the flat Separate-view list. A mutation must refresh BOTH, or
      //    whichever one isn't currently visible goes stale — switch to
      //    it later and it shows pre-mutation data. Delegated handlers
      //    keep working (they're bound to document, not these nodes).
      var oldItems = document.querySelector('[data-cv3-cp-bundled-list]');
      var newItems = doc.querySelector('[data-cv3-cp-bundled-list]');
      if (oldItems && newItems) oldItems.innerHTML = newItems.innerHTML;
      var oldFlat = document.querySelector('[data-cv3-cp-flat-list]');
      var newFlat = doc.querySelector('[data-cv3-cp-flat-list]');
      if (oldFlat && newFlat) oldFlat.innerHTML = newFlat.innerHTML;

      // 2. Summary cells — patch by class, never swap the whole summary
      //    (the flex checkbox, note textareas, checkout submit all have
      //    direct handlers that would die if their DOM nodes changed).
      ['.cv3-cp__summary-row--items',
       '.cv3-cp__summary-row--sub',
       '.cv3-cp__summary-row--total'].forEach(function (sel) {
        var oldRow = document.querySelector(sel);
        var newRow = doc.querySelector(sel);
        if (oldRow && newRow) oldRow.innerHTML = newRow.innerHTML;
      });

      // 3. Cart-level discount rows — variable count. Remove all current,
      //    re-insert the fresh ones immediately before .cv3-cp__summary-row--total.
      var totalRow = document.querySelector('.cv3-cp__summary-row--total');
      if (totalRow) {
        Array.prototype.forEach.call(
          document.querySelectorAll('.cv3-cp__summary-row--disc'),
          function (n) { n.remove(); }
        );
        Array.prototype.forEach.call(
          doc.querySelectorAll('.cv3-cp__summary-row--disc'),
          function (n) {
            totalRow.parentNode.insertBefore(
              document.importNode(n, true), totalRow
            );
          }
        );
      }

      // 4. Preorder banner — appears/disappears based on cart contents.
      var oldBanner = document.querySelector('.cv3-cp__preorder-banner');
      var newBanner = doc.querySelector('.cv3-cp__preorder-banner');
      var layoutAnchor = document.querySelector('.cv3-cp__layout');
      if (newBanner && !oldBanner && layoutAnchor) {
        layoutAnchor.parentNode.insertBefore(
          document.importNode(newBanner, true), layoutAnchor
        );
      } else if (oldBanner && !newBanner) {
        oldBanner.remove();
      }

      // 5. Item count in the header (e.g. "65 items" / "Empty").
      var oldCount = document.querySelector('.cv3-cp__count');
      var newCount = doc.querySelector('.cv3-cp__count');
      if (oldCount && newCount) oldCount.innerHTML = newCount.innerHTML;

      // 6. Empty-cart transition: if /cart now returns the empty state
      //    block, the full reload path must take over to re-init the
      //    empty-state UI (rare; the caller's catch handles the hard reload).
      var newEmpty = doc.querySelector('.cv3-cp__empty');
      var oldEmpty = document.querySelector('.cv3-cp__empty');
      if (newEmpty && !oldEmpty) throw new Error('empty-cart-transition');

      document.dispatchEvent(new CustomEvent('cv3:cart-page-soft-reloaded'));
    }

    // Fallback path: fetch the section, then apply. Used only when a
    // mutation DIDN'T already carry the re-rendered section in its
    // response (legacy callers, or paths where threading it is awkward).
    function softReloadCartPage() {
      return fetchCartSectionHtml().then(applyCartSectionHtml);
    }

    // Section-rendering POST params. Shopify re-renders the requested
    // section(s) and returns the HTML INSIDE the mutation response — no
    // separate GET, so it can never be served stale from a cache (POST
    // responses aren't cached). `sections_url: '/cart'` forces the cart
    // template context even when the mutation fires from a drawer on a
    // product/collection page. Only requested when we're actually ON the
    // cart page — elsewhere the section HTML is wasted server render.
    function cartSectionParams() {
      
             return cartPageEl ? { sections: cartSectionId(), sections_url: '/cart' } : {};

    }
    // Pull the re-rendered main-cart section HTML out of a mutation
    // response (change.js / update.js / add.js all return `.sections`
    // when `sections` was in the request body). Returns null if absent.
    function sectionHtmlFromCartResponse(resp) {
      
             return (resp && resp.sections && resp.sections[cartSectionId()]) || null;

    }

    // Sync the standalone /cart page after a drawer-initiated mutation.
    //   preRenderedSectionHtml — if the mutation response already carried
    //     the freshly-rendered section HTML (the `sections` POST-body
    //     pattern), pass it here: applied directly, ZERO extra requests.
    //   omitted — falls back to softReloadCartPage() (a GET).
    // On any failure (parse error, missing mounts, empty-cart transition)
    // the catch does a full window.location.reload().
    function maybeReloadCartPage(preRenderedSectionHtml) {
      if (!cartPageEl) return;
      if (cartPageReloadPending) return;
      cartPageReloadPending = true;
      // Thin non-blocking top progress bar — NOT the full-page veil.
      // The soft reload is a fast surgical DOM swap; a full overlay over
      // it made every qty change / add-service feel like a whole-page
      // refresh. The bar just signals "working" while the changed rows
      // update in place. The veil is reserved for the hard-reload catch.
      showCartPageProgress();
      var applyPromise;
      if (typeof preRenderedSectionHtml === 'string' && preRenderedSectionHtml) {
        // Best path — the section HTML came back inside the mutation's
        // own POST response. Apply synchronously, wrapped in a promise so
        // a thrown 'empty-cart-transition' routes to the hard-reload catch.
        applyPromise = Promise.resolve().then(function () {
          applyCartSectionHtml(preRenderedSectionHtml);
        });
      } else {
        // Fallback — fetch the section then apply.
        applyPromise = softReloadCartPage();
      }
      applyPromise
        .then(function () {
          // Landed — clear the pending flag, drop the progress bar. No
          // full reload, no JS re-init, scroll position preserved.
          abortReloadRecovery();
        })
        .catch(function (err) {
          console.warn('[cv3-cart-drawer] soft cart-page sync failed, falling back to full reload:', err);
          // Hard reload fallback — now show the full veil, because the
          // page is genuinely about to reload (2-3s) and that DOES need
          // masking. Rare path: parse failure / empty-cart transition.
          showCartPageVeil('Updating your cart…');
          try { window.location.reload(); }
          catch (e) { abortReloadRecovery(); }
        });
      // Hard ceiling: if the sync hasn't settled within 8s (offline,
      // throttled, etc.), drop the indicators so the user isn't stuck.
      cartPageReloadTimer = setTimeout(abortReloadRecovery, 8000);
    }
    // bfcache restore — Safari can resurrect the page mid-reload; on return
    // the veil DOM is gone but the flag persists, so any subsequent mutation
    // would silently no-op. Reset on every pageshow regardless of cache.
    window.addEventListener('pageshow', function () { abortReloadRecovery(); });

    // Lazily-injected full-page veil shown during cart-page reload. Kept
    // out of Liquid markup because it's only ever needed on /cart paths
    // after a mutation.
    // ─── In-drawer toast (cart-add feedback) ────────────────────────
    // Lightweight visual feedback for actions that take >100ms (adding a
    // pot, swapping pot, adding a service). Floats at the top of the
    // drawer header so it's visible even when items list is scrolled.
    // Auto-dismisses by default; busy=true keeps it up until manually
    // replaced or cleared by render() finishing.
    var cartToastEl = null;
    var cartToastTimer = null;
    function showCartToast(message, opts) {
      opts = opts || {};
      // Decide mount target: when on /cart, the drawer sheet is hidden
      // (display: none via the drawer's closed state), so a toast inside
      // it is invisible. Mount on <body> with `--global` modifier so the
      // CSS uses `position: fixed` and renders top-centre of the
      // viewport instead. Detection mirrors the drawer's `open()` guard
      // — we treat any /cart path as "no drawer" for toast purposes.
      var onCartPage = false;
      try {
        onCartPage = /^\/cart(\/|$|\?)/.test(window.location.pathname);
      } catch (e) {}
      if (!cartToastEl) {
        cartToastEl = document.createElement('div');
        cartToastEl.setAttribute('role', 'status');
        cartToastEl.setAttribute('aria-live', 'polite');
        if (onCartPage) {
          cartToastEl.classList.add('cv3-cd__toast--global');
          document.body.appendChild(cartToastEl);
        } else {
          var sheet = root.querySelector('.cv3-cd__sheet') || root;
          sheet.appendChild(cartToastEl);
        }
      }
      if (cartToastTimer) { clearTimeout(cartToastTimer); cartToastTimer = null; }
      cartToastEl.className = 'cv3-cd__toast is-open'
        + (onCartPage ? ' cv3-cd__toast--global' : '')
        + (opts.busy ? ' cv3-cd__toast--busy' : '')
        + (opts.isError ? ' cv3-cd__toast--error' : '');
      // Spinner + message. Spinner only when busy.
      cartToastEl.innerHTML =
        (opts.busy
          ? '<span class="cv3-cd__toast-spinner" aria-hidden="true"></span>'
          : (opts.isError
              ? '<span class="cv3-cd__toast-icon" aria-hidden="true">!</span>'
              : '<span class="cv3-cd__toast-icon" aria-hidden="true">✓</span>')) +
        '<span class="cv3-cd__toast-msg"></span>';
      cartToastEl.querySelector('.cv3-cd__toast-msg').textContent = message;
      if (!opts.busy && opts.duration !== 0) {
        var dur = opts.duration || 2000;
        cartToastTimer = setTimeout(hideCartToast, dur);
      }
    }
    function hideCartToast() {
      if (!cartToastEl) return;
      cartToastEl.classList.remove('is-open');
      if (cartToastTimer) { clearTimeout(cartToastTimer); cartToastTimer = null; }
    }

    var cartPageVeilEl = null;
    function showCartPageVeil(label) {
      if (!cartPageVeilEl) {
        cartPageVeilEl = document.createElement('div');
        cartPageVeilEl.className = 'cv3-cd-page-veil';
        cartPageVeilEl.setAttribute('role', 'status');
        cartPageVeilEl.setAttribute('aria-live', 'polite');
        cartPageVeilEl.innerHTML =
          '<div class="cv3-cd-page-veil__box">' +
            '<div class="cv3-cd-page-veil__spinner" aria-hidden="true"></div>' +
            '<div class="cv3-cd-page-veil__label">Updating your cart…</div>' +
          '</div>';
        document.body.appendChild(cartPageVeilEl);
      }
      var labelEl = cartPageVeilEl.querySelector('.cv3-cd-page-veil__label');
      if (labelEl && label) labelEl.textContent = label;
      // Force a frame so the transition runs.
      requestAnimationFrame(function () { cartPageVeilEl.classList.add('is-open'); });
    }

    // C1 — dismiss the veil. Called by abortReloadRecovery() above on bfcache
    // restore / hard timeout so the user is never permanently locked out.
    function hideCartPageVeil() {
      if (!cartPageVeilEl) return;
      cartPageVeilEl.classList.remove('is-open');
    }

    // Batch update multiple line items in a single POST. Used when removing
    // a bundle anchor so the pot/repot/tray go in the same request and the
    // user never sees a "half-removed" cart state.
    function batchUpdate(updates) {
      setLoading(true);
      // P0-3 audit fix: register EVERY key in this batch as in-flight, not
      // just the anchor. Without this, the customer could click bundle qty
      // (which batches anchor + pot + repot + tray) and then immediately
      // click a child's per-row qty — the child fires changeQty in parallel
      // because qtyInflight[childKey] was never set, racing two writes to
      // the same line. The shared promise we register here causes any
      // changeQty call for one of these keys to coalesce into the latest
      // pending intent until the batch resolves.
      var batchKeys = Object.keys(updates);
      var p = fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(Object.assign({ updates: updates }, cartSectionParams()))
      })
        // C2 parity — surface 422 (sold out / over-stock) as a thrown
        // error so the .catch below can toast it; previously the .json()
        // succeeded silently on the error body and the next `render(cart)`
        // ran on a stale response.
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) {
              var err = new Error((body && body.description) || ('update.js ' + r.status));
              err.body = body; err.status = r.status;
              throw err;
            }
            return body;
          });
        })
        .then(function (cart) {
          render(cart);
          setLoading(false);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cv3-cart-drawer' } }));
          maybeReloadCartPage(sectionHtmlFromCartResponse(cart));
        })
        .catch(function (err) {
          console.error('[cv3-cart-drawer] /cart/update.js failed', err);
          // Surface visibly — same reason as changeQty (silent 422s left
          // the customer wondering why the action didn't take). batchUpdate
          // is invoked by bundle-qty-scale + bundle-remove; either case
          // benefits from a "Could not update — All N in stock" toast.
          var msg = (err && err.body && err.body.description)
                 || (err && err.message)
                 || 'Could not update cart. Please try again.';
          showCartToast(msg, { isError: true, duration: 4000 });
          setLoading(false);
        })
        .then(function () {
          // Release the inflight lock on every key in the batch. If the
          // customer queued a follow-up qty change on any of them during
          // the wait, fire it now via changeQty (which checks qtyPending).
          batchKeys.forEach(function (k) {
            delete qtyInflight[k];
            if (qtyPending[k] !== undefined) {
              var t = qtyPending[k];
              delete qtyPending[k];
              changeQty(k, t);
            }
          });
        });
      batchKeys.forEach(function (k) { qtyInflight[k] = p; });
      return p;
    }

    // C3 — qty stepper single-flight + coalesce.
    // Old behaviour: every click fired a parallel /cart/change.js. On 3G,
    // responses could land out of order and render() with stale qty, leaving
    // the displayed number out of sync with the server. We now track per-key
    // in-flight state and remember the latest intended qty. While a request
    // is pending we never fire a second; once it returns, if the user clicked
    // more during the wait, we fire one final request with the latest target.
    var qtyInflight = {}; // key → Promise
    var qtyPending  = {}; // key → latest qty intent
    function changeQty(key, qty) {
      var target = Math.max(0, qty);
      qtyPending[key] = target;
      if (qtyInflight[key]) return qtyInflight[key]; // a request is already on its way
      setLoading(true);
      // A1 — focus this line so the next render doesn't snap to top.
      // Skip when removing (target === 0) — the line won't exist, so
      // fall back to scrollTop preservation.
      if (target > 0) setFocusedKey(key);
      var fire = function () {
        var sending = qtyPending[key];
        delete qtyPending[key];
        // Captured from the mutation response — the re-rendered main-cart
        // section HTML when `sections` was requested. Threaded into
        // maybeReloadCartPage so the cart page syncs with ZERO extra GET.
        var sectionHtml = null;
        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(Object.assign({ id: key, quantity: sending }, cartSectionParams()))
        })
          // C2 expansion — same .ok guard as refresh()/addBundleService.
          .then(function (r) {
            return r.json().then(function (body) {
              if (!r.ok) {
                var err = new Error(body && body.description || ('change.js ' + r.status));
                err.body = body; err.status = r.status;
                throw err;
              }
              return body;
            });
          })
          .then(function (cart) {
            render(cart);
            sectionHtml = sectionHtmlFromCartResponse(cart);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cv3-cart-drawer' } }));
          })
          .catch(function (err) {
            console.error('[cv3-cart-drawer] /cart/change.js failed', err);
            // Surface visibly — previously errors were console-only so a
            // customer trying to bump qty past stock saw NOTHING happen
            // (the number snapped back via the next render but no reason
            // why). Shopify's 422 body carries `description` like "All 5
            // in stock" or "You cannot add more...". Toast renders inside
            // the drawer when open, fixed at top of viewport on /cart.
            var msg = (err && err.body && err.body.description)
                   || (err && err.message)
                   || 'Could not update quantity. Please try again.';
            showCartToast(msg, { isError: true, duration: 4000 });
          })
          .then(function () {
            // If the user clicked more while we were in flight, fire one
            // more request with the latest target. Otherwise clear the slot
            // and release the spinner.
            if (qtyPending[key] !== undefined && qtyPending[key] !== sending) {
              qtyInflight[key] = fire();
              return qtyInflight[key];
            }
            delete qtyInflight[key];
            setLoading(false);
            maybeReloadCartPage(sectionHtml);
          });
      };
      qtyInflight[key] = fire();
      return qtyInflight[key];
    }

    function addItems(payload, opts) {
      // payload: number id, or { id, quantity, properties }, or { items: [...] }
      // opts.quiet (CRO2610, used by the cart page's add-ons shelf): add without opening the drawer. On the cart
      // page the lines and totals update in place from the same response (no reload, no extra request); on any
      // other page the drawer's contents refresh in the background. Without opts nothing changes.
      opts = opts || {};
      var body;
      if (typeof payload === 'number') {
        body = JSON.stringify({ items: [{ id: payload, quantity: 1 }] });
      } else if (payload && payload.items) {
        body = JSON.stringify(payload);
      } else if (payload && payload.id) {
        body = JSON.stringify({ items: [payload] });
      } else {
        return Promise.reject(new Error('cv3-cart-drawer: invalid add payload'));
      }
      if (opts.quiet && cartPageEl) {
        try {
          var withSections = JSON.parse(body), sectionParams = cartSectionParams();
          Object.keys(sectionParams).forEach(function (k) { withSections[k] = sectionParams[k]; });
          body = JSON.stringify(withSections);
        } catch (_) {}
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: body
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, body: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'add failed');
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cv3-cart-drawer', added: res.body } }));
          if (opts.quiet) {
            if (cartPageEl) maybeReloadCartPage(sectionHtmlFromCartResponse(res.body));
            else refresh();
          } else {
            open();
          }
          return res.body;
        });
    }

    // Event delegation on the drawer body.
    // ALSO listen on any standalone `[data-cv3-cd-page]` (the cart-page CV3
    // bundle render) — same data-attribute contract, so click handlers
    // below work identically on either surface.
    var cartPageEl = document.querySelector('[data-cv3-cd-page]');
    var clickHandler = function (e) {
      // Compact bundle expand/collapse — toggle the body's hidden attribute
      // and the chevron via aria-expanded. Checked FIRST so we don't fall
      // through to other handlers (no other handler matches the bundle head).
      var bcHead = e.target.closest('[data-cv3-cd-bundle-toggle]');
      if (bcHead) {
        var bcItem = bcHead.closest('[data-cv3-cd-key]');
        if (!bcItem) return;
        var bcBody = bcItem.querySelector('[data-cv3-cd-bundle-body]');
        if (!bcBody) return;
        var isOpen = bcHead.getAttribute('aria-expanded') === 'true';
        bcHead.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (isOpen) bcBody.setAttribute('hidden', '');
        else bcBody.removeAttribute('hidden');
        return;
      }
      var qtyBtn = e.target.closest('[data-cv3-cd-qty]');
      if (qtyBtn) {
        // Disabled stepper buttons (e.g. + on an onsite-repot bundle, or
        // − at qty=1) get an early-return so the inline `data-cv3-tip`
        // tooltip still fires but no cart write happens.
        if (qtyBtn.disabled) return;
        var li = qtyBtn.closest('[data-cv3-cd-key]');
        if (!li) return;
        var newQty   = parseInt(qtyBtn.dataset.cv3CdQty, 10);
        var anchorKey = li.dataset.cv3CdKey;
        // Bundle qty scaling — when the stepper carries
        // `data-cv3-cd-bundle-children="k1,k2,..."` (stamped at render time
        // in buildItemLi), we batch the anchor AND every child to the new
        // qty in a single /cart/update.js. Otherwise we'd ship 2 plants in
        // 1 pot with 1 service. Removal stays per-line (the × buttons use
        // their own data-cv3-cd-child-remove + data-cv3-cd-remove paths).
        var bundleChildren = (qtyBtn.dataset.cv3CdBundleChildren || '')
          .split(',').filter(Boolean);
        if (bundleChildren.length) {
          var updates = {};
          updates[anchorKey] = newQty;
          bundleChildren.forEach(function (k) { updates[k] = newQty; });
          // A1 parity — focus the anchor so the next render doesn't snap
          // to top after the multi-line update.
          if (newQty > 0) setFocusedKey(anchorKey);
          batchUpdate(updates);
        } else {
          changeQty(anchorKey, newQty);
        }
        return;
      }
      // Per-child × — removes ONLY that child (pot, repot, or tray) from
      // the bundle, leaving the anchor (plant) and other children alone.
      var childX = e.target.closest('[data-cv3-cd-child-remove]');
      if (childX) {
        var ck = childX.getAttribute('data-cv3-cd-child-remove');
        if (ck) {
          // CRO2610: once the pot or service is gone, the plant line says so too (see syncSetLine)
          var goneFrom = findItemByKey(ck);
          var goneBid = goneFrom && goneFrom.properties ? goneFrom.properties._io_bundle_id : '';
          var removing = changeQty(ck, 0);
          if (goneBid && removing && removing.then) removing.then(function () { return syncSetThenShow(goneBid); });
        }
        return;
      }
      // Service add-back toggle — adds a stamped repot/tray variant back
      // to the bundle (same _io_bundle_id so it groups with the plant). For
      // standalone plants without a bundle id, addBundleService mints one
      // via ensureBundleId(anchorKey), so we pass the anchor key too.
      //
      // Special case: onsite_repot opens the photo-upload modal first so
      // the customer can attach a photo of their pot. The actual cart-add
      // fires from inside the modal's Apply button.
      var svcAdd = e.target.closest('[data-cv3-cd-svc-add]');
      if (svcAdd) {
        // Ignore re-clicks while a request is in flight.
        if (svcAdd.dataset.cv3CdAdding) { e.preventDefault(); return; }
        e.preventDefault();
        var hostLi = svcAdd.closest('[data-cv3-cd-key]');
        var hostKey = hostLi ? hostLi.dataset.cv3CdKey : null;
        var addRole = svcAdd.getAttribute('data-cv3-cd-svc-add');
        var addVid = parseInt(svcAdd.getAttribute('data-cv3-cd-svc-variant'), 10);
        var addBid = svcAdd.getAttribute('data-cv3-cd-bundle-id') || null;
        if (addRole === 'onsite_repot') {
          openPhotoModal(addRole, addVid, addBid, hostKey, svcAdd);
        } else {
          addBundleService(addRole, addVid, addBid, hostKey, svcAdd);
        }
        return;
      }
      // Photo modal: close + skip
      if (e.target.closest('[data-cv3-cd-photo-close]')) { closePhotoModal(); return; }
      if (e.target.closest('[data-cv3-cd-photo-skip]')) {
        // Skip the photo — fall back to the legacy cart-note path.
        if (photoCtx) {
          addBundleService(photoCtx.role, photoCtx.variantId, photoCtx.bundleId, photoCtx.anchorKey, photoCtx.sourceEl);
        }
        closePhotoModal();
        return;
      }
      // Photo modal: Apply with photo
      if (e.target.closest('[data-cv3-cd-photo-apply]')) {
        applyPhotoUpload();
        return;
      }
      // "Change pot" — opens the inline picker overlay (item 6).
      var changePotBtn = e.target.closest('[data-cv3-cd-change-pot]');
      if (changePotBtn) {
        e.preventDefault();
        // Belt-and-braces button-level feedback. The picker overlay opens
        // immediately with its own spinner, but on slow networks a few
        // hundred ms can pass between click and overlay paint — flag the
        // button as busy so the click site never feels "dead".
        if (!changePotBtn.dataset.cv3CdOriginalLabel) {
          changePotBtn.dataset.cv3CdOriginalLabel = changePotBtn.textContent;
        }
        changePotBtn.classList.add('is-loading');
        changePotBtn.disabled = true;
        var origLabel = changePotBtn.dataset.cv3CdOriginalLabel;
        changePotBtn.textContent = 'Loading…';
        var resetChangePot = function () {
          changePotBtn.classList.remove('is-loading');
          changePotBtn.disabled = false;
          changePotBtn.textContent = origLabel;
        };
        // Safety reset after 4 s in case openInlinePotPicker bails silently.
        setTimeout(resetChangePot, 4000);
        // Reset as soon as the picker becomes visible to the user.
        var observer = new MutationObserver(function () {
          if (els.picker && els.picker.classList.contains('is-open')) {
            observer.disconnect();
            resetChangePot();
          }
        });
        if (els.picker) observer.observe(els.picker, { attributes: true, attributeFilter: ['class'] });
        var anchorKey = changePotBtn.getAttribute('data-cv3-cd-change-pot');
        // Tier 0 hint: the cart-page row already resolved a collection in
        // Liquid (using plant_size metafield → collections → 'planters'
        // catch-all). Stash it on the picker context object so
        // openInlinePotPickerWithData prefers it over its own lookup —
        // matters when the cart has >30 items (Liquid map skipped) or
        // when the line was added before _io_pot_collection stamping shipped.
        var stampedColl = changePotBtn.getAttribute('data-cv3-cd-pot-coll') || '';
        if (stampedColl) pendingPotCollHint = { key: anchorKey, handle: stampedColl };
        openInlinePotPicker(anchorKey);
        return;
      }
      // View pairing button — opens the detail overlay
      var viewBtn = e.target.closest('[data-cv3-cd-view]');
      if (viewBtn) {
        e.preventDefault();
        openDetailOverlay(viewBtn.getAttribute('data-cv3-cd-view'));
        return;
      }
      // Picker: back button
      if (e.target.closest('[data-cv3-cd-picker-close]')) {
        closeInlinePotPicker();
        return;
      }
      // Detail overlay: back button
      if (e.target.closest('[data-cv3-cd-detail-close]')) {
        closeDetailOverlay();
        return;
      }
      // Detail overlay: tab switch (Pairing ↔ Details)
      var detailTab = e.target.closest('[data-cv3-cd-detail-tab]');
      if (detailTab) {
        var which = detailTab.getAttribute('data-cv3-cd-detail-tab');
        Array.prototype.forEach.call(els.detail.querySelectorAll('[data-cv3-cd-detail-tab]'), function (t) {
          var on = t.getAttribute('data-cv3-cd-detail-tab') === which;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        Array.prototype.forEach.call(els.detail.querySelectorAll('[data-cv3-cd-detail-panel]'), function (p) {
          var on = p.getAttribute('data-cv3-cd-detail-panel') === which;
          p.classList.toggle('is-active', on);
          p.hidden = !on;
        });
        return;
      }
      // Picker: variant chip click — switch the card's active variant
      // (and image / price) THEN select the card. Stop event from also
      // firing the card-click handler since we already select here.
      var chipEl = e.target.closest('[data-cv3-cd-pp-chip]');
      if (chipEl) {
        e.stopPropagation();
        var card = chipEl.closest('.cv3-cd__pp-card');
        if (!card) return;
        var newVid = parseInt(chipEl.getAttribute('data-cv3-cd-pp-chip'), 10);
        var newPrice = parseInt(chipEl.getAttribute('data-cv3-cd-pp-chip-price'), 10) || 0;
        var newImg = chipEl.getAttribute('data-cv3-cd-pp-chip-img') || '';
        // Toggle chip aria + active classes within the group
        var group = chipEl.parentElement;
        Array.prototype.forEach.call(group.querySelectorAll('[data-cv3-cd-pp-chip]'), function (c) {
          c.classList.remove('is-active');
          c.setAttribute('aria-pressed', 'false');
        });
        chipEl.classList.add('is-active');
        chipEl.setAttribute('aria-pressed', 'true');
        // Update the card's "active variant"
        card.setAttribute('data-cv3-cd-pp-pick', newVid);
        card.setAttribute('data-cv3-cd-pp-price', newPrice);
        // Update the displayed price + image
        var priceEl = card.querySelector('[data-cv3-cd-pp-card-price]');
        if (priceEl) priceEl.textContent = formatMoney(newPrice);
        if (newImg) {
          var imgWrap = card.querySelector('[data-cv3-cd-pp-img]');
          if (imgWrap) imgWrap.innerHTML = '<img src="' + newImg + '" alt="" loading="lazy">';
        }
        // Commit the card as the picker's selection
        selectPickerCard(card);
        return;
      }
      // Picker: pot card SELECT (doesn't commit until Apply is clicked)
      var pickCard = e.target.closest('[data-cv3-cd-pp-pick]');
      if (pickCard) {
        selectPickerCard(pickCard);
        return;
      }
      // Picker: Apply button commits the selected pot
      if (e.target.closest('[data-cv3-cd-picker-apply]')) {
        if (pickerCtx && pickerCtx.selectedVariantId) pickPot(pickerCtx.selectedVariantId);
        return;
      }
      // Upsell strip: + add an upsell to cart
      var upsellBtn = e.target.closest('[data-cv3-cd-upsell-add]');
      if (upsellBtn) {
        if (upsellBtn.dataset.cv3CdAdding) { e.preventDefault(); return; }
        e.preventDefault();
        var upVid = parseInt(upsellBtn.getAttribute('data-cv3-cd-upsell-add'), 10);
        if (upVid) addUpsell(upVid, upsellBtn);
        return;
      }
      // Upsell anchor pill — replaces the old expand/collapse with a simple
      // scroll-to. Strip lives at the bottom of the body and is always
      // visible when upsells exist; the pill at the top of the body is the
      // discoverable click target that scrolls the body down to the strip.
      var upsellAnchor = e.target.closest('[data-cv3-cd-upsell-anchor]');
      if (upsellAnchor) {
        var strip = root.querySelector('[data-cv3-cd-upsell-strip]');
        var body  = root.querySelector('[data-cv3-cd-body]');
        if (strip && body) {
          var prefersReduced = window.matchMedia &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var targetTop = strip.offsetTop - 8;  // small breathing room above
          if (prefersReduced || !('scrollBehavior' in document.documentElement.style)) {
            body.scrollTop = targetTop;
          } else {
            body.scrollTo({ top: targetTop, behavior: 'smooth' });
          }
        }
        return;
      }
      var removeBtn = e.target.closest('[data-cv3-cd-remove]');
      if (removeBtn) {
        var liR = removeBtn.closest('[data-cv3-cd-key]');
        if (!liR) return;
        // If the anchor has bundle children stamped via data-cv3-cd-children,
        // remove them ALL in one batch update so the bundle stays consistent
        // (no orphaned pot or repot line after the plant is gone).
        var childKeys = (removeBtn.dataset.cv3CdChildren || '').split(',').filter(Boolean);
        if (childKeys.length) {
          var updates = {};
          updates[liR.dataset.cv3CdKey] = 0;
          childKeys.forEach(function (k) { updates[k] = 0; });
          batchUpdate(updates);
        } else {
          changeQty(liR.dataset.cv3CdKey, 0);
        }
        return;
      }
      if (e.target.closest('[data-cv3-cd-close]')) {
        close();
        return;
      }
      // Go to cart — programmatic navigation. The link uses href="#" to
      // dodge the legacy AMP_API click-on-/cart hijack; we do the redirect
      // ourselves here. cmd/ctrl/middle-click is allowed to pass through
      // (the link technically navigates nowhere then, but no harm).
      var goCart = e.target.closest('[data-cv3-cd-go-to-cart]');
      if (goCart) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        window.location.href = window.cv3CartUrl || "/cart";
        return;
      }
      // Fallback: any click on the drawer that lands outside the sheet (i.e.
      // on the backdrop area or the root itself) closes the drawer. Skip this
      // when the event came from the cart-page wrapper — the cart page has
      // no "sheet" and no concept of closing.
      if (e.currentTarget === root &&
          root.classList.contains('is-open') &&
          !e.target.closest('.cv3-cd__sheet')) {
        close();
      }
    };
    root.addEventListener('click', clickHandler);
    if (cartPageEl) cartPageEl.addEventListener('click', clickHandler);
    // The picker / detail / photo overlays were moved to body-level (so
    // they can open over the /cart page without forcing the drawer open).
    // They sit OUTSIDE [data-cv3-cd] in the DOM tree, so we have to bind
    // the same delegated clickHandler to each — otherwise Apply pot, chip
    // selection, card selection, Back, and ×-close are all dead clicks.
    [els.picker, els.detail, els.photo].forEach(function (el) {
      if (el) el.addEventListener('click', clickHandler);
    });

    // On the standalone /cart page the drawer never opens, so `lastCart`
    // stays null until the first user action — meaning the FIRST Change
    // pot / View pairing click pays for a /cart.js fetch (~1–3 s on slow
    // connections). Warm the cache during idle time so the picker can
    // render instantly when the user actually clicks.
    if (cartPageEl) {
      var prefetchCart = function () {
        if (lastCart) return;
        // refresh() handles normalizeWidgetPairings + setLoading. setLoading
        // toggles the drawer's spinner overlay but the drawer itself is
        // hidden on /cart, so this is invisible to the user — just warms
        // up lastCart so the next click renders instantly.
        refresh();
      };
      if ('requestIdleCallback' in window) {
        requestIdleCallback(prefetchCart, { timeout: 1500 });
      } else {
        setTimeout(prefetchCart, 600);
      }

      // ── Per-card busy feedback ──────────────────────────────────────
      // Removing the full-page veil made cart changes feel "too quiet" —
      // a qty bump or remove gave no signal until the row updated ~400ms
      // later. This dims the SPECIFIC card whose control was clicked, the
      // instant it's clicked, so the change registers visually right
      // away. Purely cosmetic: the soft-reload innerHTML swap replaces
      // the card (clearing the dim); a safety timeout covers the rare
      // path where no swap happens (failed mutation). Capture phase so
      // it runs before the mutation handler. The selector deliberately
      // EXCLUDES change-pot (opens a modal, not a direct mutation) and
      // bundle-toggle (just expand/collapse).
      cartPageEl.addEventListener('click', function (e) {
        var ctrl = e.target.closest(
          '[data-cv3-cd-qty],[data-cv3-cd-remove],[data-cv3-cd-child-remove],[data-cv3-cd-svc-add]'
        );
        if (!ctrl || ctrl.disabled) return;
        var card = ctrl.closest('.cv3-cd__item');
        if (!card) return;
        card.classList.add('cv3-busy');
        setTimeout(function () { card.classList.remove('cv3-busy'); }, 6000);
      }, true);
    }

    // Overlays (picker / detail / photo) are body-level now — bind the same
    // click delegation to each so clicks INSIDE them (Apply, Back, chip,
    // backdrop, etc.) get handled.
    [els.picker, els.detail, els.photo].forEach(function (el) {
      if (el) el.addEventListener('click', clickHandler);
    });
    // Keyboard nav for div-based radio cards (Enter / Space).
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest('[data-cv3-cd-pp-pick], [data-cv3-cd-upsell-add]');
      if (!card) return;
      e.preventDefault();
      if (card.matches('[data-cv3-cd-pp-pick]')) {
        selectPickerCard(card);
      } else if (card.matches('[data-cv3-cd-upsell-add]')) {
        var vid = parseInt(card.getAttribute('data-cv3-cd-upsell-add'), 10);
        if (vid) addUpsell(vid, card);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
      // Layered Escape: photo modal → detail overlay → picker overlay → drawer.
      if (els.photo && els.photo.classList.contains('is-open')) {
        closePhotoModal();
      } else if (els.detail && els.detail.classList.contains('is-open')) {
        closeDetailOverlay();
      } else if (els.picker && els.picker.classList.contains('is-open')) {
        closeInlinePotPicker();
      } else {
        close();
      }
    });

    // ─── Auto-expand upsells when customer scrolls cart body to bottom ─
    // Reading signal: if they've seen everything they're carrying, surface
    // the "Add to your order" tray automatically — but only ONCE per drawer
    // open, and never overrides a user's explicit collapse. Otherwise the
    // expanded body would change content height, retrigger the threshold,
    // and the strip blinks open/closed.
    // Upsell auto-expand state machine:
    //   - 'idle'         : not auto-touched. May auto-expand when user
    //                       scrolls to bottom.
    //   - 'auto-open'    : we auto-expanded on scroll-to-bottom. May
    //                       auto-collapse if user scrolls back UP
    //                       (signal: they're not interested).
    //   - 'user-open'    : user manually clicked chevron open. Never
    //                       auto-collapse — respect their intent.
    //   - 'user-closed'  : user manually closed AFTER our auto-open.
    //                       Never auto-expand again this session.
    // Upsell visibility: the strip lives at the bottom of the body and is
    // always visible when upsells exist. The anchor pill at the top of the
    // body is the discoverable "jump to upsells" affordance. We also hide
    // the anchor pill once the strip itself is in view (no point pointing
    // at something the user can already see) via IntersectionObserver.
    if (els.upsellStrip && els.upsellAnchor && 'IntersectionObserver' in window) {
      var stripIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Strip visible → hide anchor pill. Strip out of view → show it.
          els.upsellAnchor.hidden = entry.isIntersecting;
        });
      }, { root: els.body || null, threshold: 0.2 });
      stripIO.observe(els.upsellStrip);
    }

    // ─── Hydrate from server-side seed (DEFERRED) ────────────────────
    // The seed hydrate calls render() which can be slow for large carts
    // (30+ items × bundle UI = lots of DOM creation). It also fires
    // maybeRenderUpsells() which may make a /recommendations fetch. None
    // of that needs to happen on page load — defer to first idle so the
    // critical render path (header, hero, product gallery) paints first
    // and apps that need connection slots aren't competing with our init.
    var seedHydrated = false;
    function hydrateFromSeed() {
      if (seedHydrated) return;
      seedHydrated = true;
      try {
        var seedEl = document.querySelector('[data-cv3-cd-seed]');
        if (seedEl) {
          var seed = JSON.parse(seedEl.textContent || '{}');
          if (seed && typeof seed === 'object') {
            render(seed);
            setLoading(false);
          }
        }
      } catch (e) {
        // Bad seed is harmless — refresh() on open will recover.
        console.warn('[cv3-cart-drawer] seed hydrate failed', e);
      }
    }
    // Run during idle time (max 4s wait); if browser doesn't support
    // requestIdleCallback, defer to next tick after page load.
    if (window.requestIdleCallback) {
      requestIdleCallback(hydrateFromSeed, { timeout: 4000 });
    } else if (document.readyState === 'complete') {
      setTimeout(hydrateFromSeed, 0);
    } else {
      window.addEventListener('load', function () { setTimeout(hydrateFromSeed, 0); }, { once: true });
    }
    // Also force-hydrate if user opens the drawer before idle fires.
    var prevOpenForHydrate = open;
    open = function () { hydrateFromSeed(); prevOpenForHydrate(); };

    // Listen for theme-wide cart events — refresh whenever cart changes
    // from elsewhere (PDP ATC, PLP quick-add, SellEasy, Recharge, etc).
    // Refresh runs whether the drawer is open or closed so `lastCart`
    // stays current — when the customer next opens the drawer, they see
    // the right contents instantly without waiting for a /cart.js round-
    // trip. The fetch is cheap and render() is a no-op when items list
    // isn't visible. We debounce slightly to coalesce duplicate events
    // (the fetch interceptor + the app's own dispatch can both fire).
    // 80ms debounce — coalesces back-to-back cart events from third-party
    // apps (SellEasy, Recharge) into one refresh, but stays responsive
    // for typical interactions. Our internal flows (pickPot,
    // addBundleService) now call refresh() directly after their fetches
    // complete — this listener mostly serves external dispatches.
    var cartRefreshTimer = null;
    ['cart:updated', 'cart:added', 'ajaxProduct:added'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        if (cartRefreshTimer) clearTimeout(cartRefreshTimer);
        cartRefreshTimer = setTimeout(function () {
          cartRefreshTimer = null;
          refresh();
        }, 80);
      });
    });
    // Listen for explicit open requests.
    document.addEventListener('cart:open', open);

    // ─── Third-party cart-write interceptor ─────────────────────────
    // SellEasy, Recharge, post-purchase apps, native quick-add buttons,
    // and any other surface that calls /cart/add.js, /cart/change.js, or
    // /cart/update.js without dispatching cart:updated would leave our
    // drawer (and other listeners like cart-icon counter) out of sync.
    // We wrap window.fetch ONCE and re-broadcast a cart:updated event
    // after any successful Shopify cart endpoint POST.
    //
    // Safe to wrap: we always call the original fetch and return its
    // Promise unchanged. No body/response mutation, no header overrides.
    (function () {
      if (window.__cv3CartFetchWrapped) return;  // idempotent across re-inits
      window.__cv3CartFetchWrapped = true;
      var origFetch = window.fetch;
      if (typeof origFetch !== 'function') return;
      // Match the JSON cart endpoints. Don't match /cart.js (GET) or
      // /cart (page navigation) — only write endpoints trigger an update.
      var WRITE_RE = /\/cart\/(add|change|update)\.js(\?|$)/i;
      // ADD_RE is the subset that should ALSO auto-open the drawer.
      // change/update are qty bumps and attribute writes — opening the
      // drawer for those would yank focus on every stepper click. /cart/add.js
      // is the only one that signals "new item just landed", which is the
      // moment the customer wants visual confirmation. Catches PDP, quickview,
      // PLP quick-add, third-party apps — anything that POSTs add.js.
      
       var ADD_RE   = /\/cart\/add\.js$/i;

      window.fetch = function (input, init) {
        var url = '';
        try {
          if (typeof input === 'string') url = input;
          else if (input && input.url) url = input.url;
        } catch (_) {}
        var isCartWrite = WRITE_RE.test(url);
        var isCartAdd   = isCartWrite && ADD_RE.test(url);
        var result = origFetch.apply(this, arguments);
        if (!isCartWrite) return result;
        return result.then(function (response) {
          // Only dispatch on success — failed adds (422 sold out, etc.)
          // shouldn't trigger a refresh loop or pop an empty drawer.
          if (response && response.ok) {
            try {
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: { source: 'cv3-cart-drawer:fetch-intercept', url: url }
              }));
            } catch (_) { /* swallow */ }
            // Auto-open on add — but skip if the customer is on /cart, where
            // the drawer is suppressed by design (open() already no-ops there,
            // but cheap to short-circuit). Skip if a pot-picker / detail
            // overlay is mid-flight too: pickPot() does its own toast + the
            // drawer is already open in that case.
            if (isCartAdd && !/\/cart(\/?$|\?)/.test(location.pathname + location.search)) {
              // CRO2610: a product page may show its own "Added to cart" sheet instead (assets/cro2610.js, added).
              // It says so by cancelling this event; nobody cancelling means the drawer opens as before.
              var cv3Go = true;
              try { cv3Go = document.dispatchEvent(new CustomEvent('cv3:cart-drawer:auto-open', { cancelable: true, detail: { url: url } })); } catch (_) { cv3Go = true; }
              if (cv3Go) { try { open(); } catch (_) { /* swallow */ } }
            }
          }
          return response;
        });
      };
    })();

    // ─── Inline tooltip popovers (data-cv3-tip) ──────────────────────
    // Delegated handler at document level so it works inside the drawer,
    // on the cart page, and anywhere else cv3 widgets render the ? button.
    // Touch-friendly for mobile; doesn't depend on native title hover.
    (function () {
      var openTip = null;
      function closeTip() {
        if (!openTip) return;
        var btn = openTip.btn, pop = openTip.pop;
        btn.setAttribute('aria-expanded', 'false');
        pop.classList.remove('is-open');
        setTimeout(function () {
          if (pop && pop.parentNode && !pop.classList.contains('is-open')) {
            pop.parentNode.removeChild(pop);
          }
        }, 200);
        openTip = null;
      }
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cv3-tip]');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();
          if (openTip && openTip.btn === btn) { closeTip(); return; }
          closeTip();
          var pop = document.createElement('div');
          pop.className = 'cv3-cd__tip-pop';
          pop.textContent = btn.getAttribute('data-cv3-tip') || '';
          var wrap = btn.parentNode;
          if (!wrap) return;
          wrap.appendChild(pop);
          btn.setAttribute('aria-expanded', 'true');
          requestAnimationFrame(function () { pop.classList.add('is-open'); });
          openTip = { btn: btn, pop: pop };
          return;
        }
        if (openTip && !e.target.closest('.cv3-cd__tip-pop')) closeTip();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeTip();
      });
    })();

    // Public API
    window.cv3CartDrawer = { open: open, close: close, toggle: function () { root.classList.contains('is-open') ? close() : open(); }, refresh: refresh, add: addItems, line: changeLine, syncSet: syncSetLine, cart: function () { return lastCart; } };

    // Drop-in replacement for AMP_API.OPEN_CART so existing call sites work.
    // If real AMP_API loads later, it can replace this — we don't fight.
    if (!window.AMP_API) window.AMP_API = {};
    if (typeof window.AMP_API.OPEN_CART !== 'function') {
      window.AMP_API.OPEN_CART = open;
    }
    // Also intercept clicks on common cart triggers so they open the drawer
    // instead of navigating to /cart. data-no-cv3-cart on a link opts out.
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href="/cart"], a[href$="/cart"], [data-cv3-cart-open]');
      if (!a) return;
      if (a.hasAttribute('data-no-cv3-cart')) return;
      // Don't intercept middle-click / cmd-click / ctrl-click — let them open in new tabs.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      open();
    });
  })();
